import _ from 'lodash';

export const conditionMapping = {
  'Like New': 'Used - Like New',
  New: 'New',
  Good: 'Used - Good',
};

export const configPaddleGenius = [
  {
    Make: '11SIX24',
    Model: 'Hurache-X All Court',
    Retail: '149.99',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1QxsQ1kgFqK50d_z5cp0etb6cAyRLPNhk/view?usp=sharing',
    'Photo ID': '1QxsQ1kgFqK50d_z5cp0etb6cAyRLPNhk',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1QxsQ1kgFqK50d_z5cp0etb6cAyRLPNhk',
  },
  {
    Make: '11SIX24',
    Model: 'Hurache-X Alpha Pro Power',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1Y28hdzHh6d6BJgSYPAMySY84WOdh_7RM/view?usp=sharing',
    'Photo ID': '1Y28hdzHh6d6BJgSYPAMySY84WOdh_7RM',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Y28hdzHh6d6BJgSYPAMySY84WOdh_7RM',
  },
  {
    Make: '11SIX24',
    Model: 'Hurache-X Alpha1',
    Retail: '149.99',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1Zcwnqa4EBSC-QZh1JQLhu2D9r5R2du3H/view?usp=sharing',
    'Photo ID': '1Zcwnqa4EBSC-QZh1JQLhu2D9r5R2du3H',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Zcwnqa4EBSC-QZh1JQLhu2D9r5R2du3H',
  },
  {
    Make: '11SIX24',
    Model: 'Hurache-X Jelly Bean',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/111DTzH2-FH2Hm491CSgWpiNgB94r7_O_/view?usp=sharing',
    'Photo ID': '111DTzH2-FH2Hm491CSgWpiNgB94r7_O_',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=111DTzH2-FH2Hm491CSgWpiNgB94r7_O_',
  },
  {
    Make: '11SIX24',
    Model: 'Hurache-X Power',
    Retail: '169.99',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1Cq9i6juaFF8tu24_QQGpZe5OFltQk6Ev/view?usp=sharing',
    'Photo ID': '1Cq9i6juaFF8tu24_QQGpZe5OFltQk6Ev',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Cq9i6juaFF8tu24_QQGpZe5OFltQk6Ev',
  },
  {
    Make: '11SIX24',
    Model: 'Hurache-X Power 2',
    Retail: '209.99',
    New: '145.00',
    'Like New': '125.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/1G-SVPxV_2ODbamGdoSuKqrZHh6Z_HDKg/view?usp=drive_link',
    'Photo ID': '1G-SVPxV_2ODbamGdoSuKqrZHh6Z_HDKg',
  },
  {
    Make: '11SIX24',
    Model: 'Hurache-X Power Royal Burst',
    Retail: '179.99',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1sc8iJcD04RkFaY-mwgU3RCuQgdtQOmUZ/view?usp=sharing',
    'Photo ID': '1sc8iJcD04RkFaY-mwgU3RCuQgdtQOmUZ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1sc8iJcD04RkFaY-mwgU3RCuQgdtQOmUZ',
  },
  {
    Make: '11SIX24',
    Model: 'Monarch',
    Retail: '139.99',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/1s6azfiKwGPi_U6-7O8u9cLvQ_AWRZEVM/view?usp=sharing',
    'Photo ID': '1s6azfiKwGPi_U6-7O8u9cLvQ_AWRZEVM',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1s6azfiKwGPi_U6-7O8u9cLvQ_AWRZEVM',
  },
  {
    Make: '11SIX24',
    Model: 'Pegasus All Court',
    Retail: '129.99',
    New: '90.00',
    'Like New': '75.00',
    Good: '60.00',
    'Photo URL': 'https://drive.google.com/file/d/1gk2NNkSbk_K_SHrg_j6DQEF-M9XQOMTV/view?usp=sharing',
    'Photo ID': '1gk2NNkSbk_K_SHrg_j6DQEF-M9XQOMTV',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1gk2NNkSbk_K_SHrg_j6DQEF-M9XQOMTV',
  },
  {
    Make: '11SIX24',
    Model: 'Pegasus Alpha Pro Power',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1ixdPmAagMb2pfJ12LeCABX1Qi4EAgrrE/view?usp=sharing',
    'Photo ID': '1ixdPmAagMb2pfJ12LeCABX1Qi4EAgrrE',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ixdPmAagMb2pfJ12LeCABX1Qi4EAgrrE',
  },
  {
    Make: '11SIX24',
    Model: 'Pegasus Jelly Bean',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1Zw2Ic58jjnRFm0Cc4gBFQ4FTBb95NAV6/view?usp=sharing',
    'Photo ID': '1Zw2Ic58jjnRFm0Cc4gBFQ4FTBb95NAV6',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Zw2Ic58jjnRFm0Cc4gBFQ4FTBb95NAV6',
  },
  {
    Make: '11SIX24',
    Model: 'Pegasus Power',
    Retail: '169.99',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1dhp-Z7gJ02czMvXAcjdPq4E_q6RUci0K/view?usp=sharing',
    'Photo ID': '1dhp-Z7gJ02czMvXAcjdPq4E_q6RUci0K',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1dhp-Z7gJ02czMvXAcjdPq4E_q6RUci0K',
  },
  {
    Make: '11SIX24',
    Model: 'Pegasus Power 2',
    Retail: '209.99',
    New: '145.00',
    'Like New': '125.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/1PTsXzDlw8Z8rR8p8HVc86oZTFXIU3Svk/view?usp=drive_link',
    'Photo ID': '1PTsXzDlw8Z8rR8p8HVc86oZTFXIU3Svk',
  },
  {
    Make: '11SIX24',
    Model: 'Pegasus Power Royal Burst',
    Retail: '179.99',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1USKTqETdURA93oc7HN4QYt9iQm86mT99/view?usp=sharing',
    'Photo ID': '1USKTqETdURA93oc7HN4QYt9iQm86mT99',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1USKTqETdURA93oc7HN4QYt9iQm86mT99',
  },
  {
    Make: '11SIX24',
    Model: 'Vapor All Court',
    Retail: '129.99',
    New: '90.00',
    'Like New': '75.00',
    Good: '60.00',
    'Photo URL': 'https://drive.google.com/file/d/1yamO4a--4Gs9W8DBzfvf1XhHQ_j3BoP_/view?usp=sharing',
    'Photo ID': '1yamO4a--4Gs9W8DBzfvf1XhHQ_j3BoP_',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1yamO4a--4Gs9W8DBzfvf1XhHQ_j3BoP_',
  },
  {
    Make: '11SIX24',
    Model: 'Vapor All Court Royal Burst',
    Retail: '159.99',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1UfTFMY_rbj71x87xp2mhL0Q7umEFdcvv/view?usp=sharing',
    'Photo ID': '1UfTFMY_rbj71x87xp2mhL0Q7umEFdcvv',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1UfTFMY_rbj71x87xp2mhL0Q7umEFdcvv',
  },
  {
    Make: '11SIX24',
    Model: 'Vapor Alpha Pro Power',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1B2Ac4nOTfJwL0bWkybmezSHMcosyEv3A/view?usp=sharing',
    'Photo ID': '1B2Ac4nOTfJwL0bWkybmezSHMcosyEv3A',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1B2Ac4nOTfJwL0bWkybmezSHMcosyEv3A',
  },
  {
    Make: '11SIX24',
    Model: 'Vapor Jelly Bean',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1B12EEBrtjC1xEfwYZSDR3nr8gjlQqPGo/view?usp=sharing',
    'Photo ID': '1B12EEBrtjC1xEfwYZSDR3nr8gjlQqPGo',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1B12EEBrtjC1xEfwYZSDR3nr8gjlQqPGo',
  },
  {
    Make: '11SIX24',
    Model: 'Vapor Power',
    Retail: '169.99',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1aWyj6osXcoCFhIgJEhwPTmXp3OQwM0PC/view?usp=sharing',
    'Photo ID': '1aWyj6osXcoCFhIgJEhwPTmXp3OQwM0PC',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1aWyj6osXcoCFhIgJEhwPTmXp3OQwM0PC',
  },
  {
    Make: '11SIX24',
    Model: 'Vapor Power 2',
    Retail: '209.99',
    New: '145.00',
    'Like New': '125.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/1z3GN-XVXsXAKqgOv3KgJych9TkHFd81c/view?usp=drive_link',
    'Photo ID': '1z3GN-XVXsXAKqgOv3KgJych9TkHFd81c',
  },
  {
    Make: '11SIX24',
    Model: 'Vapor Power Royal Burst',
    Retail: '179.99',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1vSu2xSKqADEuTSlbEssPygvj1KLF0TUz/view?usp=sharing',
    'Photo ID': '1vSu2xSKqADEuTSlbEssPygvj1KLF0TUz',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1vSu2xSKqADEuTSlbEssPygvj1KLF0TUz',
  },
  {
    Make: 'Adidas',
    Model: 'AdiPower Attk 2',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1yphAyWqotsPDECHGwKYHpu75uIZ_mMua/view?usp=sharing',
    'Photo ID': '1yphAyWqotsPDECHGwKYHpu75uIZ_mMua',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1yphAyWqotsPDECHGwKYHpu75uIZ_mMua',
  },
  {
    Make: 'Adidas',
    Model: 'AdiPower CTRL 2',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/15n4GeYKl1bSoVK5SbndLSYetGBHkSIHN/view?usp=sharing',
    'Photo ID': '15n4GeYKl1bSoVK5SbndLSYetGBHkSIHN',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=15n4GeYKl1bSoVK5SbndLSYetGBHkSIHN',
  },
  {
    Make: 'Adidas',
    Model: 'Drive 2',
    Retail: '69.99',
    New: '45.00',
    'Like New': '40.00',
    Good: '30.00',
    'Photo URL': 'https://drive.google.com/file/d/15hlnd-fnC3qZhn2aaV6VtTWv2yMXS8Ax/view?usp=sharing',
    'Photo ID': '15hlnd-fnC3qZhn2aaV6VtTWv2yMXS8Ax',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=15hlnd-fnC3qZhn2aaV6VtTWv2yMXS8Ax',
  },
  {
    Make: 'Adidas',
    Model: 'Match Light 2',
    Retail: '69.99',
    New: '45.00',
    'Like New': '40.00',
    Good: '30.00',
    'Photo URL': 'https://drive.google.com/file/d/1RUZin1NwMod7NOLZiMGlUQmJFCJ1jJjE/view?usp=sharing',
    'Photo ID': '1RUZin1NwMod7NOLZiMGlUQmJFCJ1jJjE',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1RUZin1NwMod7NOLZiMGlUQmJFCJ1jJjE',
  },
  {
    Make: 'Adidas',
    Model: 'Metalbone',
    Retail: '259.99',
    New: '180.00',
    'Like New': '155.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1CuQezyTkUDBdfgah300FIouFKXWOQCSh/view?usp=sharing',
    'Photo ID': '1CuQezyTkUDBdfgah300FIouFKXWOQCSh',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1CuQezyTkUDBdfgah300FIouFKXWOQCSh',
  },
  {
    Make: 'Babolat',
    Model: 'BALLR Plus',
    Retail: '219.00',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1_Vz02zFNZFU-mnnUj-8WRhSvXyNaVU_Z/view?usp=sharing',
    'Photo ID': '1_Vz02zFNZFU-mnnUj-8WRhSvXyNaVU_Z',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1_Vz02zFNZFU-mnnUj-8WRhSvXyNaVU_Z',
  },
  {
    Make: 'Babolat',
    Model: 'MNSTR',
    Retail: '169.00',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1ardLLhM7NPgwcqT7ci3yqOT3L_OBKiLK/view?usp=sharing',
    'Photo ID': '1ardLLhM7NPgwcqT7ci3yqOT3L_OBKiLK',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ardLLhM7NPgwcqT7ci3yqOT3L_OBKiLK',
  },
  {
    Make: 'Babolat',
    Model: 'MNSTR Plus',
    Retail: '169.00',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1xaBoy-JkuevvaMRV1lecsOpT6Yehgjkn/view?usp=sharing',
    'Photo ID': '1xaBoy-JkuevvaMRV1lecsOpT6Yehgjkn',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1xaBoy-JkuevvaMRV1lecsOpT6Yehgjkn',
  },
  {
    Make: 'Babolat',
    Model: 'RBEL',
    Retail: '169.00',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1mWk2Et5ZdlfKUMWmu7qiXdmmCSrUpfIp/view?usp=sharing',
    'Photo ID': '1mWk2Et5ZdlfKUMWmu7qiXdmmCSrUpfIp',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1mWk2Et5ZdlfKUMWmu7qiXdmmCSrUpfIp',
  },
  {
    Make: 'Babolat',
    Model: 'STRKR Plus',
    Retail: '219.00',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1ynb8gg_E-UP2dkizMRIv9z-IDQlBVx8r/view?usp=sharing',
    'Photo ID': '1ynb8gg_E-UP2dkizMRIv9z-IDQlBVx8r',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ynb8gg_E-UP2dkizMRIv9z-IDQlBVx8r',
  },
  {
    Make: 'Babolat',
    Model: 'WZRD',
    Retail: '219.00',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/17uCXHznY-RLyDLgTwKJTV7b3skO1WA1H/view?usp=sharing',
    'Photo ID': '17uCXHznY-RLyDLgTwKJTV7b3skO1WA1H',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=17uCXHznY-RLyDLgTwKJTV7b3skO1WA1H',
  },
  {
    Make: 'Babolat',
    Model: 'XPLR',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/18-Au7m5tQDIC2D8Fc_WhyWUV1p8nFRNV/view?usp=sharing',
    'Photo ID': '18-Au7m5tQDIC2D8Fc_WhyWUV1p8nFRNV',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=18-Au7m5tQDIC2D8Fc_WhyWUV1p8nFRNV',
  },
  {
    Make: 'BALLR',
    Model: 'Heat',
    Retail: '159.99',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1XDLNCl_kf_Oxe_K13gMGGIwEvbajtGYr/view?usp=sharing',
    'Photo ID': '1XDLNCl_kf_Oxe_K13gMGGIwEvbajtGYr',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1XDLNCl_kf_Oxe_K13gMGGIwEvbajtGYr',
  },
  {
    Make: 'BALLR',
    Model: 'Pro',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1Nn5TCmmzGduOVXdfArvlof0tX5rlTI7r/view?usp=sharing',
    'Photo ID': '1Nn5TCmmzGduOVXdfArvlof0tX5rlTI7r',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Nn5TCmmzGduOVXdfArvlof0tX5rlTI7r',
  },
  {
    Make: 'Bison',
    Model: 'The Bison',
    Retail: '49.99',
    New: '30.00',
    'Like New': '25.00',
    Good: '20.00',
    'Photo URL': 'https://drive.google.com/file/d/1pbftpqtpA1zTsYccOHNg4Pdeki7iioSN/view?usp=sharing',
    'Photo ID': '1pbftpqtpA1zTsYccOHNg4Pdeki7iioSN',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1pbftpqtpA1zTsYccOHNg4Pdeki7iioSN',
  },
  {
    Make: 'Bison',
    Model: 'The Mountain',
    Retail: '59.99',
    New: '40.00',
    'Like New': '35.00',
    Good: '25.00',
    'Photo URL': 'https://drive.google.com/file/d/1NudxeHDjZr3PyjC0M3qPd-_dRENllRdf/view?usp=sharing',
    'Photo ID': '1NudxeHDjZr3PyjC0M3qPd-_dRENllRdf',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1NudxeHDjZr3PyjC0M3qPd-_dRENllRdf',
  },
  {
    Make: 'Bison',
    Model: 'The Rampage',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1-1479Ff9_aeEMukMOgBLsJXz86yDsAgu/view?usp=sharing',
    'Photo ID': '1-1479Ff9_aeEMukMOgBLsJXz86yDsAgu',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1-1479Ff9_aeEMukMOgBLsJXz86yDsAgu',
  },
  {
    Make: 'Bison',
    Model: 'The Summit',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1Wmy37dWbBzInQ3EVynhkso1HqYd_FVBB/view?usp=sharing',
    'Photo ID': '1Wmy37dWbBzInQ3EVynhkso1HqYd_FVBB',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Wmy37dWbBzInQ3EVynhkso1HqYd_FVBB',
  },
  {
    Make: 'Body Helix',
    Model: 'FLiK F1',
    Retail: '190.00',
    New: '130.00',
    'Like New': '110.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/11w7xXphQQ1qKjnydloLYXknWg3BXoamU/view?usp=sharing',
    'Photo ID': '11w7xXphQQ1qKjnydloLYXknWg3BXoamU',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=11w7xXphQQ1qKjnydloLYXknWg3BXoamU',
  },
  {
    Make: 'Body Helix',
    Model: 'FLiK Gen 3',
    Retail: '180.00',
    New: '125.00',
    'Like New': '105.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/12nvAyeqBPBIZXPlkpXmJ2HIv0F-5uaTw/view?usp=sharing',
    'Photo ID': '12nvAyeqBPBIZXPlkpXmJ2HIv0F-5uaTw',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=12nvAyeqBPBIZXPlkpXmJ2HIv0F-5uaTw',
  },
  {
    Make: 'Body Helix',
    Model: 'FLiK Plus',
    Retail: '80.00',
    New: '55.00',
    'Like New': '45.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1QrLXfDT1ldonW5oAyXR3yBwZsnRBVdy3/view?usp=sharing',
    'Photo ID': '1QrLXfDT1ldonW5oAyXR3yBwZsnRBVdy3',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1QrLXfDT1ldonW5oAyXR3yBwZsnRBVdy3',
  },
  {
    Make: 'Body Helix',
    Model: 'X1 Carbon Fiber',
    Retail: '160.00',
    New: '110.00',
    'Like New': '95.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1K7rljQaRx6OUgYwb-J4I8-pbPysFNyZ7/view?usp=sharing',
    'Photo ID': '1K7rljQaRx6OUgYwb-J4I8-pbPysFNyZ7',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1K7rljQaRx6OUgYwb-J4I8-pbPysFNyZ7',
  },
  {
    Make: 'Body Helix',
    Model: 'X1 Kevlar',
    Retail: '140.00',
    New: '95.00',
    'Like New': '80.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1FJfG_A5CGkAsVfVnVhKekJollNyrSyQj/view?usp=sharing',
    'Photo ID': '1FJfG_A5CGkAsVfVnVhKekJollNyrSyQj',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1FJfG_A5CGkAsVfVnVhKekJollNyrSyQj',
  },
  {
    Make: 'Body Helix',
    Model: 'X2 Pro Carbon',
    Retail: '160.00',
    New: '110.00',
    'Like New': '95.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/10WPNHu92RAKLl2WNmygKpygQMIRtlLqu/view?usp=sharing',
    'Photo ID': '10WPNHu92RAKLl2WNmygKpygQMIRtlLqu',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=10WPNHu92RAKLl2WNmygKpygQMIRtlLqu',
  },
  {
    Make: 'Body Helix',
    Model: 'X3 Lite',
    Retail: '140.00',
    New: '95.00',
    'Like New': '80.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1QLx-Uei_PtzNP0uSdIXBhVIJ66RcAJ1f/view?usp=sharing',
    'Photo ID': '1QLx-Uei_PtzNP0uSdIXBhVIJ66RcAJ1f',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1QLx-Uei_PtzNP0uSdIXBhVIJ66RcAJ1f',
  },
  {
    Make: 'Body Helix',
    Model: 'X3 Pro',
    Retail: '160.00',
    New: '110.00',
    'Like New': '95.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1fEdf3eapnwf-L-etlx73ikEnUyEmG9OM/view?usp=sharing',
    'Photo ID': '1fEdf3eapnwf-L-etlx73ikEnUyEmG9OM',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1fEdf3eapnwf-L-etlx73ikEnUyEmG9OM',
  },
  {
    Make: 'Body Helix',
    Model: 'X4 Carbon Fiber',
    Retail: '140.00',
    New: '95.00',
    'Like New': '80.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1TYeBaPjRt3Kj7sNm07kSwBgSTBKjRFoE/view?usp=sharing',
    'Photo ID': '1TYeBaPjRt3Kj7sNm07kSwBgSTBKjRFoE',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1TYeBaPjRt3Kj7sNm07kSwBgSTBKjRFoE',
  },
  {
    Make: 'Body Helix',
    Model: 'X4 Kevlar',
    Retail: '140.00',
    New: '95.00',
    'Like New': '80.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1AGKqAb0GkDogiBacunP0v0s11FPZpVAL/view?usp=sharing',
    'Photo ID': '1AGKqAb0GkDogiBacunP0v0s11FPZpVAL',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1AGKqAb0GkDogiBacunP0v0s11FPZpVAL',
  },
  {
    Make: 'Body Helix',
    Model: 'X5',
    Retail: '140.00',
    New: '95.00',
    'Like New': '80.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1BziKkH9khdxAXLYU3XNbW6SpiB2Q4xlc/view?usp=sharing',
    'Photo ID': '1BziKkH9khdxAXLYU3XNbW6SpiB2Q4xlc',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1BziKkH9khdxAXLYU3XNbW6SpiB2Q4xlc',
  },
  {
    Make: 'Bread & Butter',
    Model: 'Drip',
    Retail: '80.00',
    New: '55.00',
    'Like New': '45.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1CoBbZnJsZw8iJFLgyesnKIC7HPDytFpg/view?usp=sharing',
    'Photo ID': '1CoBbZnJsZw8iJFLgyesnKIC7HPDytFpg',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1CoBbZnJsZw8iJFLgyesnKIC7HPDytFpg',
  },
  {
    Make: 'Bread & Butter',
    Model: 'Fat Boy',
    Retail: '189.00',
    New: '130.00',
    'Like New': '110.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1eyQcXBR8CLQUzJPYFsX91vq3jDOylKJy/view?usp=sharing',
    'Photo ID': '1eyQcXBR8CLQUzJPYFsX91vq3jDOylKJy',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1eyQcXBR8CLQUzJPYFsX91vq3jDOylKJy',
  },
  {
    Make: 'Bread & Butter',
    Model: 'Filth',
    Retail: '165.00',
    New: '115.00',
    'Like New': '95.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1vBQV4i0s5tlO_1X-ywlPlJdgC9tUjI49/view?usp=sharing',
    'Photo ID': '1vBQV4i0s5tlO_1X-ywlPlJdgC9tUjI49',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1vBQV4i0s5tlO_1X-ywlPlJdgC9tUjI49',
  },
  {
    Make: 'Bread & Butter',
    Model: 'Invader',
    Retail: '189.99',
    New: '130.00',
    'Like New': '110.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1iRmhORlKjN_fUV23xsTedxJIhD0EpI2P/view?usp=sharing',
    'Photo ID': '1iRmhORlKjN_fUV23xsTedxJIhD0EpI2P',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1iRmhORlKjN_fUV23xsTedxJIhD0EpI2P',
  },
  {
    Make: 'Bread & Butter',
    Model: 'Loco',
    Retail: '165.00',
    New: '115.00',
    'Like New': '95.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1yiUH6SjP36eE0obcDYrYgXhVYZDzZKwx/view?usp=sharing',
    'Photo ID': '1yiUH6SjP36eE0obcDYrYgXhVYZDzZKwx',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1yiUH6SjP36eE0obcDYrYgXhVYZDzZKwx',
  },
  {
    Make: 'Bread & Butter',
    Model: 'Loco Foam',
    Retail: '199.00',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1gIuTKRiE0F97qIEzIfCMcr3JDLTwLSuy/view?usp=sharing',
    'Photo ID': '1gIuTKRiE0F97qIEzIfCMcr3JDLTwLSuy',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1gIuTKRiE0F97qIEzIfCMcr3JDLTwLSuy',
  },
  {
    Make: 'Bread & Butter',
    Model: 'Shogun',
    Retail: '189.99',
    New: '130.00',
    'Like New': '110.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1m2FSi6NLScs4aMziq1J1R3ys_jfl4NdK/view?usp=sharing',
    'Photo ID': '1m2FSi6NLScs4aMziq1J1R3ys_jfl4NdK',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1m2FSi6NLScs4aMziq1J1R3ys_jfl4NdK',
  },
  {
    Make: 'Bread & Butter',
    Model: 'Spear',
    Retail: '80.00',
    New: '55.00',
    'Like New': '45.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1ZJ4hYvWId5-dzZDpDdXqYFhx75z-CKRJ/view?usp=sharing',
    'Photo ID': '1ZJ4hYvWId5-dzZDpDdXqYFhx75z-CKRJ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ZJ4hYvWId5-dzZDpDdXqYFhx75z-CKRJ',
  },
  {
    Make: 'Cheetah',
    Model: 'Predion 5',
    Retail: '100.00',
    New: '70.00',
    'Like New': '60.00',
    Good: '50.00',
    'Photo URL': 'https://drive.google.com/file/d/1frdJHRx0ADbbqqY11eQIoFSEzqNStn_Z/view?usp=sharing',
    'Photo ID': '1frdJHRx0ADbbqqY11eQIoFSEzqNStn_Z',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1frdJHRx0ADbbqqY11eQIoFSEzqNStn_Z',
  },
  {
    Make: 'Cheetah',
    Model: 'Predion E16',
    Retail: '100.00',
    New: '70.00',
    'Like New': '60.00',
    Good: '50.00',
    'Photo URL': 'https://drive.google.com/file/d/1z3wN9k-y2S1ntf4IrT52-i5CLvnJUrd3/view?usp=sharing',
    'Photo ID': '1z3wN9k-y2S1ntf4IrT52-i5CLvnJUrd3',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1z3wN9k-y2S1ntf4IrT52-i5CLvnJUrd3',
  },
  {
    Make: 'Cheetah',
    Model: 'Predion E20',
    Retail: '100.00',
    New: '70.00',
    'Like New': '60.00',
    Good: '50.00',
    'Photo URL': 'https://drive.google.com/file/d/1tb8rAtxNIoddOKO1peVqWI3Zrfq3Qm_L/view?usp=sharing',
    'Photo ID': '1tb8rAtxNIoddOKO1peVqWI3Zrfq3Qm_L',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1tb8rAtxNIoddOKO1peVqWI3Zrfq3Qm_L',
  },
  {
    Make: 'Chorus',
    Model: 'Coda',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1YiPehZh3TKQMFxSAW8Sxe_mSHrufQVsp/view?usp=drive_link',
    'Photo ID': '1YiPehZh3TKQMFxSAW8Sxe_mSHrufQVsp',
  },
  {
    Make: 'Chorus',
    Model: 'Daylight',
    Retail: '79.99',
    New: '55.00',
    'Like New': '45.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/1wVGls9I5Yc5yMO2Wswmm1xVDql24gv5v/view?usp=sharing',
    'Photo ID': '1wVGls9I5Yc5yMO2Wswmm1xVDql24gv5v',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1wVGls9I5Yc5yMO2Wswmm1xVDql24gv5v',
  },
  {
    Make: 'Chorus',
    Model: 'Echo',
    Retail: '109.00',
    New: '75.00',
    'Like New': '65.00',
    Good: '50.00',
    'Photo URL': 'https://drive.google.com/file/d/1XxSGGkSqRNsTBcZA6SbLEqA89FgTMDU-/view?usp=sharing',
    'Photo ID': '1XxSGGkSqRNsTBcZA6SbLEqA89FgTMDU-',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1XxSGGkSqRNsTBcZA6SbLEqA89FgTMDU-',
  },
  {
    Make: 'Chorus',
    Model: 'Fire EX',
    Retail: '169.99',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1G7ORgvhchI43GoppJqHBvoyn6LohXGGT/view?usp=sharing',
    'Photo ID': '1G7ORgvhchI43GoppJqHBvoyn6LohXGGT',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1G7ORgvhchI43GoppJqHBvoyn6LohXGGT',
  },
  {
    Make: 'Chorus',
    Model: 'Fire HX',
    Retail: '169.99',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1IyAgHHFTaCpE-dRPrNtwaFEhyXPMMt1o/view?usp=sharing',
    'Photo ID': '1IyAgHHFTaCpE-dRPrNtwaFEhyXPMMt1o',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1IyAgHHFTaCpE-dRPrNtwaFEhyXPMMt1o',
  },
  {
    Make: 'Chorus',
    Model: 'Fire SX',
    Retail: '169.99',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1gKH4uPCcg2uMwp9B3nfe30bGdRLUpN41/view?usp=sharing',
    'Photo ID': '1gKH4uPCcg2uMwp9B3nfe30bGdRLUpN41',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1gKH4uPCcg2uMwp9B3nfe30bGdRLUpN41',
  },
  {
    Make: 'Chorus',
    Model: 'Shapeshifter',
    Retail: '189.99',
    New: '130.00',
    'Like New': '110.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/17O3S3rW0-GZgS5MEUBFmWZFmueeR6Kji/view?usp=sharing',
    'Photo ID': '17O3S3rW0-GZgS5MEUBFmWZFmueeR6Kji',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=17O3S3rW0-GZgS5MEUBFmWZFmueeR6Kji',
  },
  {
    Make: 'Chorus',
    Model: 'Shapeshifter EX',
    Retail: '174.99',
    New: '120.00',
    'Like New': '100.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1PMdz2-gQbJHaasi4lRVEVdy24Me_2ANz/view?usp=sharing',
    'Photo ID': '1PMdz2-gQbJHaasi4lRVEVdy24Me_2ANz',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1PMdz2-gQbJHaasi4lRVEVdy24Me_2ANz',
  },
  {
    Make: 'Chorus',
    Model: 'Shapeshifter HX',
    Retail: '174.99',
    New: '120.00',
    'Like New': '100.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1rFsTHliTDnDKoOyzECe8ZCxFXjhADzr9/view?usp=sharing',
    'Photo ID': '1rFsTHliTDnDKoOyzECe8ZCxFXjhADzr9',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1rFsTHliTDnDKoOyzECe8ZCxFXjhADzr9',
  },
  {
    Make: 'Chorus',
    Model: 'Shapeshifter SX',
    Retail: '174.99',
    New: '120.00',
    'Like New': '100.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/19LKKUfqEbx_mR2ndTCq6RMMfAse96RfO/view?usp=sharing',
    'Photo ID': '19LKKUfqEbx_mR2ndTCq6RMMfAse96RfO',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=19LKKUfqEbx_mR2ndTCq6RMMfAse96RfO',
  },
  {
    Make: 'Chorus',
    Model: 'Supercourt',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1a8kRycoOm7ueXuKRHQNgpc3D0Zz1dtga/view?usp=sharing',
    'Photo ID': '1a8kRycoOm7ueXuKRHQNgpc3D0Zz1dtga',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1a8kRycoOm7ueXuKRHQNgpc3D0Zz1dtga',
  },
  {
    Make: 'Chorus',
    Model: 'Supercourt EX',
    Retail: '149.00',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1TTUwwem6RN2gJLUe6F-axPuvdEOolq72/view?usp=sharing',
    'Photo ID': '1TTUwwem6RN2gJLUe6F-axPuvdEOolq72',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1TTUwwem6RN2gJLUe6F-axPuvdEOolq72',
  },
  {
    Make: 'Chorus',
    Model: 'Supercourt HX',
    Retail: '149.00',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/19f5AWKbn_O6gRA2ICHCde6hU2tusqoA-/view?usp=sharing',
    'Photo ID': '19f5AWKbn_O6gRA2ICHCde6hU2tusqoA-',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=19f5AWKbn_O6gRA2ICHCde6hU2tusqoA-',
  },
  {
    Make: 'Chorus',
    Model: 'Supercourt SX',
    Retail: '149.00',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1dX_AVIme_jkuIBJ4a7u6RMputbYmymnf/view?usp=sharing',
    'Photo ID': '1dX_AVIme_jkuIBJ4a7u6RMputbYmymnf',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1dX_AVIme_jkuIBJ4a7u6RMputbYmymnf',
  },
  {
    Make: 'Cliff Pickleball',
    Model: 'Vauraus',
    Retail: '179.99',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1LO94qQGmAPRbNfQbsiFNKFOMJVWBvOKa/view?usp=sharing',
    'Photo ID': '1LO94qQGmAPRbNfQbsiFNKFOMJVWBvOKa',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1LO94qQGmAPRbNfQbsiFNKFOMJVWBvOKa',
  },
  {
    Make: 'CRBN',
    Model: 'CRBN 1',
    Retail: '179.99',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1EQqKcUfhy2O89lySGkd4qjpJsWQrPWmg/view?usp=sharing',
    'Photo ID': '1EQqKcUfhy2O89lySGkd4qjpJsWQrPWmg',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1EQqKcUfhy2O89lySGkd4qjpJsWQrPWmg',
  },
  {
    Make: 'CRBN',
    Model: 'CRBN 1 TF Genesis',
    Retail: '279.99',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1pSViODABDzvoDPmA3GKnhJ3NcTucJ019/view?usp=sharing',
    'Photo ID': '1pSViODABDzvoDPmA3GKnhJ3NcTucJ019',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1pSViODABDzvoDPmA3GKnhJ3NcTucJ019',
  },
  {
    Make: 'CRBN',
    Model: 'CRBN 1 TF Waves',
    Retail: '279.99',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1C4V_bDy6Hl9tzEytoItNle33oqU0-rHZ/view?usp=sharing',
    'Photo ID': '1C4V_bDy6Hl9tzEytoItNle33oqU0-rHZ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1C4V_bDy6Hl9tzEytoItNle33oqU0-rHZ',
  },
  {
    Make: 'CRBN',
    Model: 'CRBN 1X',
    Retail: '229.99',
    New: '160.00',
    'Like New': '135.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1GOeTEf3hcfValCTgyNsUAnzO0NFXVygT/view?usp=sharing',
    'Photo ID': '1GOeTEf3hcfValCTgyNsUAnzO0NFXVygT',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1GOeTEf3hcfValCTgyNsUAnzO0NFXVygT',
  },
  {
    Make: 'CRBN',
    Model: 'CRBN 2',
    Retail: '179.99',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/17oQ-DQzQKNQFVsCxzmvEk_djDIiZefG3/view?usp=sharing',
    'Photo ID': '17oQ-DQzQKNQFVsCxzmvEk_djDIiZefG3',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=17oQ-DQzQKNQFVsCxzmvEk_djDIiZefG3',
  },
  {
    Make: 'CRBN',
    Model: 'CRBN 2 TF Barrage',
    Retail: '279.99',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1UcmDqPJXtALg9ZGEY1N18ytzpJf-2ugZ/view?usp=drive_link',
    'Photo ID': '1UcmDqPJXtALg9ZGEY1N18ytzpJf-2ugZ',
    GTIN: '850075159734',
  },
  {
    Make: 'CRBN',
    Model: 'CRBN 2 TF Genesis',
    Retail: '279.99',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1LSSP44-gzC39E_TTy6sGkUJ2W4Dj9Yvn/view?usp=sharing',
    'Photo ID': '1LSSP44-gzC39E_TTy6sGkUJ2W4Dj9Yvn',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1LSSP44-gzC39E_TTy6sGkUJ2W4Dj9Yvn',
  },
  {
    Make: 'CRBN',
    Model: 'CRBN 2 TF Waves',
    Retail: '279.99',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1-0hwPfVRMnH-6sWv8f_tiL0LW5xbbTpu/view?usp=sharing',
    'Photo ID': '1-0hwPfVRMnH-6sWv8f_tiL0LW5xbbTpu',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1-0hwPfVRMnH-6sWv8f_tiL0LW5xbbTpu',
  },
  {
    Make: 'CRBN',
    Model: 'CRBN 2X',
    Retail: '229.99',
    New: '180.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1LkZRiVJUzZ07M1yYcgYG-OWaP8jjF_8A/view?usp=sharing',
    'Photo ID': '1LkZRiVJUzZ07M1yYcgYG-OWaP8jjF_8A',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1LkZRiVJUzZ07M1yYcgYG-OWaP8jjF_8A',
  },
  {
    Make: 'CRBN',
    Model: 'CRBN 3 TF Genesis',
    Retail: '279.99',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1Fzq7qukcSqQJKxeWD2Ehs4cm4kC5vXi5/view?usp=sharing',
    'Photo ID': '1Fzq7qukcSqQJKxeWD2Ehs4cm4kC5vXi5',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Fzq7qukcSqQJKxeWD2Ehs4cm4kC5vXi5',
  },
  {
    Make: 'CRBN',
    Model: 'CRBN 3 TF Waves',
    Retail: '279.99',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1ET6kNjfxgOB7C5Ftu2ueQmoONhqyjOx3/view?usp=sharing',
    'Photo ID': '1ET6kNjfxgOB7C5Ftu2ueQmoONhqyjOx3',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ET6kNjfxgOB7C5Ftu2ueQmoONhqyjOx3',
  },
  {
    Make: 'CRBN',
    Model: 'CRBN 3X',
    Retail: '229.99',
    New: '160.00',
    'Like New': '135.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1zsbJqvSoxSWkiD-bGFxKX0VAyqSAlG42/view?usp=sharing',
    'Photo ID': '1zsbJqvSoxSWkiD-bGFxKX0VAyqSAlG42',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1zsbJqvSoxSWkiD-bGFxKX0VAyqSAlG42',
  },
  {
    Make: 'CRBN',
    Model: 'CRBN 4 TF Barrage',
    Retail: '279.99',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1UIPZg5Kp1UJZp4mN_vivbCrEJO6eDmQk/view?usp=drive_link',
    'Photo ID': '1UIPZg5Kp1UJZp4mN_vivbCrEJO6eDmQk',
    GTIN: '850075159758',
  },
  {
    Make: 'CRBN',
    Model: 'CRBN 4 TF Genesis',
    Retail: '279.99',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1MHMvrBBG3S11KJCkX-a-JSy4uth2vOH6/view?usp=sharing',
    'Photo ID': '1MHMvrBBG3S11KJCkX-a-JSy4uth2vOH6',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1MHMvrBBG3S11KJCkX-a-JSy4uth2vOH6',
  },
  {
    Make: 'CRBN',
    Model: 'CRBN 4 TF Waves',
    Retail: '279.99',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1ddECAB5q-izPijMf-TgtVFEmn18GadP8/view?usp=sharing',
    'Photo ID': '1ddECAB5q-izPijMf-TgtVFEmn18GadP8',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ddECAB5q-izPijMf-TgtVFEmn18GadP8',
  },
  {
    Make: 'Crush',
    Model: 'Force 5G',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1bcnk4Zx8lv741NA6gSuAnN5pTpzFmEVm/view?usp=sharing',
    'Photo ID': '1bcnk4Zx8lv741NA6gSuAnN5pTpzFmEVm',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1bcnk4Zx8lv741NA6gSuAnN5pTpzFmEVm',
  },
  {
    Make: 'Crush',
    Model: 'FRDM 1',
    Retail: '79.00',
    New: '55.00',
    'Like New': '45.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/1dGVVwiqkwUB0S3jV5BeRLDvTNDKOFTKT/view?usp=sharing',
    'Photo ID': '1dGVVwiqkwUB0S3jV5BeRLDvTNDKOFTKT',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1dGVVwiqkwUB0S3jV5BeRLDvTNDKOFTKT',
  },
  {
    Make: 'Crush',
    Model: 'FRDM 2',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1CSd8OIIqoSvXXAyziQzfguAtjDWEBFSU/view?usp=sharing',
    'Photo ID': '1CSd8OIIqoSvXXAyziQzfguAtjDWEBFSU',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1CSd8OIIqoSvXXAyziQzfguAtjDWEBFSU',
  },
  {
    Make: 'Crush',
    Model: 'FRDM 3',
    Retail: '119.00',
    New: '80.00',
    'Like New': '70.00',
    Good: '55.00',
    'Photo URL': 'https://drive.google.com/file/d/1qIQB_GfZEwsMlt2cAXr_lRVIQX0MbFnW/view?usp=sharing',
    'Photo ID': '1qIQB_GfZEwsMlt2cAXr_lRVIQX0MbFnW',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1qIQB_GfZEwsMlt2cAXr_lRVIQX0MbFnW',
  },
  {
    Make: 'Crush',
    Model: 'Freestyle',
    Retail: '189.95',
    New: '130.00',
    'Like New': '110.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1mc5b7vRSL_7u_mBbTa72UdDD7KgbbQMH/view?usp=sharing',
    'Photo ID': '1mc5b7vRSL_7u_mBbTa72UdDD7KgbbQMH',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1mc5b7vRSL_7u_mBbTa72UdDD7KgbbQMH',
  },
  {
    Make: 'Crush',
    Model: 'RQT',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/13-Sf3bWLAGbeck9EDBduVZZBeEtqMkNZ/view?usp=sharing',
    'Photo ID': '13-Sf3bWLAGbeck9EDBduVZZBeEtqMkNZ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=13-Sf3bWLAGbeck9EDBduVZZBeEtqMkNZ',
  },
  {
    Make: 'Diadem',
    Model: 'A52',
    Retail: '99.95',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1eGRVcB7-fOSzlWviE2YMG_UOKJNAyK5P/view?usp=sharing',
    'Photo ID': '1eGRVcB7-fOSzlWviE2YMG_UOKJNAyK5P',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1eGRVcB7-fOSzlWviE2YMG_UOKJNAyK5P',
  },
  {
    Make: 'Diadem',
    Model: 'Edge 18K',
    Retail: '229.95',
    New: '160.00',
    'Like New': '135.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1pkgdi1Eo00ab9gPvKP4czZQP9FfaDy9v/view?usp=sharing',
    'Photo ID': '1pkgdi1Eo00ab9gPvKP4czZQP9FfaDy9v',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1pkgdi1Eo00ab9gPvKP4czZQP9FfaDy9v',
  },
  {
    Make: 'Diadem',
    Model: 'Edge 18K Power',
    Retail: '239.95',
    New: '165.00',
    'Like New': '140.00',
    Good: '115.00',
    'Photo URL': 'https://drive.google.com/file/d/145kHtTvTlNIwWLYheU2k-fxi7dJ_T1aH/view?usp=sharing',
    'Photo ID': '145kHtTvTlNIwWLYheU2k-fxi7dJ_T1aH',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=145kHtTvTlNIwWLYheU2k-fxi7dJ_T1aH',
  },
  {
    Make: 'Diadem',
    Model: 'Edge 18K Power Max',
    Retail: '239.95',
    New: '165.00',
    'Like New': '140.00',
    Good: '115.00',
    'Photo URL': 'https://drive.google.com/file/d/1aBcSXRFII47tEj_qMoxpoK9q7xIoSefg/view?usp=sharing',
    'Photo ID': '1aBcSXRFII47tEj_qMoxpoK9q7xIoSefg',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1aBcSXRFII47tEj_qMoxpoK9q7xIoSefg',
  },
  {
    Make: 'Diadem',
    Model: 'Edge 18K Power Pro',
    Retail: '239.95',
    New: '165.00',
    'Like New': '140.00',
    Good: '115.00',
    'Photo URL': 'https://drive.google.com/file/d/1Ns51GtkRITIMAk8mDn5JEhKZrjD3Dapm/view?usp=sharing',
    'Photo ID': '1Ns51GtkRITIMAk8mDn5JEhKZrjD3Dapm',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Ns51GtkRITIMAk8mDn5JEhKZrjD3Dapm',
  },
  {
    Make: 'Diadem',
    Model: 'Edge 18K SP',
    Retail: '239.95',
    New: '165.00',
    'Like New': '140.00',
    Good: '115.00',
    'Photo URL': 'https://drive.google.com/file/d/1a4uFDvdqyiYwzBFlV-mEc99i3CfV_7qN/view?usp=sharing',
    'Photo ID': '1a4uFDvdqyiYwzBFlV-mEc99i3CfV_7qN',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1a4uFDvdqyiYwzBFlV-mEc99i3CfV_7qN',
  },
  {
    Make: 'Diadem',
    Model: 'Edge BluCore Hybrid',
    Retail: '249.95',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1Im6hDRiFJq1wX3Wo-WVxR3CU2twk11rc/view?usp=sharing',
    'Photo ID': '1Im6hDRiFJq1wX3Wo-WVxR3CU2twk11rc',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Im6hDRiFJq1wX3Wo-WVxR3CU2twk11rc',
  },
  {
    Make: 'Diadem',
    Model: 'Edge BluCore Pro',
    Retail: '249.95',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1npENP6qBf2YfssqIBVS9QM3iv7O2pR9q/view?usp=sharing',
    'Photo ID': '1npENP6qBf2YfssqIBVS9QM3iv7O2pR9q',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1npENP6qBf2YfssqIBVS9QM3iv7O2pR9q',
  },
  {
    Make: 'Diadem',
    Model: 'Hush',
    Retail: '189.95',
    New: '130.00',
    'Like New': '110.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1cBSNaEQDKOroXWPgqcEA8jW82G7kvfoI/view?usp=sharing',
    'Photo ID': '1cBSNaEQDKOroXWPgqcEA8jW82G7kvfoI',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1cBSNaEQDKOroXWPgqcEA8jW82G7kvfoI',
  },
  {
    Make: 'Diadem',
    Model: 'Icon Infinity',
    Retail: '219.95',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1FQmNJg2bx3N_zQjoNx4-SbaDfHcvwiOu/view?usp=sharing',
    'Photo ID': '1FQmNJg2bx3N_zQjoNx4-SbaDfHcvwiOu',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1FQmNJg2bx3N_zQjoNx4-SbaDfHcvwiOu',
  },
  {
    Make: 'Diadem',
    Model: 'Icon V1',
    Retail: '159.95',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1zTs1fmmhCCI9K1iyYoas0yuJLkyxh7Dg/view?usp=sharing',
    'Photo ID': '1zTs1fmmhCCI9K1iyYoas0yuJLkyxh7Dg',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1zTs1fmmhCCI9K1iyYoas0yuJLkyxh7Dg',
  },
  {
    Make: 'Diadem',
    Model: 'Icon V2',
    Retail: '199.95',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/19uleY5pRWBBfs0L_arcelOW0fqn3C4Wm/view?usp=sharing',
    'Photo ID': '19uleY5pRWBBfs0L_arcelOW0fqn3C4Wm',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=19uleY5pRWBBfs0L_arcelOW0fqn3C4Wm',
  },
  {
    Make: 'Diadem',
    Model: 'Riptide',
    Retail: '84.95',
    New: '55.00',
    'Like New': '50.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1lr1yWl5jc23zQWKKs9qJFETwFTbTdOkf/view?usp=sharing',
    'Photo ID': '1lr1yWl5jc23zQWKKs9qJFETwFTbTdOkf',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1lr1yWl5jc23zQWKKs9qJFETwFTbTdOkf',
  },
  {
    Make: 'Diadem',
    Model: 'Rush',
    Retail: '99.95',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/14wTxNXQAstXbLdLisqc0tCMAslh9UOr8/view?usp=sharing',
    'Photo ID': '14wTxNXQAstXbLdLisqc0tCMAslh9UOr8',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=14wTxNXQAstXbLdLisqc0tCMAslh9UOr8',
  },
  {
    Make: 'Diadem',
    Model: 'Vice',
    Retail: '109.95',
    New: '75.00',
    'Like New': '65.00',
    Good: '50.00',
    'Photo URL': 'https://drive.google.com/file/d/1pdM0eLKgZIYYbgnznyt3nNDAZEHxQzEw/view?usp=sharing',
    'Photo ID': '1pdM0eLKgZIYYbgnznyt3nNDAZEHxQzEw',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1pdM0eLKgZIYYbgnznyt3nNDAZEHxQzEw',
  },
  {
    Make: 'Diadem',
    Model: 'Warrior',
    Retail: '199.95',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1w_A4hO-7a53DvuWsIQ4onxtkcF93FIv1/view?usp=sharing',
    'Photo ID': '1w_A4hO-7a53DvuWsIQ4onxtkcF93FIv1',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1w_A4hO-7a53DvuWsIQ4onxtkcF93FIv1',
  },
  {
    Make: 'Diadem',
    Model: 'Warrior Blucore',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1IfykxDlZc6ac8xgAfdacjyFLA71Flbar/view?usp=sharing',
    'Photo ID': '1IfykxDlZc6ac8xgAfdacjyFLA71Flbar',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1IfykxDlZc6ac8xgAfdacjyFLA71Flbar',
  },
  {
    Make: 'Diadem',
    Model: 'Warrior Edge',
    Retail: '174.95',
    New: '120.00',
    'Like New': '100.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1pcNmiUPjXEjXJPYKCUl3shi-k9NdH4x9/view?usp=sharing',
    'Photo ID': '1pcNmiUPjXEjXJPYKCUl3shi-k9NdH4x9',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1pcNmiUPjXEjXJPYKCUl3shi-k9NdH4x9',
  },
  {
    Make: 'Diadem',
    Model: 'Warrior V2',
    Retail: '220.95',
    New: '150.00',
    'Like New': '130.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1YXipBxI1l8ieRf0tPjXAKTu5RhYjVNbI/view?usp=sharing',
    'Photo ID': '1YXipBxI1l8ieRf0tPjXAKTu5RhYjVNbI',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1YXipBxI1l8ieRf0tPjXAKTu5RhYjVNbI',
  },
  {
    Make: 'dINGK',
    Model: 'HYPR PRO X',
    Retail: '225.00',
    New: '155.00',
    'Like New': '135.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1xqB_uCzzFU5-AtsxhApJN6o1Rz1SuH3B/view?usp=sharing',
    'Photo ID': '1xqB_uCzzFU5-AtsxhApJN6o1Rz1SuH3B',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1xqB_uCzzFU5-AtsxhApJN6o1Rz1SuH3B',
  },
  {
    Make: 'dINGK',
    Model: 'HYPR PRO X BLUE',
    Retail: '225.00',
    New: '155.00',
    'Like New': '135.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1J-DDjSOfEb-DwCVKi8BD_1zYz_3Z9OmH/view?usp=sharing',
    'Photo ID': '1J-DDjSOfEb-DwCVKi8BD_1zYz_3Z9OmH',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1J-DDjSOfEb-DwCVKi8BD_1zYz_3Z9OmH',
  },
  {
    Make: 'dINGK',
    Model: 'PRO GRIT',
    Retail: '200.00',
    New: '140.00',
    'Like New': '120.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/1--vSPW7WzFDipVyYA53qAc78VKGIDSxM/view?usp=sharing',
    'Photo ID': '1--vSPW7WzFDipVyYA53qAc78VKGIDSxM',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1--vSPW7WzFDipVyYA53qAc78VKGIDSxM',
  },
  {
    Make: 'Electrum',
    Model: 'Model E 13mm',
    Retail: '159.99',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1ZhzURxxjcj4-PlVwfgsAJqu3JDIFdy1-/view?usp=sharing',
    'Photo ID': '1ZhzURxxjcj4-PlVwfgsAJqu3JDIFdy1-',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ZhzURxxjcj4-PlVwfgsAJqu3JDIFdy1-',
  },
  {
    Make: 'Electrum',
    Model: 'Model E 16mm',
    Retail: '179.99',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1c-zIenHdsGzqIILE_X2gly299DdhuQ4X/view?usp=sharing',
    'Photo ID': '1c-zIenHdsGzqIILE_X2gly299DdhuQ4X',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1c-zIenHdsGzqIILE_X2gly299DdhuQ4X',
  },
  {
    Make: 'Electrum',
    Model: 'Model E Elite',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1_Lh19OcT-wwX9dUqixMnUZf0S7VvR4tK/view?usp=sharing',
    'Photo ID': '1_Lh19OcT-wwX9dUqixMnUZf0S7VvR4tK',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1_Lh19OcT-wwX9dUqixMnUZf0S7VvR4tK',
  },
  {
    Make: 'Electrum',
    Model: 'Model E Stealth',
    Retail: '219.99',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1HHBoJKih6UNQ3bcI5D-TLVy4eLTkzuVt/view?usp=sharing',
    'Photo ID': '1HHBoJKih6UNQ3bcI5D-TLVy4eLTkzuVt',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1HHBoJKih6UNQ3bcI5D-TLVy4eLTkzuVt',
  },
  {
    Make: 'Electrum',
    Model: 'Pro II',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1AjaiuISKamVWKfRIfotC7nqTVU89aRFz/view?usp=sharing',
    'Photo ID': '1AjaiuISKamVWKfRIfotC7nqTVU89aRFz',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1AjaiuISKamVWKfRIfotC7nqTVU89aRFz',
  },
  {
    Make: 'Electrum',
    Model: 'Pro II Stealth',
    Retail: '219.99',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1OzV0zXqyIhL5xkhBf13u3oPOrG_N2ouO/view?usp=sharing',
    'Photo ID': '1OzV0zXqyIhL5xkhBf13u3oPOrG_N2ouO',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1OzV0zXqyIhL5xkhBf13u3oPOrG_N2ouO',
  },
  {
    Make: 'Electrum',
    Model: 'Pro Stealth',
    Retail: '219.99',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1TdZWZEFEbxdLNxlU0q31G9eKPI98Txs1/view?usp=sharing',
    'Photo ID': '1TdZWZEFEbxdLNxlU0q31G9eKPI98Txs1',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1TdZWZEFEbxdLNxlU0q31G9eKPI98Txs1',
  },
  {
    Make: 'Engage',
    Model: 'Alpha Pro',
    Retail: '259.99',
    New: '180.00',
    'Like New': '155.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1IMrBDY4HNl-bV_y_5XYaWL52BjNrOXGu/view?usp=sharing',
    'Photo ID': '1IMrBDY4HNl-bV_y_5XYaWL52BjNrOXGu',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1IMrBDY4HNl-bV_y_5XYaWL52BjNrOXGu',
  },
  {
    Make: 'Engage',
    Model: 'Encore EX',
    Retail: '159.99',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1qVDQpmibFmfqxrWr9wxH2W5WV_JP-H8f/view?usp=sharing',
    'Photo ID': '1qVDQpmibFmfqxrWr9wxH2W5WV_JP-H8f',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1qVDQpmibFmfqxrWr9wxH2W5WV_JP-H8f',
  },
  {
    Make: 'Engage',
    Model: 'Encore EX 6.0',
    Retail: '159.99',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1FsPK6antllHG3EykN8_nl8Bo9WJQ8pBD/view?usp=sharing',
    'Photo ID': '1FsPK6antllHG3EykN8_nl8Bo9WJQ8pBD',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1FsPK6antllHG3EykN8_nl8Bo9WJQ8pBD',
  },
  {
    Make: 'Engage',
    Model: 'Encore MX',
    Retail: '159.99',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1PJFIwWICEtDD7J6m8f6N3kxNy-HmaDiA/view?usp=sharing',
    'Photo ID': '1PJFIwWICEtDD7J6m8f6N3kxNy-HmaDiA',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1PJFIwWICEtDD7J6m8f6N3kxNy-HmaDiA',
  },
  {
    Make: 'Engage',
    Model: 'Encore MX 6.0',
    Retail: '159.99',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1yDF_KhD1WkQiYkfeXd8z2gnwofdKUGjq/view?usp=sharing',
    'Photo ID': '1yDF_KhD1WkQiYkfeXd8z2gnwofdKUGjq',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1yDF_KhD1WkQiYkfeXd8z2gnwofdKUGjq',
  },
  {
    Make: 'Engage',
    Model: 'Evolution Extreme V2',
    Retail: '159.99',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1cDdFny913cxC97IRsDdncHfu_6D1pJVT/view?usp=sharing',
    'Photo ID': '1cDdFny913cxC97IRsDdncHfu_6D1pJVT',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1cDdFny913cxC97IRsDdncHfu_6D1pJVT',
  },
  {
    Make: 'Engage',
    Model: 'Pro Foam',
    Retail: '229.99',
    New: '160.00',
    'Like New': '135.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1k0k8UFJuau-AhhLR-gGB_13K2hzHs929/view?usp=sharing',
    'Photo ID': '1k0k8UFJuau-AhhLR-gGB_13K2hzHs929',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1k0k8UFJuau-AhhLR-gGB_13K2hzHs929',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit EX',
    Retail: '219.99',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1nUBQWDcWoIm2xV2kbxEHSz9WEY-vlotH/view?usp=sharing',
    'Photo ID': '1nUBQWDcWoIm2xV2kbxEHSz9WEY-vlotH',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1nUBQWDcWoIm2xV2kbxEHSz9WEY-vlotH',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit EX 6.0',
    Retail: '219.99',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1d4AfYPM6gm5KfMc2z9R-OKD4LfudcKgx/view?usp=sharing',
    'Photo ID': '1d4AfYPM6gm5KfMc2z9R-OKD4LfudcKgx',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1d4AfYPM6gm5KfMc2z9R-OKD4LfudcKgx',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit MAXX EX 6.0',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1hx_w4oUqaz4eSaHqGEUBIJ4aWOduI2Y-/view?usp=sharing',
    'Photo ID': '1hx_w4oUqaz4eSaHqGEUBIJ4aWOduI2Y-',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1hx_w4oUqaz4eSaHqGEUBIJ4aWOduI2Y-',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit MAXX MX 6.0',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/10NEG2OdsM92G2K6Pn7nPi1OHDpfrC5xm/view?usp=sharing',
    'Photo ID': '10NEG2OdsM92G2K6Pn7nPi1OHDpfrC5xm',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=10NEG2OdsM92G2K6Pn7nPi1OHDpfrC5xm',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit MX',
    Retail: '219.99',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1kEYqVVBojraq0V98mf6CurITiQfsyvHV/view?usp=sharing',
    'Photo ID': '1kEYqVVBojraq0V98mf6CurITiQfsyvHV',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1kEYqVVBojraq0V98mf6CurITiQfsyvHV',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit MX 6.0',
    Retail: '219.99',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1KIC6wGHg9fvYyawGlGD1rsrUgWZdDi9n/view?usp=sharing',
    'Photo ID': '1KIC6wGHg9fvYyawGlGD1rsrUgWZdDi9n',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1KIC6wGHg9fvYyawGlGD1rsrUgWZdDi9n',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit Pro EX',
    Retail: '259.99',
    New: '180.00',
    'Like New': '155.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/13QzWQulM0LVzSWjfBW4JsfZBmVcs6ABF/view?usp=sharing',
    'Photo ID': '13QzWQulM0LVzSWjfBW4JsfZBmVcs6ABF',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=13QzWQulM0LVzSWjfBW4JsfZBmVcs6ABF',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit Pro EX 6.0',
    Retail: '259.99',
    New: '180.00',
    'Like New': '155.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1RILW3fYAVfnkp4YO4RX799iRHRmavmtW/view?usp=sharing',
    'Photo ID': '1RILW3fYAVfnkp4YO4RX799iRHRmavmtW',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1RILW3fYAVfnkp4YO4RX799iRHRmavmtW',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit Pro MX',
    Retail: '259.99',
    New: '180.00',
    'Like New': '155.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1uf_ZrUZNSPxHBB3pwt22FfvIpgRh3h2m/view?usp=sharing',
    'Photo ID': '1uf_ZrUZNSPxHBB3pwt22FfvIpgRh3h2m',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1uf_ZrUZNSPxHBB3pwt22FfvIpgRh3h2m',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit Pro MX 6.0',
    Retail: '259.99',
    New: '180.00',
    'Like New': '155.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1B-60HxTB20veIv3JJXy5CDcd9EhqtOHC/view?usp=sharing',
    'Photo ID': '1B-60HxTB20veIv3JJXy5CDcd9EhqtOHC',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1B-60HxTB20veIv3JJXy5CDcd9EhqtOHC',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit Pro1 6.0 Elongated Power Series',
    Retail: '259.99',
    New: '180.00',
    'Like New': '155.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1piFI8FES259A8YybvsJt_r_l93JNiFrV/view?usp=sharing',
    'Photo ID': '1piFI8FES259A8YybvsJt_r_l93JNiFrV',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1piFI8FES259A8YybvsJt_r_l93JNiFrV',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit Pro1 6.0 Hybrid',
    Retail: '259.99',
    New: '180.00',
    'Like New': '155.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1hO8XZHy1qNKqFPGdP5VNQlY6yvfZLLdQ/view?usp=sharing',
    'Photo ID': '1hO8XZHy1qNKqFPGdP5VNQlY6yvfZLLdQ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1hO8XZHy1qNKqFPGdP5VNQlY6yvfZLLdQ',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit Pro1 6.0 Widebody',
    Retail: '259.99',
    New: '180.00',
    'Like New': '155.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1vxnO_KN_zVpqkrva-ztdPg7V_gZVrvvd/view?usp=sharing',
    'Photo ID': '1vxnO_KN_zVpqkrva-ztdPg7V_gZVrvvd',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1vxnO_KN_zVpqkrva-ztdPg7V_gZVrvvd',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit Pro1 Elongated Power Series',
    Retail: '259.99',
    New: '180.00',
    'Like New': '155.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1WRLnlq1J0gNrn-cS6RJIO3y9NEQgHgjI/view?usp=sharing',
    'Photo ID': '1WRLnlq1J0gNrn-cS6RJIO3y9NEQgHgjI',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1WRLnlq1J0gNrn-cS6RJIO3y9NEQgHgjI',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit Pro1 Hybrid',
    Retail: '259.99',
    New: '180.00',
    'Like New': '155.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1CrEDIXlH1HLbU-Pcdt8J4Pb7_xBXfpC_/view?usp=sharing',
    'Photo ID': '1CrEDIXlH1HLbU-Pcdt8J4Pb7_xBXfpC_',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1CrEDIXlH1HLbU-Pcdt8J4Pb7_xBXfpC_',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit Pro1 Innovation 12.7mm',
    Retail: '279.99',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1QtKPEIXZn8ss158FkMvuF_dLxU3k2Btd/view?usp=sharing',
    'Photo ID': '1QtKPEIXZn8ss158FkMvuF_dLxU3k2Btd',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1QtKPEIXZn8ss158FkMvuF_dLxU3k2Btd',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit Pro1 Innovation 15.2mm',
    Retail: '279.99',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1DFTpmmXw7c947wAuilrFd6_TEs6cM4rI/view?usp=sharing',
    'Photo ID': '1DFTpmmXw7c947wAuilrFd6_TEs6cM4rI',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1DFTpmmXw7c947wAuilrFd6_TEs6cM4rI',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit Pro1 Widebody',
    Retail: '259.99',
    New: '180.00',
    'Like New': '155.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1DEbRMpUlA-qU8c_jGRqBbyq-foT2XGgn/view?usp=sharing',
    'Photo ID': '1DEbRMpUlA-qU8c_jGRqBbyq-foT2XGgn',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1DEbRMpUlA-qU8c_jGRqBbyq-foT2XGgn',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit Ultra EX 6.0',
    Retail: '259.99',
    New: '180.00',
    'Like New': '155.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1Q9QVSgx7J5cxnqA-3MqsuKCzY2p19Wpc/view?usp=sharing',
    'Photo ID': '1Q9QVSgx7J5cxnqA-3MqsuKCzY2p19Wpc',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Q9QVSgx7J5cxnqA-3MqsuKCzY2p19Wpc',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit Ultra MX',
    Retail: '259.99',
    New: '180.00',
    'Like New': '155.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1amRsXoS2Tj5E9i0R5CMfMDzCDp18G_eE/view?usp=sharing',
    'Photo ID': '1amRsXoS2Tj5E9i0R5CMfMDzCDp18G_eE',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1amRsXoS2Tj5E9i0R5CMfMDzCDp18G_eE',
  },
  {
    Make: 'Engage',
    Model: 'Pursuit V2.0',
    Retail: '179.99',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1H2Y7RGUyaZYSksmk98ULKMcyWI8PNVxO/view?usp=sharing',
    'Photo ID': '1H2Y7RGUyaZYSksmk98ULKMcyWI8PNVxO',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1H2Y7RGUyaZYSksmk98ULKMcyWI8PNVxO',
  },
  {
    Make: 'Franklin',
    Model: 'C45 Dynasty',
    Retail: '229.99',
    New: '160.00',
    'Like New': '135.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1_LEo_lh3rZZLeM6_516deTt74NuwjpGS/view?usp=sharing',
    'Photo ID': '1_LEo_lh3rZZLeM6_516deTt74NuwjpGS',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1_LEo_lh3rZZLeM6_516deTt74NuwjpGS',
  },
  {
    Make: 'Franklin',
    Model: 'C45 Hybrid',
    Retail: '229.99',
    New: '160.00',
    'Like New': '135.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1EeO0MIQWSqXe3rcTP-JG7s0o63FdSMme/view?usp=sharing',
    'Photo ID': '1EeO0MIQWSqXe3rcTP-JG7s0o63FdSMme',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1EeO0MIQWSqXe3rcTP-JG7s0o63FdSMme',
  },
  {
    Make: 'Franklin',
    Model: 'C45 Tempo',
    Retail: '229.99',
    New: '160.00',
    'Like New': '135.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1FpSijq0Y9XuNmAOgODVXqsmnyUMYSIxW/view?usp=sharing',
    'Photo ID': '1FpSijq0Y9XuNmAOgODVXqsmnyUMYSIxW',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1FpSijq0Y9XuNmAOgODVXqsmnyUMYSIxW',
  },
  {
    Make: 'Franklin',
    Model: 'FS Tour Dynasty',
    Retail: '149.99',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1o1gzxAwZfUFZvz8HghJ_NhneqTAF6D0Y/view?usp=sharing',
    'Photo ID': '1o1gzxAwZfUFZvz8HghJ_NhneqTAF6D0Y',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1o1gzxAwZfUFZvz8HghJ_NhneqTAF6D0Y',
  },
  {
    Make: 'Franklin',
    Model: 'FS Tour Tempo',
    Retail: '149.99',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1V_4Id0BIGdBJj8E56z_1g-zJar9firyF/view?usp=sharing',
    'Photo ID': '1V_4Id0BIGdBJj8E56z_1g-zJar9firyF',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1V_4Id0BIGdBJj8E56z_1g-zJar9firyF',
  },
  {
    Make: 'Franklin',
    Model: 'Signature',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/18v6KITzwkAeUayJkOe59tS8oQwKvlXey/view?usp=sharing',
    'Photo ID': '18v6KITzwkAeUayJkOe59tS8oQwKvlXey',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=18v6KITzwkAeUayJkOe59tS8oQwKvlXey',
  },
  {
    Make: 'Franklin',
    Model: 'Signature Carbon STK',
    Retail: '149.99',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1BpJ4_MmJiQV6cfykYq0v34nQcpSWlQo-/view?usp=sharing',
    'Photo ID': '1BpJ4_MmJiQV6cfykYq0v34nQcpSWlQo-',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1BpJ4_MmJiQV6cfykYq0v34nQcpSWlQo-',
  },
  {
    Make: 'Friday',
    Model: 'Challenger',
    Retail: '89.00',
    New: '60.00',
    'Like New': '50.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/10EswZMusSLub7i3hHC-JelQ1FXmpJ8GJ/view?usp=sharing',
    'Photo ID': '10EswZMusSLub7i3hHC-JelQ1FXmpJ8GJ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=10EswZMusSLub7i3hHC-JelQ1FXmpJ8GJ',
  },
  {
    Make: 'Friday',
    Model: 'Fever',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1DjXhMK4TE_WJ9lnFdoD7CVlXmI3QY1am/view?usp=sharing',
    'Photo ID': '1DjXhMK4TE_WJ9lnFdoD7CVlXmI3QY1am',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1DjXhMK4TE_WJ9lnFdoD7CVlXmI3QY1am',
  },
  {
    Make: 'Friday',
    Model: 'Original',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/10U7JdgwNwlkr3XZmpmXnZVSd70p2pAtH/view?usp=sharing',
    'Photo ID': '10U7JdgwNwlkr3XZmpmXnZVSd70p2pAtH',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=10U7JdgwNwlkr3XZmpmXnZVSd70p2pAtH',
  },
  {
    Make: 'Gamma',
    Model: '405',
    Retail: '139.99',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/1rpBHy4Mv0mnDfwHWSYrLMYKf7RD4DbY6/view?usp=sharing',
    'Photo ID': '1rpBHy4Mv0mnDfwHWSYrLMYKf7RD4DbY6',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1rpBHy4Mv0mnDfwHWSYrLMYKf7RD4DbY6',
  },
  {
    Make: 'Gamma',
    Model: '412',
    Retail: '139.99',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/1-dPswC1UqfS-b5DqTtx_9UDpvH5EHTa_/view?usp=sharing',
    'Photo ID': '1-dPswC1UqfS-b5DqTtx_9UDpvH5EHTa_',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1-dPswC1UqfS-b5DqTtx_9UDpvH5EHTa_',
  },
  {
    Make: 'Gamma',
    Model: '505',
    Retail: '179.99',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1BZ24tCiyBG1zJBNZOmPMjXqSExT9oHQq/view?usp=sharing',
    'Photo ID': '1BZ24tCiyBG1zJBNZOmPMjXqSExT9oHQq',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1BZ24tCiyBG1zJBNZOmPMjXqSExT9oHQq',
  },
  {
    Make: 'Gamma',
    Model: 'Airbender 10',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1AGUC3I1KYwzgrnfhjZ_o0ZtPnvNzzCMI/view?usp=sharing',
    'Photo ID': '1AGUC3I1KYwzgrnfhjZ_o0ZtPnvNzzCMI',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1AGUC3I1KYwzgrnfhjZ_o0ZtPnvNzzCMI',
  },
  {
    Make: 'Gamma',
    Model: 'Airbender 13',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1-7nvyy-xAZldHeSceg5EaaPCoyy0LEWO/view?usp=sharing',
    'Photo ID': '1-7nvyy-xAZldHeSceg5EaaPCoyy0LEWO',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1-7nvyy-xAZldHeSceg5EaaPCoyy0LEWO',
  },
  {
    Make: 'Gamma',
    Model: 'Airbender 16',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1xqBzOEXpNTJUEl9LrZ2OkYK7zKeICxuO/view?usp=sharing',
    'Photo ID': '1xqBzOEXpNTJUEl9LrZ2OkYK7zKeICxuO',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1xqBzOEXpNTJUEl9LrZ2OkYK7zKeICxuO',
  },
  {
    Make: 'Gamma',
    Model: 'Atomic 5.0',
    Retail: '89.99',
    New: '60.00',
    'Like New': '50.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1BlIFsOH4Nas5Fmaf7s3ZN6J0P85utalX/view?usp=sharing',
    'Photo ID': '1BlIFsOH4Nas5Fmaf7s3ZN6J0P85utalX',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1BlIFsOH4Nas5Fmaf7s3ZN6J0P85utalX',
  },
  {
    Make: 'Gamma',
    Model: 'Compass Neucore',
    Retail: '159.99',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1IilLMkyDd9hhfGPuP3lp-HQkYVGhVCKz/view?usp=sharing',
    'Photo ID': '1IilLMkyDd9hhfGPuP3lp-HQkYVGhVCKz',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1IilLMkyDd9hhfGPuP3lp-HQkYVGhVCKz',
  },
  {
    Make: 'Gamma',
    Model: 'Fusion Power',
    Retail: '49.99',
    New: '30.00',
    'Like New': '25.00',
    Good: '20.00',
    'Photo URL': 'https://drive.google.com/file/d/1jNpeReh7vdoo_Ec84mRSk9nEXsf-uY3G/view?usp=sharing',
    'Photo ID': '1jNpeReh7vdoo_Ec84mRSk9nEXsf-uY3G',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1jNpeReh7vdoo_Ec84mRSk9nEXsf-uY3G',
  },
  {
    Make: 'Gamma',
    Model: 'Fusion React',
    Retail: '39.99',
    New: '25.00',
    'Like New': '20.00',
    Good: '15.00',
    'Photo URL': 'https://drive.google.com/file/d/1YhVHdbHczRsD5GS9NhSuOSiAjrQOltPa/view?usp=sharing',
    'Photo ID': '1YhVHdbHczRsD5GS9NhSuOSiAjrQOltPa',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1YhVHdbHczRsD5GS9NhSuOSiAjrQOltPa',
  },
  {
    Make: 'Gamma',
    Model: 'Hellbender Neucore',
    Retail: '169.99',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1wQkRCQ3EQRBsbLGTBX68FqDJSEHSL41_/view?usp=sharing',
    'Photo ID': '1wQkRCQ3EQRBsbLGTBX68FqDJSEHSL41_',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1wQkRCQ3EQRBsbLGTBX68FqDJSEHSL41_',
  },
  {
    Make: 'Gamma',
    Model: 'Micron 5.0',
    Retail: '69.99',
    New: '45.00',
    'Like New': '40.00',
    Good: '30.00',
    'Photo URL': 'https://drive.google.com/file/d/1qCDULKNkruoClOs8ThN1gt7gb-_QzlAC/view?usp=sharing',
    'Photo ID': '1qCDULKNkruoClOs8ThN1gt7gb-_QzlAC',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1qCDULKNkruoClOs8ThN1gt7gb-_QzlAC',
  },
  {
    Make: 'Gamma',
    Model: 'Needle',
    Retail: '119.99',
    New: '80.00',
    'Like New': '70.00',
    Good: '55.00',
    'Photo URL': 'https://drive.google.com/file/d/11JJBZf7fXYZBOlOU_w1PcFy5xu9mkZ6h/view?usp=sharing',
    'Photo ID': '11JJBZf7fXYZBOlOU_w1PcFy5xu9mkZ6h',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=11JJBZf7fXYZBOlOU_w1PcFy5xu9mkZ6h',
  },
  {
    Make: 'Gamma',
    Model: 'Neutron 5.0',
    Retail: '79.99',
    New: '55.00',
    'Like New': '45.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/1ERbnOrj192IaGa0DSjW8XAb3HrPD7Zfy/view?usp=sharing',
    'Photo ID': '1ERbnOrj192IaGa0DSjW8XAb3HrPD7Zfy',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ERbnOrj192IaGa0DSjW8XAb3HrPD7Zfy',
  },
  {
    Make: 'Gamma',
    Model: 'Obsidian 10',
    Retail: '159.99',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1O8IRikWu2QMmLIIWHoDI-a_UAhjTMskw/view?usp=sharing',
    'Photo ID': '1O8IRikWu2QMmLIIWHoDI-a_UAhjTMskw',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1O8IRikWu2QMmLIIWHoDI-a_UAhjTMskw',
  },
  {
    Make: 'Gamma',
    Model: 'Obsidian 13',
    Retail: '159.99',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1HfITH3K5RxBx3iDc4NOHr11rbr6v-ZpK/view?usp=sharing',
    'Photo ID': '1HfITH3K5RxBx3iDc4NOHr11rbr6v-ZpK',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1HfITH3K5RxBx3iDc4NOHr11rbr6v-ZpK',
  },
  {
    Make: 'Gamma',
    Model: 'Obsidian 16',
    Retail: '159.99',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1RxGMPDMgswXEA-wg-Xo1zDlXmdz3nWfB/view?usp=sharing',
    'Photo ID': '1RxGMPDMgswXEA-wg-Xo1zDlXmdz3nWfB',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1RxGMPDMgswXEA-wg-Xo1zDlXmdz3nWfB',
  },
  {
    Make: 'Gamma',
    Model: 'Rainmaker',
    Retail: '79.99',
    New: '55.00',
    'Like New': '45.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/18OGpmcCIu8k4fbwQy1k4uMbNbFelfxw9/view?usp=sharing',
    'Photo ID': '18OGpmcCIu8k4fbwQy1k4uMbNbFelfxw9',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=18OGpmcCIu8k4fbwQy1k4uMbNbFelfxw9',
  },
  {
    Make: 'Gamma',
    Model: 'Voltage 5.0',
    Retail: '89.99',
    New: '60.00',
    'Like New': '50.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1g78jMHHpQr5rzou3awBIkTMbLFs4JF7-/view?usp=sharing',
    'Photo ID': '1g78jMHHpQr5rzou3awBIkTMbLFs4JF7-',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1g78jMHHpQr5rzou3awBIkTMbLFs4JF7-',
  },
  {
    Make: 'Gearbox',
    Model: 'CP7',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1MhG1o7QRJOATq2Ogq4XAnKuDsBJrXMZA/view?usp=sharing',
    'Photo ID': '1MhG1o7QRJOATq2Ogq4XAnKuDsBJrXMZA',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1MhG1o7QRJOATq2Ogq4XAnKuDsBJrXMZA',
  },
  {
    Make: 'Gearbox',
    Model: 'CX11E Control',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1Y2GgQgWhiFy9YYbm8fUXtGnt2MwtCy0w/view?usp=sharing',
    'Photo ID': '1Y2GgQgWhiFy9YYbm8fUXtGnt2MwtCy0w',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Y2GgQgWhiFy9YYbm8fUXtGnt2MwtCy0w',
  },
  {
    Make: 'Gearbox',
    Model: 'CX11E Power',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1G1FCiQHmvfHIu5M7OfaMYPORTeJuww9o/view?usp=sharing',
    'Photo ID': '1G1FCiQHmvfHIu5M7OfaMYPORTeJuww9o',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1G1FCiQHmvfHIu5M7OfaMYPORTeJuww9o',
  },
  {
    Make: 'Gearbox',
    Model: 'CX11Q Control',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1IwN8JgxaB2sfTrbHL2dmq-xvrBF6OATK/view?usp=sharing',
    'Photo ID': '1IwN8JgxaB2sfTrbHL2dmq-xvrBF6OATK',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1IwN8JgxaB2sfTrbHL2dmq-xvrBF6OATK',
  },
  {
    Make: 'Gearbox',
    Model: 'CX11Q Power',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1Y58C4ypXl9QHGdK7epygqd0HlqpxW233/view?usp=sharing',
    'Photo ID': '1Y58C4ypXl9QHGdK7epygqd0HlqpxW233',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Y58C4ypXl9QHGdK7epygqd0HlqpxW233',
  },
  {
    Make: 'Gearbox',
    Model: 'CX14E',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1nMYpy3DUTnsSOGV1UzB4ah3yZlLPs7z5/view?usp=sharing',
    'Photo ID': '1nMYpy3DUTnsSOGV1UzB4ah3yZlLPs7z5',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1nMYpy3DUTnsSOGV1UzB4ah3yZlLPs7z5',
  },
  {
    Make: 'Gearbox',
    Model: 'CX14E Ultimate',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1mO3xy9oFq_UpP1GT8pIyfih7J8tgQPNo/view?usp=sharing',
    'Photo ID': '1mO3xy9oFq_UpP1GT8pIyfih7J8tgQPNo',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1mO3xy9oFq_UpP1GT8pIyfih7J8tgQPNo',
  },
  {
    Make: 'Gearbox',
    Model: 'CX14H',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1YKfL52BVA3fm8gnrX4hg8mLKpAsgBIxw/view?usp=sharing',
    'Photo ID': '1YKfL52BVA3fm8gnrX4hg8mLKpAsgBIxw',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1YKfL52BVA3fm8gnrX4hg8mLKpAsgBIxw',
  },
  {
    Make: 'Gearbox',
    Model: 'CX14H Ultimate',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1PtluuZ9hT5a9sSbLLx8MdgAdbigsdWO_/view?usp=sharing',
    'Photo ID': '1PtluuZ9hT5a9sSbLLx8MdgAdbigsdWO_',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1PtluuZ9hT5a9sSbLLx8MdgAdbigsdWO_',
  },
  {
    Make: 'Gearbox',
    Model: 'G12',
    Retail: '59.99',
    New: '40.00',
    'Like New': '35.00',
    Good: '25.00',
    'Photo URL': 'https://drive.google.com/file/d/1xq4aRWYmzCZjlSj8R5Me96CMfuFpkTsQ/view?usp=sharing',
    'Photo ID': '1xq4aRWYmzCZjlSj8R5Me96CMfuFpkTsQ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1xq4aRWYmzCZjlSj8R5Me96CMfuFpkTsQ',
  },
  {
    Make: 'Gearbox',
    Model: 'G14',
    Retail: '129.99',
    New: '90.00',
    'Like New': '75.00',
    Good: '60.00',
    'Photo URL': 'https://drive.google.com/file/d/1IW2-nNzOjHgSMuZgx4iFXQk7bxeQRIYG/view?usp=sharing',
    'Photo ID': '1IW2-nNzOjHgSMuZgx4iFXQk7bxeQRIYG',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1IW2-nNzOjHgSMuZgx4iFXQk7bxeQRIYG',
  },
  {
    Make: 'Gearbox',
    Model: 'G16',
    Retail: '144.99',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1Nsaglq0CdWFm5aZmO0e3gOetoOdozqYD/view?usp=sharing',
    'Photo ID': '1Nsaglq0CdWFm5aZmO0e3gOetoOdozqYD',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Nsaglq0CdWFm5aZmO0e3gOetoOdozqYD',
  },
  {
    Make: 'Gearbox',
    Model: 'G2 Elongated',
    Retail: '119.99',
    New: '80.00',
    'Like New': '70.00',
    Good: '55.00',
    'Photo URL': 'https://drive.google.com/file/d/1-978H22-si2hw9x5HiZs8ovsqY3GGr9D/view?usp=sharing',
    'Photo ID': '1-978H22-si2hw9x5HiZs8ovsqY3GGr9D',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1-978H22-si2hw9x5HiZs8ovsqY3GGr9D',
  },
  {
    Make: 'Gearbox',
    Model: 'G2 Integra',
    Retail: '139.99',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/19FoK-iD53LO8GBx8klHShbzkKXDItY_A/view?usp=sharing',
    'Photo ID': '19FoK-iD53LO8GBx8klHShbzkKXDItY_A',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=19FoK-iD53LO8GBx8klHShbzkKXDItY_A',
  },
  {
    Make: 'Gearbox',
    Model: 'G2 Quad',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1H_kJC1i4dwY-GtMY0ehXY3GMqI6SPITR/view?usp=sharing',
    'Photo ID': '1H_kJC1i4dwY-GtMY0ehXY3GMqI6SPITR',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1H_kJC1i4dwY-GtMY0ehXY3GMqI6SPITR',
  },
  {
    Make: 'Gearbox',
    Model: 'GBX',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1jXfvF8ZFIMP9PXknNPtt2L70wdTy7iEk/view?usp=sharing',
    'Photo ID': '1jXfvF8ZFIMP9PXknNPtt2L70wdTy7iEk',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1jXfvF8ZFIMP9PXknNPtt2L70wdTy7iEk',
  },
  {
    Make: 'Gearbox',
    Model: 'GH7+',
    Retail: '74.99',
    New: '50.00',
    'Like New': '40.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/1V2R0vowoIzc6FD4y7LsR2-iMg-VHBwcq/view?usp=sharing',
    'Photo ID': '1V2R0vowoIzc6FD4y7LsR2-iMg-VHBwcq',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1V2R0vowoIzc6FD4y7LsR2-iMg-VHBwcq',
  },
  {
    Make: 'Gearbox',
    Model: 'GX2 Elongated',
    Retail: '269.99',
    New: '185.00',
    'Like New': '160.00',
    Good: '130.00',
    'Photo URL': 'https://drive.google.com/file/d/1b0j-aTKlfGXJY7496Ez63R79UNN9yqf8/view?usp=sharing',
    'Photo ID': '1b0j-aTKlfGXJY7496Ez63R79UNN9yqf8',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1b0j-aTKlfGXJY7496Ez63R79UNN9yqf8',
  },
  {
    Make: 'Gearbox',
    Model: 'GX2 Hyper',
    Retail: '269.99',
    New: '185.00',
    'Like New': '160.00',
    Good: '130.00',
    'Photo URL': 'https://drive.google.com/file/d/1Fc0iMIU4hqMKS1GJwJShErIRiebxW6Bc/view?usp=sharing',
    'Photo ID': '1Fc0iMIU4hqMKS1GJwJShErIRiebxW6Bc',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Fc0iMIU4hqMKS1GJwJShErIRiebxW6Bc',
  },
  {
    Make: 'Gearbox',
    Model: 'GX2 Integra XL',
    Retail: '269.99',
    New: '185.00',
    'Like New': '160.00',
    Good: '130.00',
    'Photo URL': 'https://drive.google.com/file/d/1EhIZv_pP4Br2klSFd90j-FzzN90b0VoI/view?usp=sharing',
    'Photo ID': '1EhIZv_pP4Br2klSFd90j-FzzN90b0VoI',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1EhIZv_pP4Br2klSFd90j-FzzN90b0VoI',
  },
  {
    Make: 'Gearbox',
    Model: 'GX2 Power Elongated',
    Retail: '279.99',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/15XgMeZzi632acI8D197Ti5tPwSC-mly-/view?usp=sharing',
    'Photo ID': '15XgMeZzi632acI8D197Ti5tPwSC-mly-',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=15XgMeZzi632acI8D197Ti5tPwSC-mly-',
  },
  {
    Make: 'Gearbox',
    Model: 'GX2 Power Hybrid',
    Retail: '279.99',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/17ppALBB-JhzQUwJwWiuximckFTLeiftv/view?usp=sharing',
    'Photo ID': '17ppALBB-JhzQUwJwWiuximckFTLeiftv',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=17ppALBB-JhzQUwJwWiuximckFTLeiftv',
  },
  {
    Make: 'Gearbox',
    Model: 'GX5',
    Retail: '149.99',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1ccGuvXNOgOiF25YgLW0Flae4nI72XjQ_/view?usp=sharing',
    'Photo ID': '1ccGuvXNOgOiF25YgLW0Flae4nI72XjQ_',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ccGuvXNOgOiF25YgLW0Flae4nI72XjQ_',
  },
  {
    Make: 'Gearbox',
    Model: 'GX6',
    Retail: '149.99',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1XlNoMkcyxRLQhnE46Au70nwfeGGre16C/view?usp=sharing',
    'Photo ID': '1XlNoMkcyxRLQhnE46Au70nwfeGGre16C',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1XlNoMkcyxRLQhnE46Au70nwfeGGre16C',
  },
  {
    Make: 'Gearbox',
    Model: 'Pro Control Elongated',
    Retail: '274.99',
    New: '190.00',
    'Like New': '160.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1BEIJ3JdsLuWAXne3PsxHvHYpvRkXD9sQ/view?usp=sharing',
    'Photo ID': '1BEIJ3JdsLuWAXne3PsxHvHYpvRkXD9sQ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1BEIJ3JdsLuWAXne3PsxHvHYpvRkXD9sQ',
  },
  {
    Make: 'Gearbox',
    Model: 'Pro Control Fusion',
    Retail: '274.99',
    New: '190.00',
    'Like New': '160.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1AlbcjWtCHTIej9sGnDgSIhUfFnpPdVeQ/view?usp=sharing',
    'Photo ID': '1AlbcjWtCHTIej9sGnDgSIhUfFnpPdVeQ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1AlbcjWtCHTIej9sGnDgSIhUfFnpPdVeQ',
  },
  {
    Make: 'Gearbox',
    Model: 'Pro Control Integra',
    Retail: '274.99',
    New: '190.00',
    'Like New': '160.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1u4K9ZglTPZH8g9s6_2_LvP7YPFrig7EC/view?usp=sharing',
    'Photo ID': '1u4K9ZglTPZH8g9s6_2_LvP7YPFrig7EC',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1u4K9ZglTPZH8g9s6_2_LvP7YPFrig7EC',
  },
  {
    Make: 'Gearbox',
    Model: 'Pro Power Elongated',
    Retail: '274.99',
    New: '190.00',
    'Like New': '160.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1zJCXX3FbH1P3odLdtJRuh0Bv0UCMxRqS/view?usp=sharing',
    'Photo ID': '1zJCXX3FbH1P3odLdtJRuh0Bv0UCMxRqS',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1zJCXX3FbH1P3odLdtJRuh0Bv0UCMxRqS',
  },
  {
    Make: 'Gearbox',
    Model: 'Pro Power Fusion',
    Retail: '274.99',
    New: '190.00',
    'Like New': '160.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1HWozV-MIOfv_poPVoQBn865t7i-23RcJ/view?usp=sharing',
    'Photo ID': '1HWozV-MIOfv_poPVoQBn865t7i-23RcJ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1HWozV-MIOfv_poPVoQBn865t7i-23RcJ',
  },
  {
    Make: 'Gearbox',
    Model: 'Pro Power Integra',
    Retail: '274.99',
    New: '190.00',
    'Like New': '160.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1RqhNVcDtQV11YvQpUW4tf2MThBv45hpu/view?usp=sharing',
    'Photo ID': '1RqhNVcDtQV11YvQpUW4tf2MThBv45hpu',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1RqhNVcDtQV11YvQpUW4tf2MThBv45hpu',
  },
  {
    Make: 'Gearbox',
    Model: 'Pro Ultimate Elongated',
    Retail: '274.99',
    New: '190.00',
    'Like New': '160.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/13YrcSRLK5mDmRLIDKUN_uicjZbH49_LL/view?usp=sharing',
    'Photo ID': '13YrcSRLK5mDmRLIDKUN_uicjZbH49_LL',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=13YrcSRLK5mDmRLIDKUN_uicjZbH49_LL',
  },
  {
    Make: 'Gearbox',
    Model: 'Pro Ultimate Hyper',
    Retail: '274.99',
    New: '190.00',
    'Like New': '160.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1IFBa70whxuTPTfKlQzyEUc9_GoXxD6Qd/view?usp=sharing',
    'Photo ID': '1IFBa70whxuTPTfKlQzyEUc9_GoXxD6Qd',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1IFBa70whxuTPTfKlQzyEUc9_GoXxD6Qd',
  },
  {
    Make: 'GRUVN',
    Model: '16E',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/12rR0bNIIMOxpku1ppaO7aesQMeUAgjQp/view?usp=sharing',
    'Photo ID': '12rR0bNIIMOxpku1ppaO7aesQMeUAgjQp',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=12rR0bNIIMOxpku1ppaO7aesQMeUAgjQp',
  },
  {
    Make: 'GRUVN',
    Model: '16H',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1y22Tmpgmp-gPF04tajIuZxvt3q3zU1J6/view?usp=sharing',
    'Photo ID': '1y22Tmpgmp-gPF04tajIuZxvt3q3zU1J6',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1y22Tmpgmp-gPF04tajIuZxvt3q3zU1J6',
  },
  {
    Make: 'GRUVN',
    Model: 'CRUZ 16H',
    Retail: '129.00',
    New: '90.00',
    'Like New': '75.00',
    Good: '60.00',
    'Photo URL': 'https://drive.google.com/file/d/1lOl3XogpNLi5I9XgH0Js4QW91-KAV_Zj/view?usp=sharing',
    'Photo ID': '1lOl3XogpNLi5I9XgH0Js4QW91-KAV_Zj',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1lOl3XogpNLi5I9XgH0Js4QW91-KAV_Zj',
  },
  {
    Make: 'GRUVN',
    Model: 'CRUZ 16S',
    Retail: '129.00',
    New: '90.00',
    'Like New': '75.00',
    Good: '60.00',
    'Photo URL': 'https://drive.google.com/file/d/1_j_TuZbv7M17YDvURb5bD4x1lYCMlo_g/view?usp=sharing',
    'Photo ID': '1_j_TuZbv7M17YDvURb5bD4x1lYCMlo_g',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1_j_TuZbv7M17YDvURb5bD4x1lYCMlo_g',
  },
  {
    Make: 'GRUVN',
    Model: 'CRUZ 16X',
    Retail: '129.00',
    New: '90.00',
    'Like New': '75.00',
    Good: '60.00',
    'Photo URL': 'https://drive.google.com/file/d/1dHv5W42-P96n_a3GU_5rxpxVj3gu09OE/view?usp=sharing',
    'Photo ID': '1dHv5W42-P96n_a3GU_5rxpxVj3gu09OE',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1dHv5W42-P96n_a3GU_5rxpxVj3gu09OE',
  },
  {
    Make: 'GRUVN',
    Model: 'LAZR 16S',
    Retail: '169.00',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1-svHPJYqJ0WEM-vLdbF-cF8pB6AyXiot/view?usp=sharing',
    'Photo ID': '1-svHPJYqJ0WEM-vLdbF-cF8pB6AyXiot',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1-svHPJYqJ0WEM-vLdbF-cF8pB6AyXiot',
  },
  {
    Make: 'GRUVN',
    Model: 'LAZR 16X',
    Retail: '169.00',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1MQ43PrihqXDVJHXxNyLaIUrWHQb4JLjx/view?usp=sharing',
    'Photo ID': '1MQ43PrihqXDVJHXxNyLaIUrWHQb4JLjx',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1MQ43PrihqXDVJHXxNyLaIUrWHQb4JLjx',
  },
  {
    Make: 'GRUVN',
    Model: 'MUVN 13S',
    Retail: '159.00',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1Q-_np8NnYcGiPBFUMVV498xxeWcABu2j/view?usp=sharing',
    'Photo ID': '1Q-_np8NnYcGiPBFUMVV498xxeWcABu2j',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Q-_np8NnYcGiPBFUMVV498xxeWcABu2j',
  },
  {
    Make: 'GRUVN',
    Model: 'MUVN 16S',
    Retail: '159.00',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1zSmpWX0lSIMf51C_KhX9YuoLgiDoHPxQ/view?usp=sharing',
    'Photo ID': '1zSmpWX0lSIMf51C_KhX9YuoLgiDoHPxQ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1zSmpWX0lSIMf51C_KhX9YuoLgiDoHPxQ',
  },
  {
    Make: 'GRUVN',
    Model: 'MUVN 16X',
    Retail: '159.00',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1m2yGm7MVy6QlO4Xv1rLu9EEs7hYvRCb2/view?usp=sharing',
    'Photo ID': '1m2yGm7MVy6QlO4Xv1rLu9EEs7hYvRCb2',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1m2yGm7MVy6QlO4Xv1rLu9EEs7hYvRCb2',
  },
  {
    Make: 'Gryp',
    Model: 'Balance 1',
    Retail: '200.00',
    New: '140.00',
    'Like New': '120.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/1eDLQaNVxHvBcilsbi1xmVXdNlsc_UfRU/view?usp=sharing',
    'Photo ID': '1eDLQaNVxHvBcilsbi1xmVXdNlsc_UfRU',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1eDLQaNVxHvBcilsbi1xmVXdNlsc_UfRU',
  },
  {
    Make: 'Gryp',
    Model: 'Balance 2',
    Retail: '200.00',
    New: '140.00',
    'Like New': '120.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/1TrN-B4lng8Q_IxqNlyct0LoHqzpvHSns/view?usp=sharing',
    'Photo ID': '1TrN-B4lng8Q_IxqNlyct0LoHqzpvHSns',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1TrN-B4lng8Q_IxqNlyct0LoHqzpvHSns',
  },
  {
    Make: 'Head',
    Model: 'Boom Team EX',
    Retail: '99.95',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1sWoX1LK71tyiTlap-cakGCW91XYckABO/view?usp=sharing',
    'Photo ID': '1sWoX1LK71tyiTlap-cakGCW91XYckABO',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1sWoX1LK71tyiTlap-cakGCW91XYckABO',
  },
  {
    Make: 'Head',
    Model: 'Boom Tour EX',
    Retail: '169.95',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1mvLvu62iae1sL66WzcCAI0Ya-KsyiVHP/view?usp=sharing',
    'Photo ID': '1mvLvu62iae1sL66WzcCAI0Ya-KsyiVHP',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1mvLvu62iae1sL66WzcCAI0Ya-KsyiVHP',
  },
  {
    Make: 'Head',
    Model: 'Extreme Elite',
    Retail: '64.95',
    New: '45.00',
    'Like New': '35.00',
    Good: '30.00',
    'Photo URL': 'https://drive.google.com/file/d/1jtyIqxJ00JM0JHcbf1S2bQ96mDuPnnQe/view?usp=sharing',
    'Photo ID': '1jtyIqxJ00JM0JHcbf1S2bQ96mDuPnnQe',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1jtyIqxJ00JM0JHcbf1S2bQ96mDuPnnQe',
  },
  {
    Make: 'Head',
    Model: 'Extreme Tour Max',
    Retail: '149.95',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/14XzYylLTf7pq-vNywii6JGxf_c8WG563/view?usp=sharing',
    'Photo ID': '14XzYylLTf7pq-vNywii6JGxf_c8WG563',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=14XzYylLTf7pq-vNywii6JGxf_c8WG563',
  },
  {
    Make: 'Head',
    Model: 'Gravity LH',
    Retail: '189.95',
    New: '130.00',
    'Like New': '110.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1lDZItKxFy6y47mQr8Sf6ruqBESUSjHLR/view?usp=sharing',
    'Photo ID': '1lDZItKxFy6y47mQr8Sf6ruqBESUSjHLR',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1lDZItKxFy6y47mQr8Sf6ruqBESUSjHLR',
  },
  {
    Make: 'Head',
    Model: 'Gravity SH',
    Retail: '189.95',
    New: '130.00',
    'Like New': '110.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1Q-_PNDs_gNG8SoWxhnqjBHHT_Q9QUhad/view?usp=sharing',
    'Photo ID': '1Q-_PNDs_gNG8SoWxhnqjBHHT_Q9QUhad',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Q-_PNDs_gNG8SoWxhnqjBHHT_Q9QUhad',
  },
  {
    Make: 'Head',
    Model: 'Gravity Tour',
    Retail: '149.95',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1EE2ROfDcfiFmZ3QJHCLMp5adwgoeBDF7/view?usp=sharing',
    'Photo ID': '1EE2ROfDcfiFmZ3QJHCLMp5adwgoeBDF7',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1EE2ROfDcfiFmZ3QJHCLMp5adwgoeBDF7',
  },
  {
    Make: 'Head',
    Model: 'Radical Elite',
    Retail: '69.95',
    New: '45.00',
    'Like New': '40.00',
    Good: '30.00',
    'Photo URL': 'https://drive.google.com/file/d/1IgPhYo6WJ3VpGuAWa4GAxslQAEY4NqHd/view?usp=sharing',
    'Photo ID': '1IgPhYo6WJ3VpGuAWa4GAxslQAEY4NqHd',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1IgPhYo6WJ3VpGuAWa4GAxslQAEY4NqHd',
  },
  {
    Make: 'Head',
    Model: 'Radical Nite',
    Retail: '219.95',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1LO0_M8G3ON3Yjh2RpzN07NtvubJN6j2P/view?usp=sharing',
    'Photo ID': '1LO0_M8G3ON3Yjh2RpzN07NtvubJN6j2P',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1LO0_M8G3ON3Yjh2RpzN07NtvubJN6j2P',
  },
  {
    Make: 'Head',
    Model: 'Radical Pro',
    Retail: '99.95',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1iZOszUIiePFTTwWK2J3RX-HsCVYwxzBF/view?usp=sharing',
    'Photo ID': '1iZOszUIiePFTTwWK2J3RX-HsCVYwxzBF',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1iZOszUIiePFTTwWK2J3RX-HsCVYwxzBF',
  },
  {
    Make: 'Head',
    Model: 'Radical Tour CO',
    Retail: '149.95',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1uiOLmeMMCDMOjzTqq70tCUtbw_ABIryD/view?usp=sharing',
    'Photo ID': '1uiOLmeMMCDMOjzTqq70tCUtbw_ABIryD',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1uiOLmeMMCDMOjzTqq70tCUtbw_ABIryD',
  },
  {
    Make: 'Head',
    Model: 'Radical Tour GR',
    Retail: '139.95',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/1ECoDyBczQvIw_rDHV6gtDWhoL4qoEzym/view?usp=sharing',
    'Photo ID': '1ECoDyBczQvIw_rDHV6gtDWhoL4qoEzym',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ECoDyBczQvIw_rDHV6gtDWhoL4qoEzym',
  },
  {
    Make: 'Head',
    Model: 'Radical Tour Raw',
    Retail: '149.95',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1-6apYMg4Do-fm3v7mERCZVfO-kSpldyb/view?usp=sharing',
    'Photo ID': '1-6apYMg4Do-fm3v7mERCZVfO-kSpldyb',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1-6apYMg4Do-fm3v7mERCZVfO-kSpldyb',
  },
  {
    Make: 'Head',
    Model: 'Radical Tour Raw EX',
    Retail: '119.95',
    New: '80.00',
    'Like New': '70.00',
    Good: '55.00',
    'Photo URL': 'https://drive.google.com/file/d/1BUSDqb8YpivL0h7fhWnaDCvK1nyMQgn6/view?usp=sharing',
    'Photo ID': '1BUSDqb8YpivL0h7fhWnaDCvK1nyMQgn6',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1BUSDqb8YpivL0h7fhWnaDCvK1nyMQgn6',
  },
  {
    Make: 'Holbrook',
    Model: 'Aero - Kevlar T',
    Retail: '219.99',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/10mt6oiWzddZ04k8XjIZ-5jwQ_oJjM2oh/view?usp=sharing',
    'Photo ID': '10mt6oiWzddZ04k8XjIZ-5jwQ_oJjM2oh',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=10mt6oiWzddZ04k8XjIZ-5jwQ_oJjM2oh',
  },
  {
    Make: 'Holbrook',
    Model: 'Aero - Metallic T',
    Retail: '219.99',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1y3ISb9PLikG_j0UtyL0Zck5Rz8WUPFbd/view?usp=sharing',
    'Photo ID': '1y3ISb9PLikG_j0UtyL0Zck5Rz8WUPFbd',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1y3ISb9PLikG_j0UtyL0Zck5Rz8WUPFbd',
  },
  {
    Make: 'Holbrook',
    Model: 'Aero - S',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1KiZdW1LTXWVK2TFn2nZWCcIV8crybuvM/view?usp=sharing',
    'Photo ID': '1KiZdW1LTXWVK2TFn2nZWCcIV8crybuvM',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1KiZdW1LTXWVK2TFn2nZWCcIV8crybuvM',
  },
  {
    Make: 'Holbrook',
    Model: 'Aero - T',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1aTWAL47W5qPSRSY232vteCG7ntu7o34t/view?usp=sharing',
    'Photo ID': '1aTWAL47W5qPSRSY232vteCG7ntu7o34t',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1aTWAL47W5qPSRSY232vteCG7ntu7o34t',
  },
  {
    Make: 'Holbrook',
    Model: 'Aero - X',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/17jeVmyNcVpZEeV6FV3tNvvNCScIJMC9R/view?usp=sharing',
    'Photo ID': '17jeVmyNcVpZEeV6FV3tNvvNCScIJMC9R',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=17jeVmyNcVpZEeV6FV3tNvvNCScIJMC9R',
  },
  {
    Make: 'Holbrook',
    Model: 'Arma S 14mm',
    Retail: '259.99',
    New: '180.00',
    'Like New': '155.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1l3moaJMzFaLZqDPSFtJHBw-zzImtk-d9/view?usp=sharing',
    'Photo ID': '1l3moaJMzFaLZqDPSFtJHBw-zzImtk-d9',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1l3moaJMzFaLZqDPSFtJHBw-zzImtk-d9',
  },
  {
    Make: 'Holbrook',
    Model: 'Arma S Metallic 14mm',
    Retail: '279.99',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1WoQcIZQIkPPyeooKAuR74bio3GxXLEVw/view?usp=sharing',
    'Photo ID': '1WoQcIZQIkPPyeooKAuR74bio3GxXLEVw',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1WoQcIZQIkPPyeooKAuR74bio3GxXLEVw',
  },
  {
    Make: 'Holbrook',
    Model: 'Arma T 14mm',
    Retail: '259.99',
    New: '180.00',
    'Like New': '155.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1hAZ-IPRbvDGMyGuOnDQLUPziSSqi_M_G/view?usp=sharing',
    'Photo ID': '1hAZ-IPRbvDGMyGuOnDQLUPziSSqi_M_G',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1hAZ-IPRbvDGMyGuOnDQLUPziSSqi_M_G',
  },
  {
    Make: 'Holbrook',
    Model: 'Arma T Metallic 14mm',
    Retail: '279.99',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1v_oJJt4eKbup5ynS-skHtn_k9SAxiu3d/view?usp=sharing',
    'Photo ID': '1v_oJJt4eKbup5ynS-skHtn_k9SAxiu3d',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1v_oJJt4eKbup5ynS-skHtn_k9SAxiu3d',
  },
  {
    Make: 'Holbrook',
    Model: 'Arma X Metallic 14mm',
    Retail: '279.99',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/11wcOJ6I9erX53rYYUapSb3rqOSSwrBh6/view?usp=sharing',
    'Photo ID': '11wcOJ6I9erX53rYYUapSb3rqOSSwrBh6',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=11wcOJ6I9erX53rYYUapSb3rqOSSwrBh6',
  },
  {
    Make: 'Holbrook',
    Model: 'Fuze',
    Retail: '229.99',
    New: '160.00',
    'Like New': '135.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1ogu5DZ8ihRpjg4-y3KrKkFhLS4sXXClX/view?usp=drive_link',
    'Photo ID': '1ogu5DZ8ihRpjg4-y3KrKkFhLS4sXXClX',
    GTIN: '850045898717',
  },
  {
    Make: 'Holbrook',
    Model: 'Performance - Centre Court',
    Retail: '79.99',
    New: '55.00',
    'Like New': '45.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/1w1hWSh-ky9-1Rr76XClrVO9WLV9nAhdS/view?usp=sharing',
    'Photo ID': '1w1hWSh-ky9-1Rr76XClrVO9WLV9nAhdS',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1w1hWSh-ky9-1Rr76XClrVO9WLV9nAhdS',
  },
  {
    Make: 'Holbrook',
    Model: 'Performance - Day N Night',
    Retail: '79.99',
    New: '55.00',
    'Like New': '45.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/1qJ3rZg_1xTY98O8pQ_Mnxqhxxt-MgIc8/view?usp=sharing',
    'Photo ID': '1qJ3rZg_1xTY98O8pQ_Mnxqhxxt-MgIc8',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1qJ3rZg_1xTY98O8pQ_Mnxqhxxt-MgIc8',
  },
  {
    Make: 'Holbrook',
    Model: 'Performance - Malibu',
    Retail: '79.99',
    New: '55.00',
    'Like New': '45.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/1qq3sjGTIeiED-J73qg8TqNEIObZqGxQD/view?usp=sharing',
    'Photo ID': '1qq3sjGTIeiED-J73qg8TqNEIObZqGxQD',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1qq3sjGTIeiED-J73qg8TqNEIObZqGxQD',
  },
  {
    Make: 'Holbrook',
    Model: 'Performance - Rewind',
    Retail: '79.99',
    New: '55.00',
    'Like New': '45.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/1iHt0hPETdZ8YDubyMf7QIEeSSevZ8_tx/view?usp=sharing',
    'Photo ID': '1iHt0hPETdZ8YDubyMf7QIEeSSevZ8_tx',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1iHt0hPETdZ8YDubyMf7QIEeSSevZ8_tx',
  },
  {
    Make: 'Holbrook',
    Model: 'Performance - SoHo',
    Retail: '79.99',
    New: '55.00',
    'Like New': '45.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/1Et1i1LnLo-1u-6Rp4rdkrbxxcjOkxioL/view?usp=sharing',
    'Photo ID': '1Et1i1LnLo-1u-6Rp4rdkrbxxcjOkxioL',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Et1i1LnLo-1u-6Rp4rdkrbxxcjOkxioL',
  },
  {
    Make: 'Holbrook',
    Model: 'Pro - Mav Pro',
    Retail: '219.99',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1S0YFFLYGRTwQdAyBV580SNjKF--_VRhX/view?usp=sharing',
    'Photo ID': '1S0YFFLYGRTwQdAyBV580SNjKF--_VRhX',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1S0YFFLYGRTwQdAyBV580SNjKF--_VRhX',
  },
  {
    Make: 'Holbrook',
    Model: 'Pro - Power Pro',
    Retail: '219.99',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1Seagcrapob75_5ROrVM_kslqpIj2JCNm/view?usp=sharing',
    'Photo ID': '1Seagcrapob75_5ROrVM_kslqpIj2JCNm',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Seagcrapob75_5ROrVM_kslqpIj2JCNm',
  },
  {
    Make: 'Holbrook',
    Model: 'Pro - Power Pro E',
    Retail: '219.99',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/15veB-k-I1-WGbz2BdAhJDpeMmIfXttrR/view?usp=sharing',
    'Photo ID': '15veB-k-I1-WGbz2BdAhJDpeMmIfXttrR',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=15veB-k-I1-WGbz2BdAhJDpeMmIfXttrR',
  },
  {
    Make: 'Holbrook',
    Model: 'Sport - Alta',
    Retail: '59.99',
    New: '40.00',
    'Like New': '35.00',
    Good: '25.00',
    'Photo URL': 'https://drive.google.com/file/d/1qYxD1bwqDcCL9dYO0xKoAiwfLVgJp566/view?usp=sharing',
    'Photo ID': '1qYxD1bwqDcCL9dYO0xKoAiwfLVgJp566',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1qYxD1bwqDcCL9dYO0xKoAiwfLVgJp566',
  },
  {
    Make: 'Holbrook',
    Model: 'Sport - Dune',
    Retail: '59.99',
    New: '40.00',
    'Like New': '35.00',
    Good: '25.00',
    'Photo URL': 'https://drive.google.com/file/d/1etyVAXVEb_ZjOwOQ8TKXPYG1lOdVhMLa/view?usp=sharing',
    'Photo ID': '1etyVAXVEb_ZjOwOQ8TKXPYG1lOdVhMLa',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1etyVAXVEb_ZjOwOQ8TKXPYG1lOdVhMLa',
  },
  {
    Make: 'Holbrook',
    Model: 'Sport - Midnight',
    Retail: '59.99',
    New: '40.00',
    'Like New': '35.00',
    Good: '25.00',
    'Photo URL': 'https://drive.google.com/file/d/1vfe365ACH9w87dQ_rGVh8x1NMlvYbKtj/view?usp=sharing',
    'Photo ID': '1vfe365ACH9w87dQ_rGVh8x1NMlvYbKtj',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1vfe365ACH9w87dQ_rGVh8x1NMlvYbKtj',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J1',
    Retail: '185.00',
    New: '125.00',
    'Like New': '110.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1FdJK0rT25JUrw7qsfCkmPIVcn2OKgsgf/view?usp=sharing',
    'Photo ID': '1FdJK0rT25JUrw7qsfCkmPIVcn2OKgsgf',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1FdJK0rT25JUrw7qsfCkmPIVcn2OKgsgf',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J1H',
    Retail: '185.00',
    New: '125.00',
    'Like New': '110.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/16O-GCv8Mu41tnVqQMkzR9pDvcJv_OVUW/view?usp=sharing',
    'Photo ID': '16O-GCv8Mu41tnVqQMkzR9pDvcJv_OVUW',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=16O-GCv8Mu41tnVqQMkzR9pDvcJv_OVUW',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J2',
    Retail: '145.00',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1h4Stu3hCMThYaw4MBy_vpiBqjnaxqxKD/view?usp=sharing',
    'Photo ID': '1h4Stu3hCMThYaw4MBy_vpiBqjnaxqxKD',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1h4Stu3hCMThYaw4MBy_vpiBqjnaxqxKD',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J2 Ti',
    Retail: '155.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1LqP3mWOicP8xQbt7EhTRfFSGq73VvuUE/view?usp=sharing',
    'Photo ID': '1LqP3mWOicP8xQbt7EhTRfFSGq73VvuUE',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1LqP3mWOicP8xQbt7EhTRfFSGq73VvuUE',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J2 Ti+',
    Retail: '165.00',
    New: '115.00',
    'Like New': '95.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1RG4_79qnr7xDNpRvwgyIivY8ohWPngNy/view?usp=sharing',
    'Photo ID': '1RG4_79qnr7xDNpRvwgyIivY8ohWPngNy',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1RG4_79qnr7xDNpRvwgyIivY8ohWPngNy',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J2FC+',
    Retail: '195.00',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1TAtfiAuGPGzlkpiM9hq54OScWrsHBDbi/view?usp=sharing',
    'Photo ID': '1TAtfiAuGPGzlkpiM9hq54OScWrsHBDbi',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1TAtfiAuGPGzlkpiM9hq54OScWrsHBDbi',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J2K 14mm',
    Retail: '165.00',
    New: '115.00',
    'Like New': '95.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1101g0rhElZUuRzWV9XswD0zALHg4O9ch/view?usp=sharing',
    'Photo ID': '1101g0rhElZUuRzWV9XswD0zALHg4O9ch',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1101g0rhElZUuRzWV9XswD0zALHg4O9ch',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J2K 16mm',
    Retail: '155.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1FAEW2dwmRCalb-x_YRWdqW4_6_1hAyE4/view?usp=sharing',
    'Photo ID': '1FAEW2dwmRCalb-x_YRWdqW4_6_1hAyE4',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1FAEW2dwmRCalb-x_YRWdqW4_6_1hAyE4',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J2K Pro',
    Retail: '165.00',
    New: '115.00',
    'Like New': '95.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/16V2t9Bsk_5YoEEcj6R6m23ba_qTFUWzA/view?usp=sharing',
    'Photo ID': '16V2t9Bsk_5YoEEcj6R6m23ba_qTFUWzA',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=16V2t9Bsk_5YoEEcj6R6m23ba_qTFUWzA',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J2K+',
    Retail: '165.00',
    New: '115.00',
    'Like New': '95.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1shIsxLTxcEOGEfRqJypTIvTcinB5S_4e/view?usp=sharing',
    'Photo ID': '1shIsxLTxcEOGEfRqJypTIvTcinB5S_4e',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1shIsxLTxcEOGEfRqJypTIvTcinB5S_4e',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J2NF',
    Retail: '195.00',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1EFcugm7MLzdOxHPiS0XTUa5BKkV-VC-_/view?usp=sharing',
    'Photo ID': '1EFcugm7MLzdOxHPiS0XTUa5BKkV-VC-_',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1EFcugm7MLzdOxHPiS0XTUa5BKkV-VC-_',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J2NFK',
    Retail: '195.00',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/17vdgZDG-SgnVmosANtyUvmiWFaRXm--m/view?usp=sharing',
    'Photo ID': '17vdgZDG-SgnVmosANtyUvmiWFaRXm--m',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=17vdgZDG-SgnVmosANtyUvmiWFaRXm--m',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J2NFT',
    Retail: '195.00',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1vQsYuadNQJsUKukYKhNSrBkQD4HyHtkT/view?usp=sharing',
    'Photo ID': '1vQsYuadNQJsUKukYKhNSrBkQD4HyHtkT',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1vQsYuadNQJsUKukYKhNSrBkQD4HyHtkT',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J2XK',
    Retail: '155.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1MOVeM0MmzkqT5WLdc_baM6-y1JFhjJtQ/view?usp=sharing',
    'Photo ID': '1MOVeM0MmzkqT5WLdc_baM6-y1JFhjJtQ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1MOVeM0MmzkqT5WLdc_baM6-y1JFhjJtQ',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J3',
    Retail: '145.00',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/19ATM3Ve69dNTCfRe0Tit5YmuuxkEVZO9/view?usp=sharing',
    'Photo ID': '19ATM3Ve69dNTCfRe0Tit5YmuuxkEVZO9',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=19ATM3Ve69dNTCfRe0Tit5YmuuxkEVZO9',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J3 Ti',
    Retail: '155.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1fhfP2uKL6XRQZGjjMQeI13UZiapZh8pT/view?usp=sharing',
    'Photo ID': '1fhfP2uKL6XRQZGjjMQeI13UZiapZh8pT',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1fhfP2uKL6XRQZGjjMQeI13UZiapZh8pT',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J3K',
    Retail: '155.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1Z-KfOnx-T69DBQ8dBKz0nzNATBRS99LS/view?usp=sharing',
    'Photo ID': '1Z-KfOnx-T69DBQ8dBKz0nzNATBRS99LS',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Z-KfOnx-T69DBQ8dBKz0nzNATBRS99LS',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J3K Pro',
    Retail: '165.00',
    New: '115.00',
    'Like New': '95.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1FC7C87C1ryJmz8gYjYKOLGnW8w4DXJMQ/view?usp=sharing',
    'Photo ID': '1FC7C87C1ryJmz8gYjYKOLGnW8w4DXJMQ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1FC7C87C1ryJmz8gYjYKOLGnW8w4DXJMQ',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J5',
    Retail: '165.00',
    New: '115.00',
    'Like New': '95.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1BzTK_wKfzac-_kHZ2RFh0Ojn5LC77cbt/view?usp=sharing',
    'Photo ID': '1BzTK_wKfzac-_kHZ2RFh0Ojn5LC77cbt',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1BzTK_wKfzac-_kHZ2RFh0Ojn5LC77cbt',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J6CR',
    Retail: '195.00',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1dm2Byvubkrs_MB_NERu2-kN2xHn1VlOA/view?usp=sharing',
    'Photo ID': '1dm2Byvubkrs_MB_NERu2-kN2xHn1VlOA',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1dm2Byvubkrs_MB_NERu2-kN2xHn1VlOA',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J6CR',
    Retail: '195.00',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1vckrrI7VI2HqfEEqwrAWX4eGekcMK4Wn/view?usp=drive_link',
    'Photo ID': '1vckrrI7VI2HqfEEqwrAWX4eGekcMK4Wn',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J6FC+',
    Retail: '195.00',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1sNRKqAvJcY-_OmRz1TCcGGpFSeeiyJCf/view?usp=sharing',
    'Photo ID': '1sNRKqAvJcY-_OmRz1TCcGGpFSeeiyJCf',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1sNRKqAvJcY-_OmRz1TCcGGpFSeeiyJCf',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J6NF',
    Retail: '195.00',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1N3ZL1vPpJDmMf6yr37jVMLxnxnday68j/view?usp=sharing',
    'Photo ID': '1N3ZL1vPpJDmMf6yr37jVMLxnxnday68j',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1N3ZL1vPpJDmMf6yr37jVMLxnxnday68j',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J7K',
    Retail: '155.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1Pn8OTgb1ThhZBKJwyjC0DJMye4a8OLll/view?usp=sharing',
    'Photo ID': '1Pn8OTgb1ThhZBKJwyjC0DJMye4a8OLll',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Pn8OTgb1ThhZBKJwyjC0DJMye4a8OLll',
  },
  {
    Make: 'Honolulu Pickleball',
    Model: 'J7K Pro',
    Retail: '165.00',
    New: '115.00',
    'Like New': '95.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1BUyqrYZy6DvxzjDLkwj9-XwVGwwRpXfp/view?usp=sharing',
    'Photo ID': '1BUyqrYZy6DvxzjDLkwj9-XwVGwwRpXfp',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1BUyqrYZy6DvxzjDLkwj9-XwVGwwRpXfp',
  },
  {
    Make: 'Hudef',
    Model: 'Apex Pro',
    Retail: '89.00',
    New: '60.00',
    'Like New': '50.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1ghsTvqrUF3mug6_7LlRx7HlDzzU6wJly/view?usp=sharing',
    'Photo ID': '1ghsTvqrUF3mug6_7LlRx7HlDzzU6wJly',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ghsTvqrUF3mug6_7LlRx7HlDzzU6wJly',
  },
  {
    Make: 'Hudef',
    Model: 'Future',
    Retail: '130.00',
    New: '90.00',
    'Like New': '75.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/1a1yDZz8YTnYWPcBoCgTvZAwJ8Xl0WNmf/view?usp=sharing',
    'Photo ID': '1a1yDZz8YTnYWPcBoCgTvZAwJ8Xl0WNmf',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1a1yDZz8YTnYWPcBoCgTvZAwJ8Xl0WNmf',
  },
  {
    Make: 'Hudef',
    Model: 'HD4.0',
    Retail: '79.00',
    New: '55.00',
    'Like New': '45.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/1Qz0fgDjaXGg-5idn84AIVKjJak0_WgCM/view?usp=sharing',
    'Photo ID': '1Qz0fgDjaXGg-5idn84AIVKjJak0_WgCM',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Qz0fgDjaXGg-5idn84AIVKjJak0_WgCM',
  },
  {
    Make: 'Hudef',
    Model: 'HD4.1',
    Retail: '79.00',
    New: '55.00',
    'Like New': '45.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/17q9dJ4_qKELPu-tntQbEqnvM2BIcEzra/view?usp=sharing',
    'Photo ID': '17q9dJ4_qKELPu-tntQbEqnvM2BIcEzra',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=17q9dJ4_qKELPu-tntQbEqnvM2BIcEzra',
  },
  {
    Make: 'Hudef',
    Model: 'HD4.2',
    Retail: '79.00',
    New: '55.00',
    'Like New': '45.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/1Mg741oZVEPzkgvD6C5h5vHPPV4fSmUyC/view?usp=sharing',
    'Photo ID': '1Mg741oZVEPzkgvD6C5h5vHPPV4fSmUyC',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Mg741oZVEPzkgvD6C5h5vHPPV4fSmUyC',
  },
  {
    Make: 'Hudef',
    Model: 'HD4.3',
    Retail: '79.00',
    New: '55.00',
    'Like New': '45.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/19eotAn4ap7-60XWNv9sIhcpQ3ycDNsoj/view?usp=sharing',
    'Photo ID': '19eotAn4ap7-60XWNv9sIhcpQ3ycDNsoj',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=19eotAn4ap7-60XWNv9sIhcpQ3ycDNsoj',
  },
  {
    Make: 'Hudef',
    Model: 'HD4.5',
    Retail: '79.00',
    New: '55.00',
    'Like New': '45.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/1xbJKJz08yImwGghD3MVLdnil9n8699uz/view?usp=sharing',
    'Photo ID': '1xbJKJz08yImwGghD3MVLdnil9n8699uz',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1xbJKJz08yImwGghD3MVLdnil9n8699uz',
  },
  {
    Make: 'Hudef',
    Model: 'HD5',
    Retail: '79.00',
    New: '55.00',
    'Like New': '45.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/1ei7XTnAWdQULix8J0uWs-zyIiWrBRhpB/view?usp=sharing',
    'Photo ID': '1ei7XTnAWdQULix8J0uWs-zyIiWrBRhpB',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ei7XTnAWdQULix8J0uWs-zyIiWrBRhpB',
  },
  {
    Make: 'Hudef',
    Model: 'HD6.6',
    Retail: '110.00',
    New: '75.00',
    'Like New': '65.00',
    Good: '55.00',
    'Photo URL': 'https://drive.google.com/file/d/1MHUrq1NglchddBJwJN08HvSOAnnimaT-/view?usp=sharing',
    'Photo ID': '1MHUrq1NglchddBJwJN08HvSOAnnimaT-',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1MHUrq1NglchddBJwJN08HvSOAnnimaT-',
  },
  {
    Make: 'Hudef',
    Model: 'HD6.8',
    Retail: '110.00',
    New: '75.00',
    'Like New': '65.00',
    Good: '55.00',
    'Photo URL': 'https://drive.google.com/file/d/1ZZCs4CvomD9uDFQhjDuYh4DRRtPzZ74P/view?usp=sharing',
    'Photo ID': '1ZZCs4CvomD9uDFQhjDuYh4DRRtPzZ74P',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ZZCs4CvomD9uDFQhjDuYh4DRRtPzZ74P',
  },
  {
    Make: 'Hudef',
    Model: 'Mage Pro',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1pKHAqu9GoKlBLxsnVSewrqCFREZmh9Y5/view?usp=sharing',
    'Photo ID': '1pKHAqu9GoKlBLxsnVSewrqCFREZmh9Y5',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1pKHAqu9GoKlBLxsnVSewrqCFREZmh9Y5',
  },
  {
    Make: 'Hudef',
    Model: 'Mage Pro Gen2',
    Retail: '169.99',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1yVkIXtfp4CN36_RV25qohCBO4thbie_x/view?usp=sharing',
    'Photo ID': '1yVkIXtfp4CN36_RV25qohCBO4thbie_x',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1yVkIXtfp4CN36_RV25qohCBO4thbie_x',
  },
  {
    Make: 'Hudef',
    Model: 'Newera',
    Retail: '130.00',
    New: '90.00',
    'Like New': '75.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/15jwpiwP3DqrfPf94DhtWL2XZarDD1aIa/view?usp=sharing',
    'Photo ID': '15jwpiwP3DqrfPf94DhtWL2XZarDD1aIa',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=15jwpiwP3DqrfPf94DhtWL2XZarDD1aIa',
  },
  {
    Make: 'Hudef',
    Model: 'Viva Pro',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1UjfDY0evavBo4r8S_JNOGc8XMJACHeB9/view?usp=sharing',
    'Photo ID': '1UjfDY0evavBo4r8S_JNOGc8XMJACHeB9',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1UjfDY0evavBo4r8S_JNOGc8XMJACHeB9',
  },
  {
    Make: 'Hudef',
    Model: 'Viva Pro Gen2',
    Retail: '129.99',
    New: '90.00',
    'Like New': '75.00',
    Good: '60.00',
    'Photo URL': 'https://drive.google.com/file/d/15W6y1tDXO7aV8Cmtjp8MXn-ZqyG93gFz/view?usp=sharing',
    'Photo ID': '15W6y1tDXO7aV8Cmtjp8MXn-ZqyG93gFz',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=15W6y1tDXO7aV8Cmtjp8MXn-ZqyG93gFz',
  },
  {
    Make: 'Hudef',
    Model: 'Viva Pro Gen3',
    Retail: '169.99',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1g9GdK73OCEJfEFD2SMVVafuQ-If0Ri0K/view?usp=sharing',
    'Photo ID': '1g9GdK73OCEJfEFD2SMVVafuQ-If0Ri0K',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1g9GdK73OCEJfEFD2SMVVafuQ-If0Ri0K',
  },
  {
    Make: 'Joola',
    Model: 'Agassi Champion 12mm',
    Retail: '59.95',
    New: '40.00',
    'Like New': '35.00',
    Good: '15.00',
    'Photo URL': 'https://drive.google.com/file/d/1xjxJWI2OHjOqOAYFAy7Mgvmsi05k3i9E/view?usp=sharing',
    'Photo ID': '1xjxJWI2OHjOqOAYFAy7Mgvmsi05k3i9E',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1xjxJWI2OHjOqOAYFAy7Mgvmsi05k3i9E',
  },
  {
    Make: 'Joola',
    Model: 'Agassi Edge 16mm',
    Retail: '99.95',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1KiJwdcFdn4QQpUdD8uIZRnfyXyXEravr/view?usp=sharing',
    'Photo ID': '1KiJwdcFdn4QQpUdD8uIZRnfyXyXEravr',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1KiJwdcFdn4QQpUdD8uIZRnfyXyXEravr',
  },
  {
    Make: 'Joola',
    Model: 'Agassi Pro 14mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1YfdBHQDXES7AYlpo9A5UqeR6Di9vG4Gx/view?usp=sharing',
    'Photo ID': '1YfdBHQDXES7AYlpo9A5UqeR6Di9vG4Gx',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1YfdBHQDXES7AYlpo9A5UqeR6Di9vG4Gx',
  },
  {
    Make: 'Joola',
    Model: 'Agassi Pro 16mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/182jpyZKRzFPUuVWswDqh-GZqIKI4RbU1/view?usp=sharing',
    'Photo ID': '182jpyZKRzFPUuVWswDqh-GZqIKI4RbU1',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=182jpyZKRzFPUuVWswDqh-GZqIKI4RbU1',
  },
  {
    Make: 'Joola',
    Model: 'Anna Bright Scorpeus 3S 14mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1LKcavPMq2JkTqIrjP2p247VZCO5imECK/view?usp=sharing',
    'Photo ID': '1LKcavPMq2JkTqIrjP2p247VZCO5imECK',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1LKcavPMq2JkTqIrjP2p247VZCO5imECK',
  },
  {
    Make: 'Joola',
    Model: 'Anna Bright Scorpeus CFS 14',
    Retail: '199.95',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1XzJ3QARrtafhcs56WTj9g2Hm1GvjUrIy/view?usp=sharing',
    'Photo ID': '1XzJ3QARrtafhcs56WTj9g2Hm1GvjUrIy',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1XzJ3QARrtafhcs56WTj9g2Hm1GvjUrIy',
  },
  {
    Make: 'Joola',
    Model: 'Anna Bright Scorpeus Pro IV 14mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1Jt-SphA1AIoJayE2s8pEO1WKh3t_9bM4/view?usp=sharing',
    'Photo ID': '1Jt-SphA1AIoJayE2s8pEO1WKh3t_9bM4',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Jt-SphA1AIoJayE2s8pEO1WKh3t_9bM4',
  },
  {
    Make: 'Joola',
    Model: 'Beacon',
    Retail: '69.95',
    New: '45.00',
    'Like New': '40.00',
    Good: '30.00',
    'Photo URL': 'https://drive.google.com/file/d/1vhSiJUsK5IjNyeftkE9PdD9mWnLcgrVW/view?usp=sharing',
    'Photo ID': '1vhSiJUsK5IjNyeftkE9PdD9mWnLcgrVW',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1vhSiJUsK5IjNyeftkE9PdD9mWnLcgrVW',
  },
  {
    Make: 'Joola',
    Model: 'Ben Johns Hyperion 3S 14mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1rNE-qPAuq9WKvnkYOgNzO1_6okug71L3/view?usp=sharing',
    'Photo ID': '1rNE-qPAuq9WKvnkYOgNzO1_6okug71L3',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1rNE-qPAuq9WKvnkYOgNzO1_6okug71L3',
  },
  {
    Make: 'Joola',
    Model: 'Ben Johns Hyperion 3S 16mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1zMD22AwUBivxTmF2GexvFtb4ZZGBsg1S/view?usp=sharing',
    'Photo ID': '1zMD22AwUBivxTmF2GexvFtb4ZZGBsg1S',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1zMD22AwUBivxTmF2GexvFtb4ZZGBsg1S',
  },
  {
    Make: 'Joola',
    Model: 'Ben Johns Hyperion C2 CFS 14',
    Retail: '199.95',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1WCO3Qtd8VJGcPYxycP5EO5S_P4vBWlnR/view?usp=sharing',
    'Photo ID': '1WCO3Qtd8VJGcPYxycP5EO5S_P4vBWlnR',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1WCO3Qtd8VJGcPYxycP5EO5S_P4vBWlnR',
  },
  {
    Make: 'Joola',
    Model: 'Ben Johns Hyperion C2 CFS 16',
    Retail: '199.95',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1MNodIM0V4b7qCFmlw3NyW1GsOJyNHd9Q/view?usp=sharing',
    'Photo ID': '1MNodIM0V4b7qCFmlw3NyW1GsOJyNHd9Q',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1MNodIM0V4b7qCFmlw3NyW1GsOJyNHd9Q',
  },
  {
    Make: 'Joola',
    Model: 'Ben Johns Hyperion CAS 13.5',
    Retail: '119.95',
    New: '80.00',
    'Like New': '70.00',
    Good: '55.00',
    'Photo URL': 'https://drive.google.com/file/d/18q67shnFo1Ftl0F4a7myf5j8GbYcrsnV/view?usp=sharing',
    'Photo ID': '18q67shnFo1Ftl0F4a7myf5j8GbYcrsnV',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=18q67shnFo1Ftl0F4a7myf5j8GbYcrsnV',
  },
  {
    Make: 'Joola',
    Model: 'Ben Johns Hyperion CAS 16',
    Retail: '119.95',
    New: '80.00',
    'Like New': '70.00',
    Good: '55.00',
    'Photo URL': 'https://drive.google.com/file/d/1jBizK5Uy87Y9AIbNNk2ajaegf1Vi0O03/view?usp=sharing',
    'Photo ID': '1jBizK5Uy87Y9AIbNNk2ajaegf1Vi0O03',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1jBizK5Uy87Y9AIbNNk2ajaegf1Vi0O03',
  },
  {
    Make: 'Joola',
    Model: 'Ben Johns Hyperion CFS 16',
    Retail: '159.95',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/19qgwSZOk-2Su0XoC5i8DGv0FZVSHhgjF/view?usp=sharing',
    'Photo ID': '19qgwSZOk-2Su0XoC5i8DGv0FZVSHhgjF',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=19qgwSZOk-2Su0XoC5i8DGv0FZVSHhgjF',
  },
  {
    Make: 'Joola',
    Model: 'Ben Johns Hyperion Pro IV 14mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1jNFuJQT_4c7-fO5DkrJZbyxmDj-aJkLt/view?usp=sharing',
    'Photo ID': '1jNFuJQT_4c7-fO5DkrJZbyxmDj-aJkLt',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1jNFuJQT_4c7-fO5DkrJZbyxmDj-aJkLt',
  },
  {
    Make: 'Joola',
    Model: 'Ben Johns Hyperion Pro IV 16mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1tJFftmqy2nZOWbX8_hc_ZyHGc84pRAdt/view?usp=sharing',
    'Photo ID': '1tJFftmqy2nZOWbX8_hc_ZyHGc84pRAdt',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1tJFftmqy2nZOWbX8_hc_ZyHGc84pRAdt',
  },
  {
    Make: 'Joola',
    Model: 'Ben Johns Perseus 3S 14mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1xP7AuQ20-J3nhYmsr94xCBrgfQ9-u34F/view?usp=sharing',
    'Photo ID': '1xP7AuQ20-J3nhYmsr94xCBrgfQ9-u34F',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1xP7AuQ20-J3nhYmsr94xCBrgfQ9-u34F',
  },
  {
    Make: 'Joola',
    Model: 'Ben Johns Perseus 3S 16mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1GPgBRy4ssVbLbCxAGJwzlmlXGY3ZimaA/view?usp=sharing',
    'Photo ID': '1GPgBRy4ssVbLbCxAGJwzlmlXGY3ZimaA',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1GPgBRy4ssVbLbCxAGJwzlmlXGY3ZimaA',
  },
  {
    Make: 'Joola',
    Model: 'Ben Johns Perseus CFS 14',
    Retail: '199.95',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1xi7GW9NPdAdcDstwv46cpCn8zIqT6s9k/view?usp=sharing',
    'Photo ID': '1xi7GW9NPdAdcDstwv46cpCn8zIqT6s9k',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1xi7GW9NPdAdcDstwv46cpCn8zIqT6s9k',
  },
  {
    Make: 'Joola',
    Model: 'Ben Johns Perseus CFS 16',
    Retail: '199.95',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1UO-lwAVeBz8G_ObTSIEhpebZP1u45_fk/view?usp=sharing',
    'Photo ID': '1UO-lwAVeBz8G_ObTSIEhpebZP1u45_fk',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1UO-lwAVeBz8G_ObTSIEhpebZP1u45_fk',
  },
  {
    Make: 'Joola',
    Model: 'Ben Johns Perseus Pro IV 14mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1dqkQ9Ga9EEyaTHiEcgiaaxTrZYMrKCeC/view?usp=sharing',
    'Photo ID': '1dqkQ9Ga9EEyaTHiEcgiaaxTrZYMrKCeC',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1dqkQ9Ga9EEyaTHiEcgiaaxTrZYMrKCeC',
  },
  {
    Make: 'Joola',
    Model: 'Ben Johns Perseus Pro IV 16mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/13v_3nua7w4tPrCZ4AicA5mTnT-NCPoBH/view?usp=sharing',
    'Photo ID': '13v_3nua7w4tPrCZ4AicA5mTnT-NCPoBH',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=13v_3nua7w4tPrCZ4AicA5mTnT-NCPoBH',
  },
  {
    Make: 'Joola',
    Model: 'Collin Johns Scorpeus 3S 16mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/15ixVqhjBBvXHNNsMARbvSKJ_GiELdIrD/view?usp=sharing',
    'Photo ID': '15ixVqhjBBvXHNNsMARbvSKJ_GiELdIrD',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=15ixVqhjBBvXHNNsMARbvSKJ_GiELdIrD',
  },
  {
    Make: 'Joola',
    Model: 'Collin Johns Scorpeus CFS 16',
    Retail: '199.95',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1dnAD-m1IBZqFIcTKKOyQFfuxMQM67ymu/view?usp=sharing',
    'Photo ID': '1dnAD-m1IBZqFIcTKKOyQFfuxMQM67ymu',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1dnAD-m1IBZqFIcTKKOyQFfuxMQM67ymu',
  },
  {
    Make: 'Joola',
    Model: 'Collin Johns Scorpeus Pro IV 16mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1mtHGVYmQwT6vdSElBDL8MHxz7dvG3_8K/view?usp=sharing',
    'Photo ID': '1mtHGVYmQwT6vdSElBDL8MHxz7dvG3_8K',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1mtHGVYmQwT6vdSElBDL8MHxz7dvG3_8K',
  },
  {
    Make: 'Joola',
    Model: 'Dekel Bar Perseus 3S 16mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1xXiMEsq1vNmpUEh1tykYmEzclmymqNWv/view?usp=sharing',
    'Photo ID': '1xXiMEsq1vNmpUEh1tykYmEzclmymqNWv',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1xXiMEsq1vNmpUEh1tykYmEzclmymqNWv',
  },
  {
    Make: 'Joola',
    Model: 'Graf Champion 12mm',
    Retail: '59.95',
    New: '40.00',
    'Like New': '35.00',
    Good: '25.00',
    'Photo URL': 'https://drive.google.com/file/d/1jUldsyXYC7If-0-nURnUderwb3jXnMiW/view?usp=sharing',
    'Photo ID': '1jUldsyXYC7If-0-nURnUderwb3jXnMiW',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1jUldsyXYC7If-0-nURnUderwb3jXnMiW',
  },
  {
    Make: 'Joola',
    Model: 'Graf Edge 16mm',
    Retail: '99.95',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1gGMOVxukiwI3J6_FeFZ1H69XnlAgt2cU/view?usp=sharing',
    'Photo ID': '1gGMOVxukiwI3J6_FeFZ1H69XnlAgt2cU',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1gGMOVxukiwI3J6_FeFZ1H69XnlAgt2cU',
  },
  {
    Make: 'Joola',
    Model: 'Graf Pro 16mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/14IQVhmqSbmAb4Ak2gXUSzE7Fsz3oBZzF/view?usp=sharing',
    'Photo ID': '14IQVhmqSbmAb4Ak2gXUSzE7Fsz3oBZzF',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=14IQVhmqSbmAb4Ak2gXUSzE7Fsz3oBZzF',
  },
  {
    Make: 'Joola',
    Model: 'Hyperion 3S Dual',
    Retail: '199.95',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1D2vPeOw0-KgM33xgxNVC4UPeMkrXO-Qj/view?usp=sharing',
    'Photo ID': '1D2vPeOw0-KgM33xgxNVC4UPeMkrXO-Qj',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1D2vPeOw0-KgM33xgxNVC4UPeMkrXO-Qj',
  },
  {
    Make: 'Joola',
    Model: 'Magnus 3S Dual',
    Retail: '199.95',
    New: '135.00',
    'Like New': '115.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1QbS_tnoBjXJ3G7ApkNj2aqJA4Q05ORfl/view?usp=sharing',
    'Photo ID': '1QbS_tnoBjXJ3G7ApkNj2aqJA4Q05ORfl',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1QbS_tnoBjXJ3G7ApkNj2aqJA4Q05ORfl',
  },
  {
    Make: 'Joola',
    Model: 'Perseus 14mm Mod TA-15',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1V8X3i_G64q9xPZAVFexJDEiFEiwRz4Ce/view?usp=sharing',
    'Photo ID': '1V8X3i_G64q9xPZAVFexJDEiFEiwRz4Ce',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1V8X3i_G64q9xPZAVFexJDEiFEiwRz4Ce',
  },
  {
    Make: 'Joola',
    Model: 'Perseus 16mm Mod TA-15',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1O4OBgw-U2cCGvqknn47BtrKfXmDVVwRD/view?usp=sharing',
    'Photo ID': '1O4OBgw-U2cCGvqknn47BtrKfXmDVVwRD',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1O4OBgw-U2cCGvqknn47BtrKfXmDVVwRD',
  },
  {
    Make: 'Joola',
    Model: 'Perseus 3S Dual',
    Retail: '199.95',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1r8REHDWiIKklH6U10IH0YOIBGJ3-nt8U/view?usp=sharing',
    'Photo ID': '1r8REHDWiIKklH6U10IH0YOIBGJ3-nt8U',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1r8REHDWiIKklH6U10IH0YOIBGJ3-nt8U',
  },
  {
    Make: 'Joola',
    Model: 'Pink Perseus 3S 16mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1xbYT_Lf6etyZ3jKyXt9M2-tTLi23tIHM/view?usp=sharing',
    'Photo ID': '1xbYT_Lf6etyZ3jKyXt9M2-tTLi23tIHM',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1xbYT_Lf6etyZ3jKyXt9M2-tTLi23tIHM',
  },
  {
    Make: 'Joola',
    Model: 'Pro V Agassi',
    Retail: '299.95',
    New: '205.00',
    'Like New': '175.00',
    Good: '145.00',
    'Photo URL': 'https://drive.google.com/file/d/1GH_tKcYfiNswGM90rNDWEFDw0LBFotKI/view?usp=drive_link',
    'Photo ID': '1GH_tKcYfiNswGM90rNDWEFDw0LBFotKI',
    GTIN: '4070116005912',
  },
  {
    Make: 'Joola',
    Model: 'Pro V Graf',
    Retail: '299.95',
    New: '205.00',
    'Like New': '175.00',
    Good: '145.00',
    'Photo URL': 'https://drive.google.com/file/d/1JYDvPYHeMU7zr6dCUEwqjoJkwyYs6o4F/view?usp=drive_link',
    'Photo ID': '1JYDvPYHeMU7zr6dCUEwqjoJkwyYs6o4F',
    GTIN: '4070116005943',
  },
  {
    Make: 'Joola',
    Model: 'Pro V Hyperion',
    Retail: '299.95',
    New: '205.00',
    'Like New': '175.00',
    Good: '145.00',
    'Photo URL': 'https://drive.google.com/file/d/1O8ndlOC3WQg0ssko9mLN5FRM-wsVQnVf/view?usp=drive_link',
    'Photo ID': '1O8ndlOC3WQg0ssko9mLN5FRM-wsVQnVf',
    GTIN: '4070116005820',
  },
  {
    Make: 'Joola',
    Model: 'Pro V Kosmos',
    Retail: '299.95',
    New: '205.00',
    'Like New': '175.00',
    Good: '145.00',
    'Photo URL': 'https://drive.google.com/file/d/1kgS7inYBhXC0CBbEYTQ7wa4VYhJlcrKR/view?usp=drive_link',
    'Photo ID': '1kgS7inYBhXC0CBbEYTQ7wa4VYhJlcrKR',
    GTIN: '4070116005738',
  },
  {
    Make: 'Joola',
    Model: 'Pro V Perseus',
    Retail: '299.95',
    New: '205.00',
    'Like New': '175.00',
    Good: '145.00',
    'Photo URL': 'https://drive.google.com/file/d/1UKqND0BEuMkISwRjEi2UimRqeS5cx4P2/view?usp=drive_link',
    'Photo ID': '1UKqND0BEuMkISwRjEi2UimRqeS5cx4P2',
    GTIN: '4070116005615',
  },
  {
    Make: 'Joola',
    Model: 'Pro V Scorpeus',
    Retail: '299.95',
    New: '205.00',
    'Like New': '175.00',
    Good: '145.00',
    'Photo URL': 'https://drive.google.com/file/d/17fCusSWq_YjyyB8S81mYXPz2Uj_Vi0bv/view?usp=drive_link',
    'Photo ID': '17fCusSWq_YjyyB8S81mYXPz2Uj_Vi0bv',
    GTIN: '4070116005677',
  },
  {
    Make: 'Joola',
    Model: 'Radius CGS 14',
    Retail: '179.95',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1ALI1CCGCA-g39bkseIOLM9DxPgOk_xQe/view?usp=sharing',
    'Photo ID': '1ALI1CCGCA-g39bkseIOLM9DxPgOk_xQe',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ALI1CCGCA-g39bkseIOLM9DxPgOk_xQe',
  },
  {
    Make: 'Joola',
    Model: 'Radius CGS 16',
    Retail: '179.95',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/10Ye62z7Xmo1dafnpbbcIGl0kmKYeb70m/view?usp=sharing',
    'Photo ID': '10Ye62z7Xmo1dafnpbbcIGl0kmKYeb70m',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=10Ye62z7Xmo1dafnpbbcIGl0kmKYeb70m',
  },
  {
    Make: 'Joola',
    Model: 'Scorpeus 3S Dual',
    Retail: '199.95',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1aXUSVOvJg68HQRwgja8bU_QlG_GPQxuk/view?usp=sharing',
    'Photo ID': '1aXUSVOvJg68HQRwgja8bU_QlG_GPQxuk',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1aXUSVOvJg68HQRwgja8bU_QlG_GPQxuk',
  },
  {
    Make: 'Joola',
    Model: 'Seneca CDS 16',
    Retail: '89.95',
    New: '60.00',
    'Like New': '50.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/11rJSRP0c4SBwNK8pdZGWaQExBSy1TnZb/view?usp=sharing',
    'Photo ID': '11rJSRP0c4SBwNK8pdZGWaQExBSy1TnZb',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=11rJSRP0c4SBwNK8pdZGWaQExBSy1TnZb',
  },
  {
    Make: 'Joola',
    Model: 'Seneca FDS 14',
    Retail: '89.95',
    New: '60.00',
    'Like New': '50.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1sNgV6WUD76tVxKkHNhVhoYA7ijZw1HzZ/view?usp=sharing',
    'Photo ID': '1sNgV6WUD76tVxKkHNhVhoYA7ijZw1HzZ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1sNgV6WUD76tVxKkHNhVhoYA7ijZw1HzZ',
  },
  {
    Make: 'Joola',
    Model: 'Simone Jardim Hyperion 3S 16mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1OyUhwX8fXoLjDlzxvtzp9lOt-QpG8OCJ/view?usp=sharing',
    'Photo ID': '1OyUhwX8fXoLjDlzxvtzp9lOt-QpG8OCJ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1OyUhwX8fXoLjDlzxvtzp9lOt-QpG8OCJ',
  },
  {
    Make: 'Joola',
    Model: 'Simone Jardim Hyperion C2 CFS 14',
    Retail: '199.95',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1_aubux8FBd2Zxc8N-cBTFx77mXrs25ZD/view?usp=sharing',
    'Photo ID': '1_aubux8FBd2Zxc8N-cBTFx77mXrs25ZD',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1_aubux8FBd2Zxc8N-cBTFx77mXrs25ZD',
  },
  {
    Make: 'Joola',
    Model: 'Simone Jardim Hyperion C2 CFS 16',
    Retail: '199.95',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1XM8l0Bq8YQxQh6MCdWYzi8xLBkVn6VzI/view?usp=sharing',
    'Photo ID': '1XM8l0Bq8YQxQh6MCdWYzi8xLBkVn6VzI',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1XM8l0Bq8YQxQh6MCdWYzi8xLBkVn6VzI',
  },
  {
    Make: 'Joola',
    Model: 'Simone Jardim Hyperion CFS 16 Swift',
    Retail: '199.95',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1S-gzWhNtNO07-9S2OqFLLYO9lYCqjnOC/view?usp=sharing',
    'Photo ID': '1S-gzWhNtNO07-9S2OqFLLYO9lYCqjnOC',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1S-gzWhNtNO07-9S2OqFLLYO9lYCqjnOC',
  },
  {
    Make: 'Joola',
    Model: 'Simone Jardim Hyperion Pro IV 16mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/14tQoYS95KpKJ1a6ljtdG3fZi1qk3o6dr/view?usp=sharing',
    'Photo ID': '14tQoYS95KpKJ1a6ljtdG3fZi1qk3o6dr',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=14tQoYS95KpKJ1a6ljtdG3fZi1qk3o6dr',
  },
  {
    Make: 'Joola',
    Model: 'Tyson McGuffin Magnus 3S 14mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1oVccgUqABXKqmEqd-0rL2xp_xCSFPHx8/view?usp=sharing',
    'Photo ID': '1oVccgUqABXKqmEqd-0rL2xp_xCSFPHx8',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1oVccgUqABXKqmEqd-0rL2xp_xCSFPHx8',
  },
  {
    Make: 'Joola',
    Model: 'Tyson McGuffin Magnus 3S 16mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1faXbp3Xy1B38z-_HGone33-_E_6PniDA/view?usp=sharing',
    'Photo ID': '1faXbp3Xy1B38z-_HGone33-_E_6PniDA',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1faXbp3Xy1B38z-_HGone33-_E_6PniDA',
  },
  {
    Make: 'Joola',
    Model: 'Tyson McGuffin Magnus CAS 14mm',
    Retail: '129.95',
    New: '90.00',
    'Like New': '75.00',
    Good: '60.00',
    'Photo URL': 'https://drive.google.com/file/d/14JE0MYhRYBjHTfGNQ4I0ncYyShsbgQbN/view?usp=sharing',
    'Photo ID': '14JE0MYhRYBjHTfGNQ4I0ncYyShsbgQbN',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=14JE0MYhRYBjHTfGNQ4I0ncYyShsbgQbN',
  },
  {
    Make: 'Joola',
    Model: 'Tyson McGuffin Magnus Pro IV 14mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/16pDOZ05yW9_yqLYCx9j2NEFfwxjgxAXn/view?usp=sharing',
    'Photo ID': '16pDOZ05yW9_yqLYCx9j2NEFfwxjgxAXn',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=16pDOZ05yW9_yqLYCx9j2NEFfwxjgxAXn',
  },
  {
    Make: 'Joola',
    Model: 'Tyson McGuffin Magnus Pro IV 16mm',
    Retail: '279.95',
    New: '195.00',
    'Like New': '165.00',
    Good: '135.00',
    'Photo URL': 'https://drive.google.com/file/d/1WmWoCwWzJnJe494G2vRomg2BZP7qBIMt/view?usp=sharing',
    'Photo ID': '1WmWoCwWzJnJe494G2vRomg2BZP7qBIMt',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1WmWoCwWzJnJe494G2vRomg2BZP7qBIMt',
  },
  {
    Make: 'Joola',
    Model: 'Vision CGS 16',
    Retail: '139.95',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/1FokMv__ZvEhfDiljONhPdFzHPEeniDmz/view?usp=sharing',
    'Photo ID': '1FokMv__ZvEhfDiljONhPdFzHPEeniDmz',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1FokMv__ZvEhfDiljONhPdFzHPEeniDmz',
  },
  {
    Make: 'Kiwi Labs',
    Model: '0-0 Start',
    Retail: '89.00',
    New: '60.00',
    'Like New': '50.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1-ybjoB5JgsrFOSGnIDAMdx24f2AbftPc/view?usp=sharing',
    'Photo ID': '1-ybjoB5JgsrFOSGnIDAMdx24f2AbftPc',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1-ybjoB5JgsrFOSGnIDAMdx24f2AbftPc',
  },
  {
    Make: 'Kiwi Labs',
    Model: 'Cannon',
    Retail: '139.00',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/1YbrnlOt5iPrijq4-X8PZ211V6DMitfm6/view?usp=sharing',
    'Photo ID': '1YbrnlOt5iPrijq4-X8PZ211V6DMitfm6',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1YbrnlOt5iPrijq4-X8PZ211V6DMitfm6',
  },
  {
    Make: 'Kiwi Labs',
    Model: 'Slice',
    Retail: '139.00',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/1zbt5gBXTJwC9nQ_Z6lc8D_YdOZoBlip3/view?usp=sharing',
    'Photo ID': '1zbt5gBXTJwC9nQ_Z6lc8D_YdOZoBlip3',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1zbt5gBXTJwC9nQ_Z6lc8D_YdOZoBlip3',
  },
  {
    Make: 'Legacy',
    Model: 'Legacy Pro',
    Retail: '150.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1eINIZ4CS7NEtFMftdwvFiUrsVEVkHn7b/view?usp=sharing',
    'Photo ID': '1eINIZ4CS7NEtFMftdwvFiUrsVEVkHn7b',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1eINIZ4CS7NEtFMftdwvFiUrsVEVkHn7b',
  },
  {
    Make: 'Legacy',
    Model: 'Legacy Pro 14mm',
    Retail: '150.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1p64Mdcilqiv6Zxly0q4iItTX2oBpz6BR/view?usp=sharing',
    'Photo ID': '1p64Mdcilqiv6Zxly0q4iItTX2oBpz6BR',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1p64Mdcilqiv6Zxly0q4iItTX2oBpz6BR',
  },
  {
    Make: 'Legacy',
    Model: 'Legacy Pro Air',
    Retail: '150.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1SVqc0Xvg01u3PV3dQKCAVvm3Al1rsA2I/view?usp=sharing',
    'Photo ID': '1SVqc0Xvg01u3PV3dQKCAVvm3Al1rsA2I',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1SVqc0Xvg01u3PV3dQKCAVvm3Al1rsA2I',
  },
  {
    Make: 'Legacy',
    Model: 'Legacy Pro S',
    Retail: '150.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/13jDwZ8t1DKQ_kCu1vnTE9OkJ0e69d-Aa/view?usp=sharing',
    'Photo ID': '13jDwZ8t1DKQ_kCu1vnTE9OkJ0e69d-Aa',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=13jDwZ8t1DKQ_kCu1vnTE9OkJ0e69d-Aa',
  },
  {
    Make: 'Luzz',
    Model: 'Pro 4 Inferno',
    Retail: '229.00',
    New: '160.00',
    'Like New': '135.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/18quvsgEKkEWGU6zRO_jwrxGijDnXCS55/view?usp=drive_link',
    'Photo ID': '18quvsgEKkEWGU6zRO_jwrxGijDnXCS55',
  },
  {
    Make: 'Luzz',
    Model: 'Pro 4 Tornazo',
    Retail: '229.00',
    New: '160.00',
    'Like New': '135.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1-QcPBGub0bh8cPueIjjgHgYiS5kR4BcG/view?usp=drive_link',
    'Photo ID': '1-QcPBGub0bh8cPueIjjgHgYiS5kR4BcG',
  },
  {
    Make: 'Neonic',
    Model: 'Flare Prime Titanium',
    Retail: '149.99',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1pO29US-4Z9iWzqm4VKQjACqC3_ZoNsXv/view?usp=sharing',
    'Photo ID': '1pO29US-4Z9iWzqm4VKQjACqC3_ZoNsXv',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1pO29US-4Z9iWzqm4VKQjACqC3_ZoNsXv',
  },
  {
    Make: 'Neonic',
    Model: 'Flare Prime X',
    Retail: '139.99',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/1F5S8aR45anH3o8U76d8kHbQO7ySWAS-v/view?usp=sharing',
    'Photo ID': '1F5S8aR45anH3o8U76d8kHbQO7ySWAS-v',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1F5S8aR45anH3o8U76d8kHbQO7ySWAS-v',
  },
  {
    Make: 'Neonic',
    Model: 'Flow 16mm',
    Retail: '129.99',
    New: '90.00',
    'Like New': '75.00',
    Good: '60.00',
    'Photo URL': 'https://drive.google.com/file/d/1E0avQXBKvpq_SUVjbYOPgi1uKqyhFhsE/view?usp=sharing',
    'Photo ID': '1E0avQXBKvpq_SUVjbYOPgi1uKqyhFhsE',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1E0avQXBKvpq_SUVjbYOPgi1uKqyhFhsE',
  },
  {
    Make: 'Neonic',
    Model: 'Flow Prime X',
    Retail: '139.99',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/1O_6QsfsVyW3VQMULTPNUTejdCwuoavu-/view?usp=sharing',
    'Photo ID': '1O_6QsfsVyW3VQMULTPNUTejdCwuoavu-',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1O_6QsfsVyW3VQMULTPNUTejdCwuoavu-',
  },
  {
    Make: 'Neonic',
    Model: 'Force',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1iWLMWGLVLABqZL87PsE8WY0lEKqlqN6S/view?usp=sharing',
    'Photo ID': '1iWLMWGLVLABqZL87PsE8WY0lEKqlqN6S',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1iWLMWGLVLABqZL87PsE8WY0lEKqlqN6S',
  },
  {
    Make: 'Niupipo',
    Model: 'Explorer Pro',
    Retail: '96.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/11bxwBMsSL1qc8si3YoOaDgzjipbDtoz6/view?usp=sharing',
    'Photo ID': '11bxwBMsSL1qc8si3YoOaDgzjipbDtoz6',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=11bxwBMsSL1qc8si3YoOaDgzjipbDtoz6',
  },
  {
    Make: 'Niupipo',
    Model: 'Voyager Pro',
    Retail: '132.99',
    New: '90.00',
    'Like New': '75.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/17Y0_oI4JVI6OKReig9XBE9RoslopVWl4/view?usp=sharing',
    'Photo ID': '17Y0_oI4JVI6OKReig9XBE9RoslopVWl4',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=17Y0_oI4JVI6OKReig9XBE9RoslopVWl4',
  },
  {
    Make: 'Omega',
    Model: 'Evolution Extreme',
    Retail: '140.00',
    New: '95.00',
    'Like New': '80.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1VTHOTAaDq2zEKeF-A5eGlVZ1gf30AHyD/view?usp=sharing',
    'Photo ID': '1VTHOTAaDq2zEKeF-A5eGlVZ1gf30AHyD',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1VTHOTAaDq2zEKeF-A5eGlVZ1gf30AHyD',
  },
  {
    Make: 'Omega',
    Model: 'Evolution Extreme X',
    Retail: '140.00',
    New: '95.00',
    'Like New': '80.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1jkST87h3PClOQ5I8NIOm3rIT_hUt4kW0/view?usp=sharing',
    'Photo ID': '1jkST87h3PClOQ5I8NIOm3rIT_hUt4kW0',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1jkST87h3PClOQ5I8NIOm3rIT_hUt4kW0',
  },
  {
    Make: 'Omega',
    Model: 'Evolution Max',
    Retail: '100.00',
    New: '70.00',
    'Like New': '60.00',
    Good: '50.00',
    'Photo URL': 'https://drive.google.com/file/d/1uAJnixaOAMCoWEzTDHmcUBOXFH93lTPq/view?usp=sharing',
    'Photo ID': '1uAJnixaOAMCoWEzTDHmcUBOXFH93lTPq',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1uAJnixaOAMCoWEzTDHmcUBOXFH93lTPq',
  },
  {
    Make: 'Omega',
    Model: 'Evolution Pro',
    Retail: '129.99',
    New: '90.00',
    'Like New': '75.00',
    Good: '60.00',
    'Photo URL': 'https://drive.google.com/file/d/1XwHe2YVlMHBAySLG4B9CQes6qzBoHPgZ/view?usp=sharing',
    'Photo ID': '1XwHe2YVlMHBAySLG4B9CQes6qzBoHPgZ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1XwHe2YVlMHBAySLG4B9CQes6qzBoHPgZ',
  },
  {
    Make: 'Omega',
    Model: 'Evolution Pro-1',
    Retail: '129.99',
    New: '90.00',
    'Like New': '75.00',
    Good: '60.00',
    'Photo URL': 'https://drive.google.com/file/d/1OZQF3F7hY78tRz18l3DHIr9yO3qSIaFu/view?usp=sharing',
    'Photo ID': '1OZQF3F7hY78tRz18l3DHIr9yO3qSIaFu',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1OZQF3F7hY78tRz18l3DHIr9yO3qSIaFu',
  },
  {
    Make: 'Omega',
    Model: 'Raptor',
    Retail: '180.00',
    New: '125.00',
    'Like New': '105.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/14pGW3M9E1YQehAWB11Gzp85cE1uUyASs/view?usp=sharing',
    'Photo ID': '14pGW3M9E1YQehAWB11Gzp85cE1uUyASs',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=14pGW3M9E1YQehAWB11Gzp85cE1uUyASs',
  },
  {
    Make: 'Omega',
    Model: 'Raptor X',
    Retail: '180.00',
    New: '125.00',
    'Like New': '105.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1GStoiTcZEpmiMvEImHl3jndhO7VDp9rg/view?usp=sharing',
    'Photo ID': '1GStoiTcZEpmiMvEImHl3jndhO7VDp9rg',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1GStoiTcZEpmiMvEImHl3jndhO7VDp9rg',
  },
  {
    Make: 'Oneshot Pickleball',
    Model: 'Aero Proshot',
    Retail: '185.00',
    New: '125.00',
    'Like New': '110.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1872MsmTlgxpOuCaPKoTOajEf_XP5u3vv/view?usp=sharing',
    'Photo ID': '1872MsmTlgxpOuCaPKoTOajEf_XP5u3vv',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1872MsmTlgxpOuCaPKoTOajEf_XP5u3vv',
  },
  {
    Make: 'Oneshot Pickleball',
    Model: 'Flip Shot',
    Retail: '105.00',
    New: '70.00',
    'Like New': '60.00',
    Good: '50.00',
    'Photo URL': 'https://drive.google.com/file/d/1prqcQ9dtB3rPOvNHTaZtPiL4-XKqzaZ0/view?usp=sharing',
    'Photo ID': '1prqcQ9dtB3rPOvNHTaZtPiL4-XKqzaZ0',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1prqcQ9dtB3rPOvNHTaZtPiL4-XKqzaZ0',
  },
  {
    Make: 'Onix',
    Model: 'Evoke Premier',
    Retail: '149.99',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/14G7PGgin3-fvItGdaOwtOd6q7BC08ctt/view?usp=sharing',
    'Photo ID': '14G7PGgin3-fvItGdaOwtOd6q7BC08ctt',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=14G7PGgin3-fvItGdaOwtOd6q7BC08ctt',
  },
  {
    Make: 'Onix',
    Model: 'Evoke Premier CT-16',
    Retail: '179.99',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/17qtJzUxDjCVL57o1Wyplzf7WxVxYxnrh/view?usp=sharing',
    'Photo ID': '17qtJzUxDjCVL57o1Wyplzf7WxVxYxnrh',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=17qtJzUxDjCVL57o1Wyplzf7WxVxYxnrh',
  },
  {
    Make: 'Onix',
    Model: 'Evoke Premier Pro',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1MeVjCqhc0EmtVQzq640efVNizfCzFXdS/view?usp=sharing',
    'Photo ID': '1MeVjCqhc0EmtVQzq640efVNizfCzFXdS',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1MeVjCqhc0EmtVQzq640efVNizfCzFXdS',
  },
  {
    Make: 'Onix',
    Model: 'Evoke Pro',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1QtnAmYpabPgNrPVcdX6OGIehi1BsDNWD/view?usp=sharing',
    'Photo ID': '1QtnAmYpabPgNrPVcdX6OGIehi1BsDNWD',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1QtnAmYpabPgNrPVcdX6OGIehi1BsDNWD',
  },
  {
    Make: 'Onix',
    Model: 'Malice',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1xwIeyu9BZ-uDjfqu0UM4onPrVKnIivke/view?usp=sharing',
    'Photo ID': '1xwIeyu9BZ-uDjfqu0UM4onPrVKnIivke',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1xwIeyu9BZ-uDjfqu0UM4onPrVKnIivke',
  },
  {
    Make: 'Onix',
    Model: 'Malice DB',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1Gf6m0cWqQmDRXCz9dfkRsCM5DUNuqJzL/view?usp=sharing',
    'Photo ID': '1Gf6m0cWqQmDRXCz9dfkRsCM5DUNuqJzL',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Gf6m0cWqQmDRXCz9dfkRsCM5DUNuqJzL',
  },
  {
    Make: 'Onix',
    Model: 'Malice DB Open Throat',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1j8j64NgPwuB_tpAL30HYLku6dwGJsfWM/view?usp=sharing',
    'Photo ID': '1j8j64NgPwuB_tpAL30HYLku6dwGJsfWM',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1j8j64NgPwuB_tpAL30HYLku6dwGJsfWM',
  },
  {
    Make: 'Onix',
    Model: 'Malice Open Throat',
    Retail: '229.99',
    New: '160.00',
    'Like New': '135.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1_M3pMxHhPAOr8REy6ErsVWuAhgWbGtTG/view?usp=sharing',
    'Photo ID': '1_M3pMxHhPAOr8REy6ErsVWuAhgWbGtTG',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1_M3pMxHhPAOr8REy6ErsVWuAhgWbGtTG',
  },
  {
    Make: 'Onix',
    Model: 'Mayhem',
    Retail: '209.99',
    New: '145.00',
    'Like New': '125.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/1wflvqjEJ60hWewPGHjhLTXbs-0uBiMXZ/view?usp=sharing',
    'Photo ID': '1wflvqjEJ60hWewPGHjhLTXbs-0uBiMXZ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1wflvqjEJ60hWewPGHjhLTXbs-0uBiMXZ',
  },
  {
    Make: 'Onix',
    Model: 'Outbreak',
    Retail: '129.99',
    New: '90.00',
    'Like New': '75.00',
    Good: '60.00',
    'Photo URL': 'https://drive.google.com/file/d/1IYP4F9H86SkT_nqn8WsL48k8C5ujcKLl/view?usp=sharing',
    'Photo ID': '1IYP4F9H86SkT_nqn8WsL48k8C5ujcKLl',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1IYP4F9H86SkT_nqn8WsL48k8C5ujcKLl',
  },
  {
    Make: 'Onix',
    Model: 'React',
    Retail: '39.98',
    New: '25.00',
    'Like New': '20.00',
    Good: '20.00',
    'Photo URL': 'https://drive.google.com/file/d/1SbNmDB26OO3kRYesjEentTYFu3RkXzbx/view?usp=sharing',
    'Photo ID': '1SbNmDB26OO3kRYesjEentTYFu3RkXzbx',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1SbNmDB26OO3kRYesjEentTYFu3RkXzbx',
  },
  {
    Make: 'Onix',
    Model: 'Summit Outbreak',
    Retail: '119.99',
    New: '80.00',
    'Like New': '70.00',
    Good: '55.00',
    'Photo URL': 'https://drive.google.com/file/d/1D-okQwXya6jTnmyZ9UXnfhDUgCvGHyox/view?usp=sharing',
    'Photo ID': '1D-okQwXya6jTnmyZ9UXnfhDUgCvGHyox',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1D-okQwXya6jTnmyZ9UXnfhDUgCvGHyox',
  },
  {
    Make: 'Onix',
    Model: 'Supercell 22mm',
    Retail: '139.99',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/1O82DAbQ3czs4CGfLU5QIU5PN42Ck4VgC/view?usp=sharing',
    'Photo ID': '1O82DAbQ3czs4CGfLU5QIU5PN42Ck4VgC',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1O82DAbQ3czs4CGfLU5QIU5PN42Ck4VgC',
  },
  {
    Make: 'Onix',
    Model: 'Vertex',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/18v_3qEFXvJCj3t_Yqak-CWooaOli06xl/view?usp=sharing',
    'Photo ID': '18v_3qEFXvJCj3t_Yqak-CWooaOli06xl',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=18v_3qEFXvJCj3t_Yqak-CWooaOli06xl',
  },
  {
    Make: 'Onix',
    Model: 'Voyager Pro',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1MJnMdCVPu0ynA7S8Fl8zUApCOsKawL0H/view?usp=sharing',
    'Photo ID': '1MJnMdCVPu0ynA7S8Fl8zUApCOsKawL0H',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1MJnMdCVPu0ynA7S8Fl8zUApCOsKawL0H',
  },
  {
    Make: 'Onix',
    Model: 'Z5',
    Retail: '89.99',
    New: '60.00',
    'Like New': '50.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1AQlBKyrNcE6C5_NjV6L_uv9E3DPFcpTo/view?usp=sharing',
    'Photo ID': '1AQlBKyrNcE6C5_NjV6L_uv9E3DPFcpTo',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1AQlBKyrNcE6C5_NjV6L_uv9E3DPFcpTo',
  },
  {
    Make: 'Onix',
    Model: 'Z5 Mod',
    Retail: '89.99',
    New: '60.00',
    'Like New': '50.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1y2ihmOwk5LfOFu18tzXU2q5NlIgvqsv-/view?usp=sharing',
    'Photo ID': '1y2ihmOwk5LfOFu18tzXU2q5NlIgvqsv-',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1y2ihmOwk5LfOFu18tzXU2q5NlIgvqsv-',
  },
  {
    Make: 'Onix',
    Model: 'Z5 Mod 2',
    Retail: '89.99',
    New: '60.00',
    'Like New': '50.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1mU6bYTqoYEjGoc-LqWWFt08tPFOKfXL9/view?usp=sharing',
    'Photo ID': '1mU6bYTqoYEjGoc-LqWWFt08tPFOKfXL9',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1mU6bYTqoYEjGoc-LqWWFt08tPFOKfXL9',
  },
  {
    Make: 'Onix',
    Model: 'Z7',
    Retail: '119.99',
    New: '80.00',
    'Like New': '70.00',
    Good: '55.00',
    'Photo URL': 'https://drive.google.com/file/d/1zDiodbzsocR_avGz-ZHZnfMsahnlmCDS/view?usp=sharing',
    'Photo ID': '1zDiodbzsocR_avGz-ZHZnfMsahnlmCDS',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1zDiodbzsocR_avGz-ZHZnfMsahnlmCDS',
  },
  {
    Make: 'Oya',
    Model: 'Oya Classic',
    Retail: '169.99',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1P74LR7R3trX3_HPFSK56POjK233lJN4u/view?usp=sharing',
    'Photo ID': '1P74LR7R3trX3_HPFSK56POjK233lJN4u',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1P74LR7R3trX3_HPFSK56POjK233lJN4u',
  },
  {
    Make: 'Oya',
    Model: 'Oya Max',
    Retail: '169.99',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/183kwxMb1lHGnqHdAS5dyJtgOUlTSca1Z/view?usp=sharing',
    'Photo ID': '183kwxMb1lHGnqHdAS5dyJtgOUlTSca1Z',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=183kwxMb1lHGnqHdAS5dyJtgOUlTSca1Z',
  },
  {
    Make: 'Oya',
    Model: 'Phantom',
    Retail: '169.99',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1lOjgpk0KnihfEVUwgH3IMhmQWiE7l-EP/view?usp=sharing',
    'Photo ID': '1lOjgpk0KnihfEVUwgH3IMhmQWiE7l-EP',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1lOjgpk0KnihfEVUwgH3IMhmQWiE7l-EP',
  },
  {
    Make: 'Oya',
    Model: 'Phantom Max',
    Retail: '169.99',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1uGb7_zkW9AkI9n-LeFdHeWOpPSn5GHyg/view?usp=sharing',
    'Photo ID': '1uGb7_zkW9AkI9n-LeFdHeWOpPSn5GHyg',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1uGb7_zkW9AkI9n-LeFdHeWOpPSn5GHyg',
  },
  {
    Make: 'Paddletek',
    Model: 'Bantam ALW-C 12.7',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1Eugf5u5m9iymD7WfJ_aLtx98BDg2DjUH/view?usp=sharing',
    'Photo ID': '1Eugf5u5m9iymD7WfJ_aLtx98BDg2DjUH',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Eugf5u5m9iymD7WfJ_aLtx98BDg2DjUH',
  },
  {
    Make: 'Paddletek',
    Model: 'Bantam ALW-C 14.3',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1Zddf3BuWdHLwnJIMBwjDjnMaJ74kRR17/view?usp=sharing',
    'Photo ID': '1Zddf3BuWdHLwnJIMBwjDjnMaJ74kRR17',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Zddf3BuWdHLwnJIMBwjDjnMaJ74kRR17',
  },
  {
    Make: 'Paddletek',
    Model: 'Bantam ESQ-C 12.7',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1u9Vv48mO4VN9gmjYrAY0e6F4ekm55lh5/view?usp=sharing',
    'Photo ID': '1u9Vv48mO4VN9gmjYrAY0e6F4ekm55lh5',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1u9Vv48mO4VN9gmjYrAY0e6F4ekm55lh5',
  },
  {
    Make: 'Paddletek',
    Model: 'Bantam ESQ-C 14.3',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1jirYzpPVpwprgd7T8FYp0GwEYDaT3nuH/view?usp=sharing',
    'Photo ID': '1jirYzpPVpwprgd7T8FYp0GwEYDaT3nuH',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1jirYzpPVpwprgd7T8FYp0GwEYDaT3nuH',
  },
  {
    Make: 'Paddletek',
    Model: 'Bantam EX-L',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/12ekKiPavL90o3FGymUaGnBg32LqQlx6X/view?usp=sharing',
    'Photo ID': '12ekKiPavL90o3FGymUaGnBg32LqQlx6X',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=12ekKiPavL90o3FGymUaGnBg32LqQlx6X',
  },
  {
    Make: 'Paddletek',
    Model: 'Bantam EX-L Pro',
    Retail: '149.99',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1T9M6BGgAwqhlexK6TC8Kzu3sIOqTrRay/view?usp=sharing',
    'Photo ID': '1T9M6BGgAwqhlexK6TC8Kzu3sIOqTrRay',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1T9M6BGgAwqhlexK6TC8Kzu3sIOqTrRay',
  },
  {
    Make: 'Paddletek',
    Model: 'Bantam GTO-C 12.7',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1IcZNBUnWVK2IpLRxl7KRakAwMGvavBLU/view?usp=sharing',
    'Photo ID': '1IcZNBUnWVK2IpLRxl7KRakAwMGvavBLU',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1IcZNBUnWVK2IpLRxl7KRakAwMGvavBLU',
  },
  {
    Make: 'Paddletek',
    Model: 'Bantam GTO-C 14.3',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1iTdEtf6_YURuhwOf-x0O6WWk8RJWco5Z/view?usp=sharing',
    'Photo ID': '1iTdEtf6_YURuhwOf-x0O6WWk8RJWco5Z',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1iTdEtf6_YURuhwOf-x0O6WWk8RJWco5Z',
  },
  {
    Make: 'Paddletek',
    Model: 'Bantam TKO-C 12.7',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/10rowhBo3uYzBxd85RFg81QzZfKPFJjbA/view?usp=sharing',
    'Photo ID': '10rowhBo3uYzBxd85RFg81QzZfKPFJjbA',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=10rowhBo3uYzBxd85RFg81QzZfKPFJjbA',
  },
  {
    Make: 'Paddletek',
    Model: 'Bantam TKO-C 14.3',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1KY7TAj8teobxSkQSzVGB4sfdUsnF2Kmy/view?usp=sharing',
    'Photo ID': '1KY7TAj8teobxSkQSzVGB4sfdUsnF2Kmy',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1KY7TAj8teobxSkQSzVGB4sfdUsnF2Kmy',
  },
  {
    Make: 'Paddletek',
    Model: 'Bantam TKO-CX 12.7',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1UMdk6PJZjdwgvhCI__f_SfqtprzORKsC/view?usp=sharing',
    'Photo ID': '1UMdk6PJZjdwgvhCI__f_SfqtprzORKsC',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1UMdk6PJZjdwgvhCI__f_SfqtprzORKsC',
  },
  {
    Make: 'Paddletek',
    Model: 'Bantam TKO-CX 14.3',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1D_KFeLYzePs0w03ixL7Jj5_ql_sibFeY/view?usp=sharing',
    'Photo ID': '1D_KFeLYzePs0w03ixL7Jj5_ql_sibFeY',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1D_KFeLYzePs0w03ixL7Jj5_ql_sibFeY',
  },
  {
    Make: 'Paddletek',
    Model: 'Bantam TS-5',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1gz33YN5v_Cqws_zSV_U903Ig3vcOTkh_/view?usp=sharing',
    'Photo ID': '1gz33YN5v_Cqws_zSV_U903Ig3vcOTkh_',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1gz33YN5v_Cqws_zSV_U903Ig3vcOTkh_',
  },
  {
    Make: 'Paddletek',
    Model: 'Bantam TS-5 Pro',
    Retail: '149.99',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1klUm6CqXVvljGz9KXYrRnwF24xfm3AwO/view?usp=sharing',
    'Photo ID': '1klUm6CqXVvljGz9KXYrRnwF24xfm3AwO',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1klUm6CqXVvljGz9KXYrRnwF24xfm3AwO',
  },
  {
    Make: 'Paddletek',
    Model: 'GT Showtime 12.7',
    Retail: '259.99',
    New: '180.00',
    'Like New': '155.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/17TO2R5F-v_1xnRZpb0xhZqh0YfLh3LJr/view?usp=sharing',
    'Photo ID': '17TO2R5F-v_1xnRZpb0xhZqh0YfLh3LJr',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=17TO2R5F-v_1xnRZpb0xhZqh0YfLh3LJr',
  },
  {
    Make: 'Paddletek',
    Model: 'Phoenix G6',
    Retail: '69.99',
    New: '45.00',
    'Like New': '40.00',
    Good: '30.00',
    'Photo URL': 'https://drive.google.com/file/d/1ro5gz-L5Qc4OCOag0EF2pN5LK3QyQ3QD/view?usp=sharing',
    'Photo ID': '1ro5gz-L5Qc4OCOag0EF2pN5LK3QyQ3QD',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ro5gz-L5Qc4OCOag0EF2pN5LK3QyQ3QD',
  },
  {
    Make: 'Paddletek',
    Model: 'Phoenix Genesis',
    Retail: '89.99',
    New: '60.00',
    'Like New': '50.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1O2rVNjnaaPxRdHjtRLi58yNawMnxDz4o/view?usp=sharing',
    'Photo ID': '1O2rVNjnaaPxRdHjtRLi58yNawMnxDz4o',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1O2rVNjnaaPxRdHjtRLi58yNawMnxDz4o',
  },
  {
    Make: 'Paddletek',
    Model: 'Phoenix Genesis Pro',
    Retail: '119.99',
    New: '80.00',
    'Like New': '70.00',
    Good: '55.00',
    'Photo URL': 'https://drive.google.com/file/d/1p0KMzGSNuMwIwtjvJtZR9UEbr1mEVEEl/view?usp=sharing',
    'Photo ID': '1p0KMzGSNuMwIwtjvJtZR9UEbr1mEVEEl',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1p0KMzGSNuMwIwtjvJtZR9UEbr1mEVEEl',
  },
  {
    Make: 'Paddletek',
    Model: 'Tempest Reign Pro',
    Retail: '179.99',
    New: '75.00',
    'Like New': '55.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/1qTqasvXrUP4l0tp9qbZNpv9AwFpnh18J/view?usp=sharing',
    'Photo ID': '1qTqasvXrUP4l0tp9qbZNpv9AwFpnh18J',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1qTqasvXrUP4l0tp9qbZNpv9AwFpnh18J',
  },
  {
    Make: 'Paddletek',
    Model: 'Tempest Reign V3',
    Retail: '139.99',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/17rdEpBGShCQM2DaNlp5B-THRpkHSPo2R/view?usp=sharing',
    'Photo ID': '17rdEpBGShCQM2DaNlp5B-THRpkHSPo2R',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=17rdEpBGShCQM2DaNlp5B-THRpkHSPo2R',
  },
  {
    Make: 'Paddletek',
    Model: 'Tempest TKO-C 14.3',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1J1TSMqK1zVHQU_B_FtmyC3BWB1wP6RZD/view?usp=sharing',
    'Photo ID': '1J1TSMqK1zVHQU_B_FtmyC3BWB1wP6RZD',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1J1TSMqK1zVHQU_B_FtmyC3BWB1wP6RZD',
  },
  {
    Make: 'Paddletek',
    Model: 'Tempest Wave Pro',
    Retail: '179.99',
    New: '65.00',
    'Like New': '45.00',
    Good: '25.00',
    'Photo URL': 'https://drive.google.com/file/d/1cIhbZeoNw-cZPrbhzM32wlvtmrMceAGd/view?usp=sharing',
    'Photo ID': '1cIhbZeoNw-cZPrbhzM32wlvtmrMceAGd',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1cIhbZeoNw-cZPrbhzM32wlvtmrMceAGd',
  },
  {
    Make: 'Paddletek',
    Model: 'Tempest Wave Pro V3',
    Retail: '209.99',
    New: '145.00',
    'Like New': '125.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/1j8sLUdYqx_1vF5dx_lyCAoU30kWsNUL1/view?usp=sharing',
    'Photo ID': '1j8sLUdYqx_1vF5dx_lyCAoU30kWsNUL1',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1j8sLUdYqx_1vF5dx_lyCAoU30kWsNUL1',
  },
  {
    Make: 'Paddletek',
    Model: 'Tempest Wave Pro-C',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1tpSFMn4wQf_YE2Aoq_02xeWeix8l3AnL/view?usp=sharing',
    'Photo ID': '1tpSFMn4wQf_YE2Aoq_02xeWeix8l3AnL',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1tpSFMn4wQf_YE2Aoq_02xeWeix8l3AnL',
  },
  {
    Make: 'Paddletek',
    Model: 'Tempest Wave V3',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/16hfTzwIHIzrtyN2fUjZo8gm6B8fhX5jE/view?usp=sharing',
    'Photo ID': '16hfTzwIHIzrtyN2fUjZo8gm6B8fhX5jE',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=16hfTzwIHIzrtyN2fUjZo8gm6B8fhX5jE',
  },
  {
    Make: 'PCKL',
    Model: 'Power Series',
    Retail: '54.95',
    New: '35.00',
    'Like New': '30.00',
    Good: '25.00',
    'Photo URL': 'https://drive.google.com/file/d/1y6MEmJ5Q0i4MANewmWDKMeDafdL6SwLn/view?usp=sharing',
    'Photo ID': '1y6MEmJ5Q0i4MANewmWDKMeDafdL6SwLn',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1y6MEmJ5Q0i4MANewmWDKMeDafdL6SwLn',
  },
  {
    Make: 'PCKL',
    Model: 'Pro Series',
    Retail: '54.95',
    New: '35.00',
    'Like New': '30.00',
    Good: '25.00',
    'Photo URL': 'https://drive.google.com/file/d/1wWRV1Wb6ch-yV4hZjDty0Z7T9SjirF7Z/view?usp=sharing',
    'Photo ID': '1wWRV1Wb6ch-yV4hZjDty0Z7T9SjirF7Z',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1wWRV1Wb6ch-yV4hZjDty0Z7T9SjirF7Z',
  },
  {
    Make: 'Pickleball Apes',
    Model: 'Energy S Bronze',
    Retail: '120.00',
    New: '80.00',
    'Like New': '70.00',
    Good: '60.00',
    'Photo URL': 'https://drive.google.com/file/d/1OuRXz769sMr6O6AHcSqmXfPCSz1WXIVe/view?usp=sharing',
    'Photo ID': '1OuRXz769sMr6O6AHcSqmXfPCSz1WXIVe',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1OuRXz769sMr6O6AHcSqmXfPCSz1WXIVe',
  },
  {
    Make: 'Pickleball Apes',
    Model: 'Harmony S',
    Retail: '179.99',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1uyd5uGeLS1GJV3z-iq63XX7uL1Y1hFWq/view?usp=sharing',
    'Photo ID': '1uyd5uGeLS1GJV3z-iq63XX7uL1Y1hFWq',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1uyd5uGeLS1GJV3z-iq63XX7uL1Y1hFWq',
  },
  {
    Make: 'Pickleball Apes',
    Model: 'Harmony V',
    Retail: '179.99',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1bpLxxD9T_Lxf8gwoxbEraNyqX5WTX5Zm/view?usp=sharing',
    'Photo ID': '1bpLxxD9T_Lxf8gwoxbEraNyqX5WTX5Zm',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1bpLxxD9T_Lxf8gwoxbEraNyqX5WTX5Zm',
  },
  {
    Make: 'Pickleball Apes',
    Model: 'Harmony X',
    Retail: '179.99',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/16f7CTcQNYsgt2ZtO0g-IRq47UylhL4Ny/view?usp=sharing',
    'Photo ID': '16f7CTcQNYsgt2ZtO0g-IRq47UylhL4Ny',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=16f7CTcQNYsgt2ZtO0g-IRq47UylhL4Ny',
  },
  {
    Make: 'Pickleball Apes',
    Model: 'Neo Line One',
    Retail: '69.99',
    New: '45.00',
    'Like New': '40.00',
    Good: '30.00',
    'Photo URL': 'https://drive.google.com/file/d/1UiS32I1EnlJk2NmQF44T81lBmpGmSWon/view?usp=sharing',
    'Photo ID': '1UiS32I1EnlJk2NmQF44T81lBmpGmSWon',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1UiS32I1EnlJk2NmQF44T81lBmpGmSWon',
  },
  {
    Make: 'Pickleball Apes',
    Model: 'Pro Line Energy',
    Retail: '149.99',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1E8wmV0WeKDU-YAJ-nYSYc8HfuhO5vrHR/view?usp=sharing',
    'Photo ID': '1E8wmV0WeKDU-YAJ-nYSYc8HfuhO5vrHR',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1E8wmV0WeKDU-YAJ-nYSYc8HfuhO5vrHR',
  },
  {
    Make: 'Pickleball Apes',
    Model: 'Pro Line Energy S',
    Retail: '169.99',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1KIIk1CMbrAlNMPsPFsvO0lFqXFdilKA0/view?usp=sharing',
    'Photo ID': '1KIIk1CMbrAlNMPsPFsvO0lFqXFdilKA0',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1KIIk1CMbrAlNMPsPFsvO0lFqXFdilKA0',
  },
  {
    Make: 'Pickleball Apes',
    Model: 'Pulse E',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1WwjN45CRDbRx0FYNJp7Gii3oLM5tetnS/view?usp=sharing',
    'Photo ID': '1WwjN45CRDbRx0FYNJp7Gii3oLM5tetnS',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1WwjN45CRDbRx0FYNJp7Gii3oLM5tetnS',
  },
  {
    Make: 'Pickleball Apes',
    Model: 'Pulse S',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1YAN5zalNLeuxkgUF4FWLfXrg5wQQ3b31/view?usp=sharing',
    'Photo ID': '1YAN5zalNLeuxkgUF4FWLfXrg5wQQ3b31',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1YAN5zalNLeuxkgUF4FWLfXrg5wQQ3b31',
  },
  {
    Make: 'Pickleball Apes',
    Model: 'Pulse V',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1ish1qp3wQBDRNVAWE1tFBHn_X-AgKpE9/view?usp=sharing',
    'Photo ID': '1ish1qp3wQBDRNVAWE1tFBHn_X-AgKpE9',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ish1qp3wQBDRNVAWE1tFBHn_X-AgKpE9',
  },
  {
    Make: 'Pickleball Apes',
    Model: 'Pulse X',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1IUX0bqZy6dPhivDc7o5U5Vt0yHUV49xB/view?usp=sharing',
    'Photo ID': '1IUX0bqZy6dPhivDc7o5U5Vt0yHUV49xB',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1IUX0bqZy6dPhivDc7o5U5Vt0yHUV49xB',
  },
  {
    Make: 'Pickleball Poker',
    Model: 'Joker',
    Retail: '74.99',
    New: '50.00',
    'Like New': '40.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/1lUMIMJ9bZc1MIC2R0e2eWAERarilqx0l/view?usp=sharing',
    'Photo ID': '1lUMIMJ9bZc1MIC2R0e2eWAERarilqx0l',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1lUMIMJ9bZc1MIC2R0e2eWAERarilqx0l',
  },
  {
    Make: 'Pickleball Poker',
    Model: 'The Bet',
    Retail: '69.99',
    New: '45.00',
    'Like New': '40.00',
    Good: '30.00',
    'Photo URL': 'https://drive.google.com/file/d/1VcrW-U7kMvVpsww40x8ahOMNcP6TfP-y/view?usp=sharing',
    'Photo ID': '1VcrW-U7kMvVpsww40x8ahOMNcP6TfP-y',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1VcrW-U7kMvVpsww40x8ahOMNcP6TfP-y',
  },
  {
    Make: 'PIKKL',
    Model: 'Hurricane Pro',
    Retail: '159.99',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1Bz1d3YBnhMoOTihrdZmWQCwEqvVTDRMg/view?usp=sharing',
    'Photo ID': '1Bz1d3YBnhMoOTihrdZmWQCwEqvVTDRMg',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Bz1d3YBnhMoOTihrdZmWQCwEqvVTDRMg',
  },
  {
    Make: 'PIKKL',
    Model: 'Sport Series',
    Retail: '49.99',
    New: '30.00',
    'Like New': '25.00',
    Good: '20.00',
    'Photo URL': 'https://drive.google.com/file/d/1OneQhea2vm8Q3pWF5JNdJPccuZ7kS-wY/view?usp=sharing',
    'Photo ID': '1OneQhea2vm8Q3pWF5JNdJPccuZ7kS-wY',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1OneQhea2vm8Q3pWF5JNdJPccuZ7kS-wY',
  },
  {
    Make: 'PIKKL',
    Model: 'Vantage Pro',
    Retail: '139.00',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/1S3HsFjviy_kLjtVXxvDh3pbgNxZ1A7WZ/view?usp=sharing',
    'Photo ID': '1S3HsFjviy_kLjtVXxvDh3pbgNxZ1A7WZ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1S3HsFjviy_kLjtVXxvDh3pbgNxZ1A7WZ',
  },
  {
    Make: 'PikNinja',
    Model: 'Revenant',
    Retail: '169.95',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1ULnmvs0COu-MW2UZVV0wTRIfHjTJDJJ1/view?usp=sharing',
    'Photo ID': '1ULnmvs0COu-MW2UZVV0wTRIfHjTJDJJ1',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ULnmvs0COu-MW2UZVV0wTRIfHjTJDJJ1',
  },
  {
    Make: 'PikNinja',
    Model: 'Revenant 2.0',
    Retail: '179.95',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1xe7aN39FtvW5pPThQW7MldSgv9O-BK7L/view?usp=sharing',
    'Photo ID': '1xe7aN39FtvW5pPThQW7MldSgv9O-BK7L',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1xe7aN39FtvW5pPThQW7MldSgv9O-BK7L',
  },
  {
    Make: 'ProDrive',
    Model: 'Drive',
    Retail: '199.00',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1GvMaljML43TONtCX3VBeoxmi3LMKN7Tl/view?usp=sharing',
    'Photo ID': '1GvMaljML43TONtCX3VBeoxmi3LMKN7Tl',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1GvMaljML43TONtCX3VBeoxmi3LMKN7Tl',
  },
  {
    Make: 'ProDrive',
    Model: 'Drive Carbon',
    Retail: '199.00',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1hLaor7W8KXCnuMAW2VA3B605eThyVc-r/view?usp=sharing',
    'Photo ID': '1hLaor7W8KXCnuMAW2VA3B605eThyVc-r',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1hLaor7W8KXCnuMAW2VA3B605eThyVc-r',
  },
  {
    Make: 'ProDrive',
    Model: 'Encounter',
    Retail: '219.00',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1GvMaljML43TONtCX3VBeoxmi3LMKN7Tl/view?usp=sharing',
    'Photo ID': '1lIgPC0iN7AV4HmqJnOgcjMchwoU_YCML',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1lIgPC0iN7AV4HmqJnOgcjMchwoU_YCML',
  },
  {
    Make: 'ProDrive',
    Model: 'Ghost',
    Retail: '189.00',
    New: '130.00',
    'Like New': '110.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1ETvmQuRhQL7uWNUgtfV4lqCXcg6ZbqVk/view?usp=sharing',
    'Photo ID': '1ETvmQuRhQL7uWNUgtfV4lqCXcg6ZbqVk',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ETvmQuRhQL7uWNUgtfV4lqCXcg6ZbqVk',
  },
  {
    Make: 'Professor',
    Model: 'PhD',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1BzItzn0nR_VUGQo28plySm6XDhbTgjQ6/view?usp=sharing',
    'Photo ID': '1BzItzn0nR_VUGQo28plySm6XDhbTgjQ6',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1BzItzn0nR_VUGQo28plySm6XDhbTgjQ6',
  },
  {
    Make: 'Professor',
    Model: 'PhD Pro',
    Retail: '159.95',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/13O0VDvGt9DQwuvQnPVxegzIcbwAP2YEh/view?usp=sharing',
    'Photo ID': '13O0VDvGt9DQwuvQnPVxegzIcbwAP2YEh',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=13O0VDvGt9DQwuvQnPVxegzIcbwAP2YEh',
  },
  {
    Make: 'ProKennex',
    Model: 'Black Ace LG',
    Retail: '250.00',
    New: '175.00',
    'Like New': '150.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1oSqF3cmoopoWGS4IeIqELw09rbt-75qi/view?usp=sharing',
    'Photo ID': '1oSqF3cmoopoWGS4IeIqELw09rbt-75qi',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1oSqF3cmoopoWGS4IeIqELw09rbt-75qi',
  },
  {
    Make: 'ProKennex',
    Model: 'Black Ace Ovation',
    Retail: '250.00',
    New: '175.00',
    'Like New': '150.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1jyWhSF6B7rG_8XxxHPz8qOpYWJK2snn3/view?usp=sharing',
    'Photo ID': '1jyWhSF6B7rG_8XxxHPz8qOpYWJK2snn3',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1jyWhSF6B7rG_8XxxHPz8qOpYWJK2snn3',
  },
  {
    Make: 'ProKennex',
    Model: 'Black Ace Pro',
    Retail: '250.00',
    New: '175.00',
    'Like New': '150.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1SoHA-P9CjUkTJxJx1TkOIQXRG7yoStBr/view?usp=sharing',
    'Photo ID': '1SoHA-P9CjUkTJxJx1TkOIQXRG7yoStBr',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1SoHA-P9CjUkTJxJx1TkOIQXRG7yoStBr',
  },
  {
    Make: 'ProKennex',
    Model: 'Black Ace XF',
    Retail: '250.00',
    New: '175.00',
    'Like New': '150.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1XPuTutrlugHwd0rNxKOrlOEETJmkTunv/view?usp=sharing',
    'Photo ID': '1XPuTutrlugHwd0rNxKOrlOEETJmkTunv',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1XPuTutrlugHwd0rNxKOrlOEETJmkTunv',
  },
  {
    Make: 'ProKennex',
    Model: 'Kinetic',
    Retail: '189.95',
    New: '130.00',
    'Like New': '110.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1HhiKqgu_O9Zcxs8sGdgGiy5hFQk3POK9/view?usp=sharing',
    'Photo ID': '1HhiKqgu_O9Zcxs8sGdgGiy5hFQk3POK9',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1HhiKqgu_O9Zcxs8sGdgGiy5hFQk3POK9',
  },
  {
    Make: 'ProKennex',
    Model: 'Ovation Flight',
    Retail: '199.95',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1-3fw6LD-UzNgpQjT-jYnD3SH4srC9wCO/view?usp=sharing',
    'Photo ID': '1-3fw6LD-UzNgpQjT-jYnD3SH4srC9wCO',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1-3fw6LD-UzNgpQjT-jYnD3SH4srC9wCO',
  },
  {
    Make: 'ProKennex',
    Model: 'Ovation Speed II',
    Retail: '179.95',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1hJU_svAW73sdAeDxIRdD3oUbx58IzCVi/view?usp=sharing',
    'Photo ID': '1hJU_svAW73sdAeDxIRdD3oUbx58IzCVi',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1hJU_svAW73sdAeDxIRdD3oUbx58IzCVi',
  },
  {
    Make: 'ProKennex',
    Model: 'Ovation Spin',
    Retail: '220.00',
    New: '150.00',
    'Like New': '130.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1kh_2tjvNpC_amhp6__T2EMjM8QT6c2Ng/view?usp=sharing',
    'Photo ID': '1kh_2tjvNpC_amhp6__T2EMjM8QT6c2Ng',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1kh_2tjvNpC_amhp6__T2EMjM8QT6c2Ng',
  },
  {
    Make: 'ProKennex',
    Model: 'Pro Spin',
    Retail: '220.00',
    New: '150.00',
    'Like New': '130.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1eZNHnwNMvOQkfUhA2ZNn0M3YcmuWyHoy/view?usp=sharing',
    'Photo ID': '1eZNHnwNMvOQkfUhA2ZNn0M3YcmuWyHoy',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1eZNHnwNMvOQkfUhA2ZNn0M3YcmuWyHoy',
  },
  {
    Make: 'Prolite',
    Model: 'Bolt',
    Retail: '65.00',
    New: '45.00',
    'Like New': '35.00',
    Good: '30.00',
    'Photo URL': 'https://drive.google.com/file/d/1UEC2_DW-RXZdNL9h6tbrNSthhiz4q4-_/view?usp=sharing',
    'Photo ID': '1UEC2_DW-RXZdNL9h6tbrNSthhiz4q4-_',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1UEC2_DW-RXZdNL9h6tbrNSthhiz4q4-_',
  },
  {
    Make: 'Prolite',
    Model: 'Crush PowerSpin 2.0',
    Retail: '100.00',
    New: '70.00',
    'Like New': '60.00',
    Good: '50.00',
    'Photo URL': 'https://drive.google.com/file/d/1z4Q8Tz1l5k4ATtv6ktu4yvM5SuTtQusX/view?usp=sharing',
    'Photo ID': '1z4Q8Tz1l5k4ATtv6ktu4yvM5SuTtQusX',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1z4Q8Tz1l5k4ATtv6ktu4yvM5SuTtQusX',
  },
  {
    Make: 'Prolite',
    Model: 'Custom Crush 2.0',
    Retail: '150.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1gFnnziqghtXnrq2HBj_hYr2sMA-zTZg9/view?usp=sharing',
    'Photo ID': '1gFnnziqghtXnrq2HBj_hYr2sMA-zTZg9',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1gFnnziqghtXnrq2HBj_hYr2sMA-zTZg9',
  },
  {
    Make: 'Prolite',
    Model: 'K2 Power',
    Retail: '180.00',
    New: '125.00',
    'Like New': '105.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1dKdndzSE9mf5qaiHIlL843Xvj0OEuvhn/view?usp=sharing',
    'Photo ID': '1dKdndzSE9mf5qaiHIlL843Xvj0OEuvhn',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1dKdndzSE9mf5qaiHIlL843Xvj0OEuvhn',
  },
  {
    Make: 'Prolite',
    Model: 'Rebel PowerSpin 2.0',
    Retail: '100.00',
    New: '70.00',
    'Like New': '60.00',
    Good: '50.00',
    'Photo URL': 'https://drive.google.com/file/d/1COXgqG8h-gw4NIYhMSn6pOvWSlG2hy5O/view?usp=sharing',
    'Photo ID': '1COXgqG8h-gw4NIYhMSn6pOvWSlG2hy5O',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1COXgqG8h-gw4NIYhMSn6pOvWSlG2hy5O',
  },
  {
    Make: 'Prolite',
    Model: 'Rival PowerSpin 2.0',
    Retail: '100.00',
    New: '70.00',
    'Like New': '60.00',
    Good: '50.00',
    'Photo URL': 'https://drive.google.com/file/d/11wJ-js1HcGDxiE9NtjHNOqJHAm3rPdHC/view?usp=sharing',
    'Photo ID': '11wJ-js1HcGDxiE9NtjHNOqJHAm3rPdHC',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=11wJ-js1HcGDxiE9NtjHNOqJHAm3rPdHC',
  },
  {
    Make: 'Prolite',
    Model: 'Stealth GS1',
    Retail: '180.00',
    New: '125.00',
    'Like New': '105.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1lOlb8JFZk9ca0Tqe1uhjAYC8oCbAiDqc/view?usp=sharing',
    'Photo ID': '1lOlb8JFZk9ca0Tqe1uhjAYC8oCbAiDqc',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1lOlb8JFZk9ca0Tqe1uhjAYC8oCbAiDqc',
  },
  {
    Make: 'Prolite',
    Model: 'Supernova Pro LX',
    Retail: '189.99',
    New: '130.00',
    'Like New': '110.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1LCkSvUWOrRO2Wm9CxiGCRHvYc1R5axgN/view?usp=sharing',
    'Photo ID': '1LCkSvUWOrRO2Wm9CxiGCRHvYc1R5axgN',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1LCkSvUWOrRO2Wm9CxiGCRHvYc1R5axgN',
  },
  {
    Make: 'Prolite',
    Model: 'Titan LRG Pro LX',
    Retail: '200.00',
    New: '140.00',
    'Like New': '120.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/1S8hun6V-84jUcGOIzhbYxHLbeURsDQIu/view?usp=sharing',
    'Photo ID': '1S8hun6V-84jUcGOIzhbYxHLbeURsDQIu',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1S8hun6V-84jUcGOIzhbYxHLbeURsDQIu',
  },
  {
    Make: 'Prolite',
    Model: 'Titan Pro LX',
    Retail: '200.00',
    New: '140.00',
    'Like New': '120.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/1X_jjYAgqYzTub6qOGbIMDACkEHiZTw94/view?usp=sharing',
    'Photo ID': '1X_jjYAgqYzTub6qOGbIMDACkEHiZTw94',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1X_jjYAgqYzTub6qOGbIMDACkEHiZTw94',
  },
  {
    Make: 'Proton',
    Model: 'Series Four - Project Roadrunner',
    Retail: '300.00',
    New: '210.00',
    'Like New': '180.00',
    Good: '150.00',
    'Photo URL': 'https://drive.google.com/file/d/1NNI4gisb8auKNSxONdg8Lsdx6ipi__ta/view?usp=sharing',
    'Photo ID': '1NNI4gisb8auKNSxONdg8Lsdx6ipi__ta',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1NNI4gisb8auKNSxONdg8Lsdx6ipi__ta',
  },
  {
    Make: 'Proton',
    Model: 'Series One - Type A - Player Model',
    Retail: '280.00',
    New: '195.00',
    'Like New': '165.00',
    Good: '140.00',
    'Photo URL': 'https://drive.google.com/file/d/1XlwfxjCtmLywAG8Vn74N2K5bVwzwAy-y/view?usp=sharing',
    'Photo ID': '1XlwfxjCtmLywAG8Vn74N2K5bVwzwAy-y',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1XlwfxjCtmLywAG8Vn74N2K5bVwzwAy-y',
  },
  {
    Make: 'Proton',
    Model: 'Series One - Type A - Tournament',
    Retail: '280.00',
    New: '195.00',
    'Like New': '165.00',
    Good: '140.00',
    'Photo URL': 'https://drive.google.com/file/d/1k7mC22XHi1daOxvB063q_lRl5QN0tNF7/view?usp=sharing',
    'Photo ID': '1k7mC22XHi1daOxvB063q_lRl5QN0tNF7',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1k7mC22XHi1daOxvB063q_lRl5QN0tNF7',
  },
  {
    Make: 'Proton',
    Model: 'Series Three - Project Flamingo',
    Retail: '280.00',
    New: '195.00',
    'Like New': '165.00',
    Good: '140.00',
    'Photo URL': 'https://drive.google.com/file/d/1Nap0jkNFMca5gRfvsVt1_Wi6sUkqMNzg/view?usp=sharing',
    'Photo ID': '1Nap0jkNFMca5gRfvsVt1_Wi6sUkqMNzg',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Nap0jkNFMca5gRfvsVt1_Wi6sUkqMNzg',
  },
  {
    Make: 'Proton',
    Model: 'Series Three - Raw Carbon',
    Retail: '250.00',
    New: '175.00',
    'Like New': '150.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1HqsK9iw__L275RXE2G-hhAf-pWmyG6rQ/view?usp=sharing',
    'Photo ID': '1HqsK9iw__L275RXE2G-hhAf-pWmyG6rQ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1HqsK9iw__L275RXE2G-hhAf-pWmyG6rQ',
  },
  {
    Make: 'Proton',
    Model: 'Series Three - Year of the Snake',
    Retail: '350.00',
    New: '245.00',
    'Like New': '210.00',
    Good: '175.00',
    'Photo URL': 'https://drive.google.com/file/d/1wYnnx-8sfNVh9onaHjJ-eycX1dR_U48o/view?usp=sharing',
    'Photo ID': '1wYnnx-8sfNVh9onaHjJ-eycX1dR_U48o',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1wYnnx-8sfNVh9onaHjJ-eycX1dR_U48o',
  },
  {
    Make: 'Proton',
    Model: 'Series Two - Edgeless Ultra Soft',
    Retail: '220.00',
    New: '150.00',
    'Like New': '130.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1ADkYAjPJP2zgJOSGeBZ0dd7l0TDOqysm/view?usp=sharing',
    'Photo ID': '1ADkYAjPJP2zgJOSGeBZ0dd7l0TDOqysm',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ADkYAjPJP2zgJOSGeBZ0dd7l0TDOqysm',
  },
  {
    Make: 'ProXR',
    Model: 'Beth Bellamy Diamond Series',
    Retail: '179.99',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1opf7npNXpx5bNp_mHpZEjGIEfvd6SUfv/view?usp=sharing',
    'Photo ID': '1opf7npNXpx5bNp_mHpZEjGIEfvd6SUfv',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1opf7npNXpx5bNp_mHpZEjGIEfvd6SUfv',
  },
  {
    Make: 'ProXR',
    Model: 'Connor Garnett Signature',
    Retail: '209.99',
    New: '145.00',
    'Like New': '125.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/1TLyys_xGi7s4y_wxzLT5ncPpMWkK76qz/view?usp=sharing',
    'Photo ID': '1TLyys_xGi7s4y_wxzLT5ncPpMWkK76qz',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1TLyys_xGi7s4y_wxzLT5ncPpMWkK76qz',
  },
  {
    Make: 'ProXR',
    Model: 'John Cincola',
    Retail: '209.99',
    New: '145.00',
    'Like New': '125.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/19DazEzNokLK5nB_iCVithJNecTtJJ2Pe/view?usp=sharing',
    'Photo ID': '19DazEzNokLK5nB_iCVithJNecTtJJ2Pe',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=19DazEzNokLK5nB_iCVithJNecTtJJ2Pe',
  },
  {
    Make: 'ProXR',
    Model: 'Protohype XIX',
    Retail: '250.00',
    New: '175.00',
    'Like New': '150.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1WILD77OC3Btvp34h7CSj141A-8qH1f5D/view?usp=sharing',
    'Photo ID': '1WILD77OC3Btvp34h7CSj141A-8qH1f5D',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1WILD77OC3Btvp34h7CSj141A-8qH1f5D',
  },
  {
    Make: 'ProXR',
    Model: 'Protohype XXI',
    Retail: '250.00',
    New: '175.00',
    'Like New': '150.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/1--izQNKC6xf-UDhFCVh5pqBSe78JUZSu/view?usp=sharing',
    'Photo ID': '1--izQNKC6xf-UDhFCVh5pqBSe78JUZSu',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1--izQNKC6xf-UDhFCVh5pqBSe78JUZSu',
  },
  {
    Make: 'ProXR',
    Model: 'Signature 16',
    Retail: '209.99',
    New: '145.00',
    'Like New': '125.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/1OXij11t-fFIxuq1hLFCUA9xcB4RktMjk/view?usp=sharing',
    'Photo ID': '1OXij11t-fFIxuq1hLFCUA9xcB4RktMjk',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1OXij11t-fFIxuq1hLFCUA9xcB4RktMjk',
  },
  {
    Make: 'ProXR',
    Model: 'Signature Jolt',
    Retail: '119.99',
    New: '80.00',
    'Like New': '70.00',
    Good: '55.00',
    'Photo URL': 'https://drive.google.com/file/d/1G86tG0Q8du5bUV1a1Gi96nfzt5fF574X/view?usp=sharing',
    'Photo ID': '1G86tG0Q8du5bUV1a1Gi96nfzt5fF574X',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1G86tG0Q8du5bUV1a1Gi96nfzt5fF574X',
  },
  {
    Make: 'ProXR',
    Model: 'Signature Series',
    Retail: '209.99',
    New: '145.00',
    'Like New': '125.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/1r5-M9zn51IUmFccgWSjPpGKGzgXFzuDG/view?usp=sharing',
    'Photo ID': '1r5-M9zn51IUmFccgWSjPpGKGzgXFzuDG',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1r5-M9zn51IUmFccgWSjPpGKGzgXFzuDG',
  },
  {
    Make: 'ProXR',
    Model: 'Sweet Spot Max',
    Retail: '209.99',
    New: '145.00',
    'Like New': '125.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/1MBypu52O4CsdpUDYXd1GVh6MS5hzmqZz/view?usp=sharing',
    'Photo ID': '1MBypu52O4CsdpUDYXd1GVh6MS5hzmqZz',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1MBypu52O4CsdpUDYXd1GVh6MS5hzmqZz',
  },
  {
    Make: 'ProXR',
    Model: 'Zane Navratil "The Standard"',
    Retail: '209.99',
    New: '145.00',
    'Like New': '125.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/1UhhkWh9PEoDGplMlKhFy5xUP9wb1KvKq/view?usp=sharing',
    'Photo ID': '1UhhkWh9PEoDGplMlKhFy5xUP9wb1KvKq',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1UhhkWh9PEoDGplMlKhFy5xUP9wb1KvKq',
  },
  {
    Make: 'ProXR',
    Model: 'Zane Navratil Signature',
    Retail: '209.99',
    New: '145.00',
    'Like New': '125.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/1Jt4fB4hGZcy978pwK0DmwhmszkbaJTdD/view?usp=sharing',
    'Photo ID': '1Jt4fB4hGZcy978pwK0DmwhmszkbaJTdD',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Jt4fB4hGZcy978pwK0DmwhmszkbaJTdD',
  },
  {
    Make: 'Revolin',
    Model: 'Revo Pro Pure Hybrid',
    Retail: '219.99',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1Bj47gVkXKGgn0M96VviL5lrGtcIijjHi/view?usp=sharing',
    'Photo ID': '1Bj47gVkXKGgn0M96VviL5lrGtcIijjHi',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Bj47gVkXKGgn0M96VviL5lrGtcIijjHi',
  },
  {
    Make: 'Revolin',
    Model: 'Revo Pro Reach Hybrid',
    Retail: '219.99',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1REr5rvGzsrDzvb7TWi5U3cgL-h92R7fB/view?usp=sharing',
    'Photo ID': '1REr5rvGzsrDzvb7TWi5U3cgL-h92R7fB',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1REr5rvGzsrDzvb7TWi5U3cgL-h92R7fB',
  },
  {
    Make: 'Revolin',
    Model: 'Revo Pure Control',
    Retail: '150.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1aCqWmpq64aiRHbVrwIoR-Xbe9-mMTdew/view?usp=sharing',
    'Photo ID': '1aCqWmpq64aiRHbVrwIoR-Xbe9-mMTdew',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1aCqWmpq64aiRHbVrwIoR-Xbe9-mMTdew',
  },
  {
    Make: 'Revolin',
    Model: 'Revo Pure Power',
    Retail: '150.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1tcWsWuMEjYFpFKWjn1HXFKad28LerbUK/view?usp=sharing',
    'Photo ID': '1tcWsWuMEjYFpFKWjn1HXFKad28LerbUK',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1tcWsWuMEjYFpFKWjn1HXFKad28LerbUK',
  },
  {
    Make: 'Revolin',
    Model: 'Revo Reach Control',
    Retail: '150.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1Zg-iVtCCoQjxLzIzzGc-kVtf_AiwBN5A/view?usp=sharing',
    'Photo ID': '1Zg-iVtCCoQjxLzIzzGc-kVtf_AiwBN5A',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Zg-iVtCCoQjxLzIzzGc-kVtf_AiwBN5A',
  },
  {
    Make: 'Revolin',
    Model: 'Revo Reach Power',
    Retail: '150.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1tP5Ca_IfXQ_YQ165F1lx0me38vbyk6-O/view?usp=sharing',
    'Photo ID': '1tP5Ca_IfXQ_YQ165F1lx0me38vbyk6-O',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1tP5Ca_IfXQ_YQ165F1lx0me38vbyk6-O',
  },
  {
    Make: 'Revolin',
    Model: 'Rise',
    Retail: '109.99',
    New: '75.00',
    'Like New': '65.00',
    Good: '50.00',
    'Photo URL': 'https://drive.google.com/file/d/13O_I_pXSyCsp3iJyNImVksT_mSzLZF0Y/view?usp=sharing',
    'Photo ID': '13O_I_pXSyCsp3iJyNImVksT_mSzLZF0Y',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=13O_I_pXSyCsp3iJyNImVksT_mSzLZF0Y',
  },
  {
    Make: 'Rokne',
    Model: 'Aero Blade 1.19',
    Retail: '299.99',
    New: '205.00',
    'Like New': '175.00',
    Good: '145.00',
    'Photo URL': 'https://drive.google.com/file/d/11VThB9SPS0bp2g40PMrF3jvTFK4apxke/view?usp=sharing',
    'Photo ID': '11VThB9SPS0bp2g40PMrF3jvTFK4apxke',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=11VThB9SPS0bp2g40PMrF3jvTFK4apxke',
  },
  {
    Make: 'Rokne',
    Model: 'Current - LTE 13',
    Retail: '139.99',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/1LyfaKvRjzPgH6gYI4AGpYwCChVhq3tn_/view?usp=sharing',
    'Photo ID': '1LyfaKvRjzPgH6gYI4AGpYwCChVhq3tn_',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1LyfaKvRjzPgH6gYI4AGpYwCChVhq3tn_',
  },
  {
    Make: 'Rokne',
    Model: 'Current - LTE 16',
    Retail: '139.99',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/1gPoXpj2CcTJq3kmJdFDH8Z4UXWYKU_Ku/view?usp=sharing',
    'Photo ID': '1gPoXpj2CcTJq3kmJdFDH8Z4UXWYKU_Ku',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1gPoXpj2CcTJq3kmJdFDH8Z4UXWYKU_Ku',
  },
  {
    Make: 'Rokne',
    Model: 'Curve Classic LTE',
    Retail: '79.99',
    New: '55.00',
    'Like New': '45.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/1na5dkjHoc-DoVAH1ZVSendfny4bXC3WP/view?usp=sharing',
    'Photo ID': '1na5dkjHoc-DoVAH1ZVSendfny4bXC3WP',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1na5dkjHoc-DoVAH1ZVSendfny4bXC3WP',
  },
  {
    Make: 'Rokne',
    Model: 'Curve Classic Original',
    Retail: '89.99',
    New: '60.00',
    'Like New': '50.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1fKsaiEQxwXzL4HmLx6VbtvoQzvb5u7ON/view?usp=sharing',
    'Photo ID': '1fKsaiEQxwXzL4HmLx6VbtvoQzvb5u7ON',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1fKsaiEQxwXzL4HmLx6VbtvoQzvb5u7ON',
  },
  {
    Make: 'Rokne',
    Model: 'Curve Classic Raw',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1v4pHeMLnNKJanIeqeODzcshreQLIMPNp/view?usp=sharing',
    'Photo ID': '1v4pHeMLnNKJanIeqeODzcshreQLIMPNp',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1v4pHeMLnNKJanIeqeODzcshreQLIMPNp',
  },
  {
    Make: 'Rokne',
    Model: 'Curve Classic Rec',
    Retail: '49.99',
    New: '30.00',
    'Like New': '25.00',
    Good: '20.00',
    'Photo URL': 'https://drive.google.com/file/d/1LIVOjB3um8aXVsxeCPckZd7vI6MfwaI6/view?usp=sharing',
    'Photo ID': '1LIVOjB3um8aXVsxeCPckZd7vI6MfwaI6',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1LIVOjB3um8aXVsxeCPckZd7vI6MfwaI6',
  },
  {
    Make: 'Rokne',
    Model: 'Pipeline - LTE 16',
    Retail: '139.99',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/17e7U7LnTOsTwdVybQKPnh7nEhLrZJWVT/view?usp=sharing',
    'Photo ID': '17e7U7LnTOsTwdVybQKPnh7nEhLrZJWVT',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=17e7U7LnTOsTwdVybQKPnh7nEhLrZJWVT',
  },
  {
    Make: 'Rokne',
    Model: 'Republic 1.16',
    Retail: '189.99',
    New: '130.00',
    'Like New': '110.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1jnGkNEvCZR1_v9CEw2rO01pTUZrqcAbl/view?usp=sharing',
    'Photo ID': '1jnGkNEvCZR1_v9CEw2rO01pTUZrqcAbl',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1jnGkNEvCZR1_v9CEw2rO01pTUZrqcAbl',
  },
  {
    Make: 'Rokne',
    Model: 'Republic 2.16',
    Retail: '209.99',
    New: '145.00',
    'Like New': '125.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/1i9IsooecsTbxWgr6kA9rn_LernrBxCr3/view?usp=sharing',
    'Photo ID': '1i9IsooecsTbxWgr6kA9rn_LernrBxCr3',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1i9IsooecsTbxWgr6kA9rn_LernrBxCr3',
  },
  {
    Make: 'Rokne',
    Model: 'Republic 3.16',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1rLP5hHuqF7Ng-UD61GhY1B__8gY8inRw/view?usp=sharing',
    'Photo ID': '1rLP5hHuqF7Ng-UD61GhY1B__8gY8inRw',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1rLP5hHuqF7Ng-UD61GhY1B__8gY8inRw',
  },
  {
    Make: 'Rokne',
    Model: 'Taktical Carbon 13mm',
    Retail: '189.99',
    New: '130.00',
    'Like New': '110.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1Db21mdMaTdEv5sU571ozAP5awNXQb83g/view?usp=sharing',
    'Photo ID': '1Db21mdMaTdEv5sU571ozAP5awNXQb83g',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Db21mdMaTdEv5sU571ozAP5awNXQb83g',
  },
  {
    Make: 'Rokne',
    Model: 'Taktical Carbon 16mm',
    Retail: '189.99',
    New: '130.00',
    'Like New': '110.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1yK6rQIg__PyYEvHwZRR9yF1zsovXeM_U/view?usp=sharing',
    'Photo ID': '1yK6rQIg__PyYEvHwZRR9yF1zsovXeM_U',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1yK6rQIg__PyYEvHwZRR9yF1zsovXeM_U',
  },
  {
    Make: 'Ronbus',
    Model: 'Nova R1',
    Retail: '180.00',
    New: '125.00',
    'Like New': '105.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1TYFRMWySW34iwP1jDr4jGIkwQhumj-cP/view?usp=sharing',
    'Photo ID': '1TYFRMWySW34iwP1jDr4jGIkwQhumj-cP',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1TYFRMWySW34iwP1jDr4jGIkwQhumj-cP',
  },
  {
    Make: 'Ronbus',
    Model: 'Nova R2',
    Retail: '180.00',
    New: '125.00',
    'Like New': '105.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1Cc68LWzCFWjudHT4X-W18wmxUtBA9cx1/view?usp=sharing',
    'Photo ID': '1Cc68LWzCFWjudHT4X-W18wmxUtBA9cx1',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Cc68LWzCFWjudHT4X-W18wmxUtBA9cx1',
  },
  {
    Make: 'Ronbus',
    Model: 'Nova R3',
    Retail: '180.00',
    New: '125.00',
    'Like New': '105.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1HsgoSa6dhYP8UU6WJksaaX5V8XePW2aD/view?usp=sharing',
    'Photo ID': '1HsgoSa6dhYP8UU6WJksaaX5V8XePW2aD',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1HsgoSa6dhYP8UU6WJksaaX5V8XePW2aD',
  },
  {
    Make: 'Ronbus',
    Model: 'Quanta R1.16',
    Retail: '119.99',
    New: '80.00',
    'Like New': '70.00',
    Good: '55.00',
    'Photo URL': 'https://drive.google.com/file/d/1C24kePCShszitj6j9e7gFLXmSwbXpxQS/view?usp=sharing',
    'Photo ID': '1C24kePCShszitj6j9e7gFLXmSwbXpxQS',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1C24kePCShszitj6j9e7gFLXmSwbXpxQS',
  },
  {
    Make: 'Ronbus',
    Model: 'Quanta R2.16',
    Retail: '119.99',
    New: '80.00',
    'Like New': '70.00',
    Good: '55.00',
    'Photo URL': 'https://drive.google.com/file/d/111PX-sSk4B22_YYm3xyg3UkWKhgTLHAl/view?usp=sharing',
    'Photo ID': '111PX-sSk4B22_YYm3xyg3UkWKhgTLHAl',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=111PX-sSk4B22_YYm3xyg3UkWKhgTLHAl',
  },
  {
    Make: 'Ronbus',
    Model: 'Quanta R3.16',
    Retail: '119.99',
    New: '80.00',
    'Like New': '70.00',
    Good: '55.00',
    'Photo URL': 'https://drive.google.com/file/d/1ZmHQDWYIsstUqpDNkS23AXj9wMr-8wiE/view?usp=sharing',
    'Photo ID': '1ZmHQDWYIsstUqpDNkS23AXj9wMr-8wiE',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ZmHQDWYIsstUqpDNkS23AXj9wMr-8wiE',
  },
  {
    Make: 'Ronbus',
    Model: 'Quanta R4.16',
    Retail: '119.99',
    New: '80.00',
    'Like New': '70.00',
    Good: '55.00',
    'Photo URL': 'https://drive.google.com/file/d/1BG0iEp2XZ0Dhz_PACCLSRxgA5cIpFaoc/view?usp=sharing',
    'Photo ID': '1BG0iEp2XZ0Dhz_PACCLSRxgA5cIpFaoc',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1BG0iEp2XZ0Dhz_PACCLSRxgA5cIpFaoc',
  },
  {
    Make: 'Ronbus',
    Model: 'Quanta R5.16',
    Retail: '119.99',
    New: '80.00',
    'Like New': '70.00',
    Good: '55.00',
    'Photo URL': 'https://drive.google.com/file/d/1HhNt54oKSV7r-dOHh8MCfYXlzuTTbMgu/view?usp=sharing',
    'Photo ID': '1HhNt54oKSV7r-dOHh8MCfYXlzuTTbMgu',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1HhNt54oKSV7r-dOHh8MCfYXlzuTTbMgu',
  },
  {
    Make: 'Ronbus',
    Model: 'R1 Pulsar',
    Retail: '170.00',
    New: '115.00',
    'Like New': '100.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1TnJQx3eUD6KudT3C1CboSIstPjE1PkXC/view?usp=sharing',
    'Photo ID': '1TnJQx3eUD6KudT3C1CboSIstPjE1PkXC',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1TnJQx3eUD6KudT3C1CboSIstPjE1PkXC',
  },
  {
    Make: 'Ronbus',
    Model: 'R1 Pulsar FX',
    Retail: '180.00',
    New: '125.00',
    'Like New': '105.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1aCJQ85NgthUVYhnNj64dSnBeIkGyK0XL/view?usp=sharing',
    'Photo ID': '1aCJQ85NgthUVYhnNj64dSnBeIkGyK0XL',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1aCJQ85NgthUVYhnNj64dSnBeIkGyK0XL',
  },
  {
    Make: 'Ronbus',
    Model: 'R1.16',
    Retail: '120.00',
    New: '80.00',
    'Like New': '70.00',
    Good: '60.00',
    'Photo URL': 'https://drive.google.com/file/d/1Eld4bVVfY8_YKCSpOutxYZsUEGgxF-SL/view?usp=sharing',
    'Photo ID': '1Eld4bVVfY8_YKCSpOutxYZsUEGgxF-SL',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Eld4bVVfY8_YKCSpOutxYZsUEGgxF-SL',
  },
  {
    Make: 'Ronbus',
    Model: 'R2 Pulsar FX',
    Retail: '180.00',
    New: '125.00',
    'Like New': '105.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1wCdgst04OYs3YQ5YnmplfJwtyuLUZc7T/view?usp=sharing',
    'Photo ID': '1wCdgst04OYs3YQ5YnmplfJwtyuLUZc7T',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1wCdgst04OYs3YQ5YnmplfJwtyuLUZc7T',
  },
  {
    Make: 'Ronbus',
    Model: 'R2.16',
    Retail: '120.00',
    New: '80.00',
    'Like New': '70.00',
    Good: '60.00',
    'Photo URL': 'https://drive.google.com/file/d/19arQ6lNW9GytAp5LMj3bhG8kMMgtASQ3/view?usp=sharing',
    'Photo ID': '19arQ6lNW9GytAp5LMj3bhG8kMMgtASQ3',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=19arQ6lNW9GytAp5LMj3bhG8kMMgtASQ3',
  },
  {
    Make: 'Ronbus',
    Model: 'R3 Pulsar',
    Retail: '150.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1HIhwgQSs3rffLSIeBWsUfYEXTcTZU70h/view?usp=sharing',
    'Photo ID': '1HIhwgQSs3rffLSIeBWsUfYEXTcTZU70h',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1HIhwgQSs3rffLSIeBWsUfYEXTcTZU70h',
  },
  {
    Make: 'Ronbus',
    Model: 'R3 Pulsar FX',
    Retail: '180.00',
    New: '125.00',
    'Like New': '105.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1MvXV0rUZTl1cxbMrAXe-BdozPYg2jDnT/view?usp=sharing',
    'Photo ID': '1MvXV0rUZTl1cxbMrAXe-BdozPYg2jDnT',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1MvXV0rUZTl1cxbMrAXe-BdozPYg2jDnT',
  },
  {
    Make: 'Ronbus',
    Model: 'R3 Pulsar FX',
    Retail: '180.00',
    New: '125.00',
    'Like New': '105.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1MvXV0rUZTl1cxbMrAXe-BdozPYg2jDnT/view?usp=sharing',
    'Photo ID': '1MvXV0rUZTl1cxbMrAXe-BdozPYg2jDnT',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1MvXV0rUZTl1cxbMrAXe-BdozPYg2jDnT',
  },
  {
    Make: 'Ronbus',
    Model: 'Refoam R4.14',
    Retail: '180.00',
    New: '125.00',
    'Like New': '105.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1ZMl1BysCfZ2g0_wkwsNIo29bNcY3wMaw/view?usp=sharing',
    'Photo ID': '1ZMl1BysCfZ2g0_wkwsNIo29bNcY3wMaw',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ZMl1BysCfZ2g0_wkwsNIo29bNcY3wMaw',
  },
  {
    Make: 'Ronbus',
    Model: 'Ripple V2 R1.14',
    Retail: '280.00',
    New: '195.00',
    'Like New': '165.00',
    Good: '140.00',
    'Photo URL': 'https://drive.google.com/file/d/1adLpMlrDbgLJTQ1pyTvrX7eznLx3g9KY/view?usp=sharing',
    'Photo ID': '1adLpMlrDbgLJTQ1pyTvrX7eznLx3g9KY',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1adLpMlrDbgLJTQ1pyTvrX7eznLx3g9KY',
  },
  {
    Make: 'Ronbus',
    Model: 'Ripple V2 R2.14',
    Retail: '280.00',
    New: '195.00',
    'Like New': '165.00',
    Good: '140.00',
    'Photo URL': 'https://drive.google.com/file/d/1fX-K7oAo6MN4zpz4TWYt8wW1OuLE25xb/view?usp=sharing',
    'Photo ID': '1fX-K7oAo6MN4zpz4TWYt8wW1OuLE25xb',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1fX-K7oAo6MN4zpz4TWYt8wW1OuLE25xb',
  },
  {
    Make: 'Ronbus',
    Model: 'Ripple V2 R4.14',
    Retail: '280.00',
    New: '195.00',
    'Like New': '165.00',
    Good: '140.00',
    'Photo URL': 'https://drive.google.com/file/d/1nCJ-nXiKBj66w1zSaMRQT7rCXSQb8ii4/view?usp=sharing',
    'Photo ID': '1nCJ-nXiKBj66w1zSaMRQT7rCXSQb8ii4',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1nCJ-nXiKBj66w1zSaMRQT7rCXSQb8ii4',
  },
  {
    Make: 'RPM',
    Model: 'Friction Pro',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1W5xycupGabt5Iy0sBmDLVNmIkN3SAanC/view?usp=drive_link',
    'Photo ID': '1W5xycupGabt5Iy0sBmDLVNmIkN3SAanC',
    GTIN: '850080047002',
  },
  {
    Make: 'RPM',
    Model: 'Friction Pro 2',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1d8luLnLrpmc0Jb5laIygxohzud5kyyux/view?usp=drive_link',
    'Photo ID': '1d8luLnLrpmc0Jb5laIygxohzud5kyyux',
    GTIN: '850080047040',
  },
  {
    Make: 'RPM',
    Model: 'Q2',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/18va5xiBhJZ7XujRDsrVlA29ytTwHn6t3/view?usp=drive_link',
    'Photo ID': '18va5xiBhJZ7XujRDsrVlA29ytTwHn6t3',
    GTIN: '850080047064',
  },
  {
    Make: 'Selkirk',
    Model: 'Amped - Epic',
    Retail: '150.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1b6vKB25E_nfFffM-rbhctEXfoU8uQi4z/view?usp=sharing',
    'Photo ID': '1b6vKB25E_nfFffM-rbhctEXfoU8uQi4z',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1b6vKB25E_nfFffM-rbhctEXfoU8uQi4z',
  },
  {
    Make: 'Selkirk',
    Model: 'Amped - Invikta',
    Retail: '150.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1vYoSwcR8XsZidGhVXX5UMnyvuFQ_VkFr/view?usp=sharing',
    'Photo ID': '1vYoSwcR8XsZidGhVXX5UMnyvuFQ_VkFr',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1vYoSwcR8XsZidGhVXX5UMnyvuFQ_VkFr',
  },
  {
    Make: 'Selkirk',
    Model: 'Amped - S2',
    Retail: '150.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1aWZARK4IZ9GoIzrHHRS6wJ7EFxkn8EPt/view?usp=sharing',
    'Photo ID': '1aWZARK4IZ9GoIzrHHRS6wJ7EFxkn8EPt',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1aWZARK4IZ9GoIzrHHRS6wJ7EFxkn8EPt',
  },
  {
    Make: 'Selkirk',
    Model: 'Amped Control - Epic',
    Retail: '160.00',
    New: '110.00',
    'Like New': '95.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/13vSf9AvSsfzV6KOvYp4B-bMrl8je16p3/view?usp=sharing',
    'Photo ID': '13vSf9AvSsfzV6KOvYp4B-bMrl8je16p3',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=13vSf9AvSsfzV6KOvYp4B-bMrl8je16p3',
  },
  {
    Make: 'Selkirk',
    Model: 'Amped Control - Invikta',
    Retail: '160.00',
    New: '110.00',
    'Like New': '95.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1fi-UKpg1j-JNNMwdfjeFr4a4dzKavLy8/view?usp=sharing',
    'Photo ID': '1fi-UKpg1j-JNNMwdfjeFr4a4dzKavLy8',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1fi-UKpg1j-JNNMwdfjeFr4a4dzKavLy8',
  },
  {
    Make: 'Selkirk',
    Model: 'Amped Control - S2',
    Retail: '160.00',
    New: '110.00',
    'Like New': '95.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1fhQYBemeylgXcHL6eOKBY_ZSDIqc7aDd/view?usp=sharing',
    'Photo ID': '1fhQYBemeylgXcHL6eOKBY_ZSDIqc7aDd',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1fhQYBemeylgXcHL6eOKBY_ZSDIqc7aDd',
  },
  {
    Make: 'Selkirk',
    Model: 'Amped Pro Air - Epic',
    Retail: '180.00',
    New: '125.00',
    'Like New': '105.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1eR_oxk2Ho9LpNDTnOb-91-JkUNAD8cX0/view?usp=sharing',
    'Photo ID': '1eR_oxk2Ho9LpNDTnOb-91-JkUNAD8cX0',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1eR_oxk2Ho9LpNDTnOb-91-JkUNAD8cX0',
  },
  {
    Make: 'Selkirk',
    Model: 'Amped Pro Air - Invikta',
    Retail: '180.00',
    New: '125.00',
    'Like New': '105.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1lEthXFWpScMl1KgiMNmb6OAk6ojTtITP/view?usp=sharing',
    'Photo ID': '1lEthXFWpScMl1KgiMNmb6OAk6ojTtITP',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1lEthXFWpScMl1KgiMNmb6OAk6ojTtITP',
  },
  {
    Make: 'Selkirk',
    Model: 'LUXX Control Air - Epic',
    Retail: '250.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1mW2lWi7qi2PRsqO9CxxwaRvId_1Wiidq/view?usp=sharing',
    'Photo ID': '1mW2lWi7qi2PRsqO9CxxwaRvId_1Wiidq',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1mW2lWi7qi2PRsqO9CxxwaRvId_1Wiidq',
  },
  {
    Make: 'Selkirk',
    Model: 'LUXX Control Air - Invikta',
    Retail: '250.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1XRpwSy98yTpB2bf6vinMkKRp4T0wIjGs/view?usp=sharing',
    'Photo ID': '1XRpwSy98yTpB2bf6vinMkKRp4T0wIjGs',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1XRpwSy98yTpB2bf6vinMkKRp4T0wIjGs',
  },
  {
    Make: 'Selkirk',
    Model: 'LUXX Control Air - Invikta Jack Sock',
    Retail: '250.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1VGfASTecE3UgEa7hk6BxwF0ebM9EG4ap/view?usp=sharing',
    'Photo ID': '1VGfASTecE3UgEa7hk6BxwF0ebM9EG4ap',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1VGfASTecE3UgEa7hk6BxwF0ebM9EG4ap',
  },
  {
    Make: 'Selkirk',
    Model: 'LUXX Control Air - S2',
    Retail: '250.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/11OGVOO09dOQ_kfSd4FxXppDYm9sbxU5H/view?usp=sharing',
    'Photo ID': '11OGVOO09dOQ_kfSd4FxXppDYm9sbxU5H',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=11OGVOO09dOQ_kfSd4FxXppDYm9sbxU5H',
  },
  {
    Make: 'Selkirk',
    Model: 'LUXX Control Air with InfiniGrit - Epic',
    Retail: '280.00',
    New: '195.00',
    'Like New': '165.00',
    Good: '140.00',
    'Photo URL': 'https://drive.google.com/file/d/1bw-y0KTGFpPF8kHgvGar103TjfapiqvY/view?usp=sharing',
    'Photo ID': '1bw-y0KTGFpPF8kHgvGar103TjfapiqvY',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1bw-y0KTGFpPF8kHgvGar103TjfapiqvY',
  },
  {
    Make: 'Selkirk',
    Model: 'LUXX Control Air with InfiniGrit - Invikta',
    Retail: '280.00',
    New: '195.00',
    'Like New': '165.00',
    Good: '140.00',
    'Photo URL': 'https://drive.google.com/file/d/1yrLoQOArNq2ynfjGjbV_dNRZlkAzfrHj/view?usp=sharing',
    'Photo ID': '1yrLoQOArNq2ynfjGjbV_dNRZlkAzfrHj',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1yrLoQOArNq2ynfjGjbV_dNRZlkAzfrHj',
  },
  {
    Make: 'Selkirk',
    Model: 'Selkirk Labs Project 001',
    Retail: '333.00',
    New: '230.00',
    'Like New': '195.00',
    Good: '165.00',
    'Photo URL': 'https://drive.google.com/file/d/1Nw6JMtFL1JuteFmHD4RmSNmHOLIbJ3X_/view?usp=sharing',
    'Photo ID': '1Nw6JMtFL1JuteFmHD4RmSNmHOLIbJ3X_',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Nw6JMtFL1JuteFmHD4RmSNmHOLIbJ3X_',
  },
  {
    Make: 'Selkirk',
    Model: 'Selkirk Labs Project 002',
    Retail: '333.00',
    New: '230.00',
    'Like New': '195.00',
    Good: '165.00',
    'Photo URL': 'https://drive.google.com/file/d/1C59Fz0YcuixNUsAhOf8UEugx8kYm1OqX/view?usp=sharing',
    'Photo ID': '1C59Fz0YcuixNUsAhOf8UEugx8kYm1OqX',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1C59Fz0YcuixNUsAhOf8UEugx8kYm1OqX',
  },
  {
    Make: 'Selkirk',
    Model: 'Selkirk Labs Project 003',
    Retail: '333.00',
    New: '230.00',
    'Like New': '195.00',
    Good: '165.00',
    'Photo URL': 'https://drive.google.com/file/d/1U5DCD8YSYM8AMJuhxCwdQHWT_V6lfhB6/view?usp=sharing',
    'Photo ID': '1U5DCD8YSYM8AMJuhxCwdQHWT_V6lfhB6',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1U5DCD8YSYM8AMJuhxCwdQHWT_V6lfhB6',
  },
  {
    Make: 'Selkirk',
    Model: 'Selkirk Labs Project 005',
    Retail: '222.00',
    New: '155.00',
    'Like New': '130.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1-lspLy8Ww_Ltn91Gu2VjCA_teWcFPrsw/view?usp=sharing',
    'Photo ID': '1-lspLy8Ww_Ltn91Gu2VjCA_teWcFPrsw',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1-lspLy8Ww_Ltn91Gu2VjCA_teWcFPrsw',
  },
  {
    Make: 'Selkirk',
    Model: 'Selkirk Labs Project 006',
    Retail: '333.00',
    New: '230.00',
    'Like New': '195.00',
    Good: '165.00',
    'Photo URL': 'https://drive.google.com/file/d/1ZB0vSpDsXKSsModyjxh2tAiKxIdZzKJO/view?usp=sharing',
    'Photo ID': '1ZB0vSpDsXKSsModyjxh2tAiKxIdZzKJO',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ZB0vSpDsXKSsModyjxh2tAiKxIdZzKJO',
  },
  {
    Make: 'Selkirk',
    Model: 'Selkirk Labs Project 007',
    Retail: '333.00',
    New: '230.00',
    'Like New': '195.00',
    Good: '165.00',
    'Photo URL': 'https://drive.google.com/file/d/16wRbd6ZIzpmXadQCqWfm_dTs0imZ86gb/view?usp=sharing',
    'Photo ID': '16wRbd6ZIzpmXadQCqWfm_dTs0imZ86gb',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=16wRbd6ZIzpmXadQCqWfm_dTs0imZ86gb',
  },
  {
    Make: 'Selkirk',
    Model: 'Selkirk Labs Project 008',
    Retail: '288.00',
    New: '200.00',
    'Like New': '170.00',
    Good: '140.00',
    'Photo URL': 'https://drive.google.com/file/d/19XgDJD67cZzLXN8QbaX-mRs3RTRuJx8D/view?usp=sharing',
    'Photo ID': '19XgDJD67cZzLXN8QbaX-mRs3RTRuJx8D',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=19XgDJD67cZzLXN8QbaX-mRs3RTRuJx8D',
  },
  {
    Make: 'Selkirk',
    Model: 'Selkirk Labs Project Boomstik',
    Retail: '333.00',
    New: '230.00',
    'Like New': '195.00',
    Good: '165.00',
    'Photo URL': 'https://drive.google.com/file/d/1P7Snjc5CZFzRNW1KITrN19jjTkSOD-Gz/view?usp=sharing',
    'Photo ID': '1P7Snjc5CZFzRNW1KITrN19jjTkSOD-Gz',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1P7Snjc5CZFzRNW1KITrN19jjTkSOD-Gz',
  },
  {
    Make: 'Selkirk',
    Model: 'Selkirk Labs x Tesla',
    Retail: '350.00',
    New: '245.00',
    'Like New': '210.00',
    Good: '175.00',
    'Photo URL': 'https://drive.google.com/file/d/1ZkizYQHCizPyY6q6WC65ZD5St6nFQrnQ/view?usp=drive_link',
    'Photo ID': '1ZkizYQHCizPyY6q6WC65ZD5St6nFQrnQ',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK Atlas - Max',
    Retail: '80.00',
    New: '55.00',
    'Like New': '45.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1x2Y7COEF4fzMG1WnmpdY4JRR_vj9OAXP/view?usp=sharing',
    'Photo ID': '1x2Y7COEF4fzMG1WnmpdY4JRR_vj9OAXP',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1x2Y7COEF4fzMG1WnmpdY4JRR_vj9OAXP',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK Atlas - XL',
    Retail: '80.00',
    New: '55.00',
    'Like New': '45.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1omfqzwyPZwHwC0UC-1il8d0UWajiqebc/view?usp=sharing',
    'Photo ID': '1omfqzwyPZwHwC0UC-1il8d0UWajiqebc',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1omfqzwyPZwHwC0UC-1il8d0UWajiqebc',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK Dauntless',
    Retail: '180.00',
    New: '125.00',
    'Like New': '105.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1RCuLvPiM2CVmhQyj9wTH2Y7VP6dbwLR4/view?usp=drive_link',
    'Photo ID': '1RCuLvPiM2CVmhQyj9wTH2Y7VP6dbwLR4',
    GTIN: '840309343534',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK ERA Power - Elongated',
    Retail: '200.00',
    New: '140.00',
    'Like New': '120.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/12Dkc6SYBpefLHnphcQ3RlgiaXhr17xmp/view?usp=sharing',
    'Photo ID': '12Dkc6SYBpefLHnphcQ3RlgiaXhr17xmp',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=12Dkc6SYBpefLHnphcQ3RlgiaXhr17xmp',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK ERA Power - Widebody',
    Retail: '200.00',
    New: '140.00',
    'Like New': '120.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/1FMgntBBg1Qdgw3SbFIN0oQUs7AX2PbGJ/view?usp=sharing',
    'Photo ID': '1FMgntBBg1Qdgw3SbFIN0oQUs7AX2PbGJ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1FMgntBBg1Qdgw3SbFIN0oQUs7AX2PbGJ',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK EVO Control - Max',
    Retail: '100.00',
    New: '70.00',
    'Like New': '60.00',
    Good: '50.00',
    'Photo URL': 'https://drive.google.com/file/d/1RDmqLg5_8MdE4ujBxy7mq1vPWKqxbtRa/view?usp=sharing',
    'Photo ID': '1RDmqLg5_8MdE4ujBxy7mq1vPWKqxbtRa',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1RDmqLg5_8MdE4ujBxy7mq1vPWKqxbtRa',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK EVO Control - XL',
    Retail: '100.00',
    New: '70.00',
    'Like New': '60.00',
    Good: '50.00',
    'Photo URL': 'https://drive.google.com/file/d/11pb6SzpCnB9W_lt5Pm_fsCCNNs_0DwSs/view?usp=sharing',
    'Photo ID': '11pb6SzpCnB9W_lt5Pm_fsCCNNs_0DwSs',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=11pb6SzpCnB9W_lt5Pm_fsCCNNs_0DwSs',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK EVO Power - Max',
    Retail: '100.00',
    New: '70.00',
    'Like New': '60.00',
    Good: '50.00',
    'Photo URL': 'https://drive.google.com/file/d/1_a91wdB7x2W7de7OlLW0sUef98j2t2bL/view?usp=sharing',
    'Photo ID': '1_a91wdB7x2W7de7OlLW0sUef98j2t2bL',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1_a91wdB7x2W7de7OlLW0sUef98j2t2bL',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK EVO Power - XL',
    Retail: '100.00',
    New: '70.00',
    'Like New': '60.00',
    Good: '50.00',
    'Photo URL': 'https://drive.google.com/file/d/1ZMpsU4_O5SfvVu8ENdIKUuGA_y6qVddK/view?usp=sharing',
    'Photo ID': '1ZMpsU4_O5SfvVu8ENdIKUuGA_y6qVddK',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ZMpsU4_O5SfvVu8ENdIKUuGA_y6qVddK',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK Geo',
    Retail: '100.00',
    New: '70.00',
    'Like New': '60.00',
    Good: '50.00',
    'Photo URL': 'https://drive.google.com/file/d/1_7qKmwuqWMmwr7VpXUnAHV223EDZJ7EB/view?usp=drive_link',
    'Photo ID': '1_7qKmwuqWMmwr7VpXUnAHV223EDZJ7EB',
    GTIN: '840309343459',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK Halo Control - Max',
    Retail: '140.00',
    New: '95.00',
    'Like New': '80.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1Q2pKRAihZvYGGYg31L0qLaodhR_HRyNZ/view?usp=sharing',
    'Photo ID': '1Q2pKRAihZvYGGYg31L0qLaodhR_HRyNZ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Q2pKRAihZvYGGYg31L0qLaodhR_HRyNZ',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK Halo Control - XL',
    Retail: '140.00',
    New: '95.00',
    'Like New': '80.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/18xSqj_OoFEpiUDJa9_rX-mgihiGE7clo/view?usp=sharing',
    'Photo ID': '18xSqj_OoFEpiUDJa9_rX-mgihiGE7clo',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=18xSqj_OoFEpiUDJa9_rX-mgihiGE7clo',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK Halo Power - Max',
    Retail: '140.00',
    New: '95.00',
    'Like New': '80.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1Tudkd_1psGimq-ReTcfAp_Sjgtk2v6ik/view?usp=sharing',
    'Photo ID': '1Tudkd_1psGimq-ReTcfAp_Sjgtk2v6ik',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Tudkd_1psGimq-ReTcfAp_Sjgtk2v6ik',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK Halo Power - XL',
    Retail: '140.00',
    New: '95.00',
    'Like New': '80.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1-MSuxYHuMZjCvIE-RI6wkcuxlkZgjcjw/view?usp=sharing',
    'Photo ID': '1-MSuxYHuMZjCvIE-RI6wkcuxlkZgjcjw',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1-MSuxYHuMZjCvIE-RI6wkcuxlkZgjcjw',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK Halo Pro - Max',
    Retail: '160.00',
    New: '110.00',
    'Like New': '95.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/18UHPGVh7_JG8qaP0OcU5B_1FZiZMpzTz/view?usp=sharing',
    'Photo ID': '18UHPGVh7_JG8qaP0OcU5B_1FZiZMpzTz',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=18UHPGVh7_JG8qaP0OcU5B_1FZiZMpzTz',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK Halo Pro - XL',
    Retail: '160.00',
    New: '110.00',
    'Like New': '95.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1hk9F6uuC3hRvCHnQp0MLO2mLtNz1D_r_/view?usp=sharing',
    'Photo ID': '1hk9F6uuC3hRvCHnQp0MLO2mLtNz1D_r_',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1hk9F6uuC3hRvCHnQp0MLO2mLtNz1D_r_',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK Latitude - Max',
    Retail: '70.00',
    New: '45.00',
    'Like New': '40.00',
    Good: '35.00',
    'Photo URL': 'https://drive.google.com/file/d/1twSMLzKN0KkcqjS6CkBRWxe60Lt4NndC/view?usp=sharing',
    'Photo ID': '1twSMLzKN0KkcqjS6CkBRWxe60Lt4NndC',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1twSMLzKN0KkcqjS6CkBRWxe60Lt4NndC',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK Omega Hybrid Air - Max',
    Retail: '120.00',
    New: '80.00',
    'Like New': '70.00',
    Good: '60.00',
    'Photo URL': 'https://drive.google.com/file/d/1F1_Wa4mj2qwgWbQSLdWqUaKDfFJtVf9S/view?usp=sharing',
    'Photo ID': '1F1_Wa4mj2qwgWbQSLdWqUaKDfFJtVf9S',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1F1_Wa4mj2qwgWbQSLdWqUaKDfFJtVf9S',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK Omega Hybrid Air - XL',
    Retail: '120.00',
    New: '80.00',
    'Like New': '70.00',
    Good: '60.00',
    'Photo URL': 'https://drive.google.com/file/d/1I8K-m7n8CCT1dnxPAAHjKNyAJRamwdpm/view?usp=sharing',
    'Photo ID': '1I8K-m7n8CCT1dnxPAAHjKNyAJRamwdpm',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1I8K-m7n8CCT1dnxPAAHjKNyAJRamwdpm',
  },
  {
    Make: 'Selkirk',
    Model: 'SLK Valkyrie',
    Retail: '80.00',
    New: '55.00',
    'Like New': '45.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1y_FAWPh-bCIhRh7P6RaHq8oQbhoFCf27/view?usp=drive_link',
    'Photo ID': '1y_FAWPh-bCIhRh7P6RaHq8oQbhoFCf27',
    GTIN: '840309343398',
  },
  {
    Make: 'Selkirk',
    Model: 'Vanguard 2.0 - Epic',
    Retail: '199.00',
    New: '105.00',
    'Like New': '85.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/1KRccBgi-1ANKoo3oFd3Rl_iunzitPxlY/view?usp=sharing',
    'Photo ID': '1KRccBgi-1ANKoo3oFd3Rl_iunzitPxlY',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1KRccBgi-1ANKoo3oFd3Rl_iunzitPxlY',
  },
  {
    Make: 'Selkirk',
    Model: 'Vanguard 2.0 - Invikta',
    Retail: '199.00',
    New: '105.00',
    'Like New': '85.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/1Mm8oXRXwKIp3w_4wiONy0ng8Cfnc68dh/view?usp=sharing',
    'Photo ID': '1Mm8oXRXwKIp3w_4wiONy0ng8Cfnc68dh',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Mm8oXRXwKIp3w_4wiONy0ng8Cfnc68dh',
  },
  {
    Make: 'Selkirk',
    Model: 'Vanguard 2.0 - S2',
    Retail: '199.00',
    New: '105.00',
    'Like New': '85.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/1pvlyBZS07rfu5lD604Su3kzV39UzI3AN/view?usp=sharing',
    'Photo ID': '1pvlyBZS07rfu5lD604Su3kzV39UzI3AN',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1pvlyBZS07rfu5lD604Su3kzV39UzI3AN',
  },
  {
    Make: 'Selkirk',
    Model: 'Vanguard Control - Epic',
    Retail: '200.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1EAsUyXvQiJAM_Azfn57xL0caScSyCDwZ/view?usp=sharing',
    'Photo ID': '1EAsUyXvQiJAM_Azfn57xL0caScSyCDwZ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1EAsUyXvQiJAM_Azfn57xL0caScSyCDwZ',
  },
  {
    Make: 'Selkirk',
    Model: 'Vanguard Control - Invikta',
    Retail: '200.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1YC2YtQ1RJN3jRZffwuAgOENT77yq0zq_/view?usp=sharing',
    'Photo ID': '1YC2YtQ1RJN3jRZffwuAgOENT77yq0zq_',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1YC2YtQ1RJN3jRZffwuAgOENT77yq0zq_',
  },
  {
    Make: 'Selkirk',
    Model: 'Vanguard Control - S2',
    Retail: '200.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1ctJ48LcSBMVscYWHcJt2LFpHc_IZtDxx/view?usp=sharing',
    'Photo ID': '1ctJ48LcSBMVscYWHcJt2LFpHc_IZtDxx',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ctJ48LcSBMVscYWHcJt2LFpHc_IZtDxx',
  },
  {
    Make: 'Selkirk',
    Model: 'Vanguard Power Air - Epic',
    Retail: '200.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1NcJghDKvSQWeFyOM5QY1dDlu7Z-kodlj/view?usp=sharing',
    'Photo ID': '1NcJghDKvSQWeFyOM5QY1dDlu7Z-kodlj',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1NcJghDKvSQWeFyOM5QY1dDlu7Z-kodlj',
  },
  {
    Make: 'Selkirk',
    Model: 'Vanguard Power Air - Invikta',
    Retail: '200.00',
    New: '105.00',
    'Like New': '90.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/1QeMOxcLBPlQyn5217NKN6bYTx-KNGGik/view?usp=sharing',
    'Photo ID': '1QeMOxcLBPlQyn5217NKN6bYTx-KNGGik',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1QeMOxcLBPlQyn5217NKN6bYTx-KNGGik',
  },
  {
    Make: 'Selkirk',
    Model: 'Vanguard Power Air - Invikta Catherine Parenteau',
    Retail: '180.00',
    New: '125.00',
    'Like New': '105.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/16MSAo_t2cWuqn_vDe2e-YsnanNEwkkQi/view?usp=sharing',
    'Photo ID': '16MSAo_t2cWuqn_vDe2e-YsnanNEwkkQi',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=16MSAo_t2cWuqn_vDe2e-YsnanNEwkkQi',
  },
  {
    Make: 'Selkirk',
    Model: 'Vanguard Power Air - S2',
    Retail: '250.00',
    New: '175.00',
    'Like New': '150.00',
    Good: '125.00',
    'Photo URL': 'https://drive.google.com/file/d/18IzQCYrugXVKvc0GoJ-cJHhz44ICaMgL/view?usp=sharing',
    'Photo ID': '18IzQCYrugXVKvc0GoJ-cJHhz44ICaMgL',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=18IzQCYrugXVKvc0GoJ-cJHhz44ICaMgL',
  },
  {
    Make: 'Selkirk',
    Model: 'Vanguard Pro - Epic',
    Retail: '230.00',
    New: '160.00',
    'Like New': '135.00',
    Good: '115.00',
    'Photo URL': 'https://drive.google.com/file/d/1ctGPD58LrgOcECTnJGshrTKpevDBiqIV/view?usp=sharing',
    'Photo ID': '1ctGPD58LrgOcECTnJGshrTKpevDBiqIV',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ctGPD58LrgOcECTnJGshrTKpevDBiqIV',
  },
  {
    Make: 'Selkirk',
    Model: 'Vanguard Pro - Invikta',
    Retail: '230.00',
    New: '160.00',
    'Like New': '135.00',
    Good: '115.00',
    'Photo URL': 'https://drive.google.com/file/d/167g4FZ--fb6JS7X5_ETQqxKj3LmwHFcp/view?usp=sharing',
    'Photo ID': '167g4FZ--fb6JS7X5_ETQqxKj3LmwHFcp',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=167g4FZ--fb6JS7X5_ETQqxKj3LmwHFcp',
  },
  {
    Make: 'Six Zero',
    Model: 'Black Diamond',
    Retail: '180.00',
    New: '125.00',
    'Like New': '105.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1ILTtg7Sh5Pv6-kPAVynz1LyQIKGUl0pG/view?usp=sharing',
    'Photo ID': '1ILTtg7Sh5Pv6-kPAVynz1LyQIKGUl0pG',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ILTtg7Sh5Pv6-kPAVynz1LyQIKGUl0pG',
  },
  {
    Make: 'Six Zero',
    Model: 'Black Diamond Infinity',
    Retail: '220.00',
    New: '150.00',
    'Like New': '130.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1BhjB4eKWZl5ZDbssdRIdTyz5PJojeoo1/view?usp=sharing',
    'Photo ID': '1BhjB4eKWZl5ZDbssdRIdTyz5PJojeoo1',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1BhjB4eKWZl5ZDbssdRIdTyz5PJojeoo1',
  },
  {
    Make: 'Six Zero',
    Model: 'Coral',
    Retail: '200.00',
    New: '140.00',
    'Like New': '120.00',
    Good: '100.00',
    'Photo URL': 'https://drive.google.com/file/d/1Snse_mqLYSdPt-L8KXehmpKCYJgpHgSp/view?usp=drive_link',
    'Photo ID': '1Snse_mqLYSdPt-L8KXehmpKCYJgpHgSp',
    GTIN: '785366699814',
  },
  {
    Make: 'Six Zero',
    Model: 'Double Black Diamond',
    Retail: '180.00',
    New: '125.00',
    'Like New': '105.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1wyhyfkY6OSj9k5QT51Mipoan_KLOUrwR/view?usp=sharing',
    'Photo ID': '1wyhyfkY6OSj9k5QT51Mipoan_KLOUrwR',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1wyhyfkY6OSj9k5QT51Mipoan_KLOUrwR',
  },
  {
    Make: 'Six Zero',
    Model: 'Double Black Diamond Infinity',
    Retail: '220.00',
    New: '150.00',
    'Like New': '130.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1V5Vi2EqxpJ4_B8hGEhX03dnr9Sza_wEy/view?usp=sharing',
    'Photo ID': '1V5Vi2EqxpJ4_B8hGEhX03dnr9Sza_wEy',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1V5Vi2EqxpJ4_B8hGEhX03dnr9Sza_wEy',
  },
  {
    Make: 'Six Zero',
    Model: 'Quartz',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1pctjpNBTM0qkF9nE9mxJxOl2kNcaVSs8/view?usp=sharing',
    'Photo ID': '1pctjpNBTM0qkF9nE9mxJxOl2kNcaVSs8',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1pctjpNBTM0qkF9nE9mxJxOl2kNcaVSs8',
  },
  {
    Make: 'Six Zero',
    Model: 'Ruby',
    Retail: '199.00',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1vaR8DWAJ7BJIzzEdWjSbfh6PX9qpPZ3F/view?usp=sharing',
    'Photo ID': '1vaR8DWAJ7BJIzzEdWjSbfh6PX9qpPZ3F',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1vaR8DWAJ7BJIzzEdWjSbfh6PX9qpPZ3F',
  },
  {
    Make: 'Six Zero',
    Model: 'Ruby Pro',
    Retail: '225.00',
    New: '155.00',
    'Like New': '135.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1Ogig3gYan96GBUgOi1XdXMpfvopfNwcK/view?usp=sharing',
    'Photo ID': '1Ogig3gYan96GBUgOi1XdXMpfvopfNwcK',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Ogig3gYan96GBUgOi1XdXMpfvopfNwcK',
  },
  {
    Make: 'Six Zero',
    Model: 'Sapphire',
    Retail: '86.00',
    New: '60.00',
    'Like New': '50.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1qizVvbqjalwXrlDmhkc_Wh4Aqvzjrn2M/view?usp=sharing',
    'Photo ID': '1qizVvbqjalwXrlDmhkc_Wh4Aqvzjrn2M',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1qizVvbqjalwXrlDmhkc_Wh4Aqvzjrn2M',
  },
  {
    Make: 'Spartus',
    Model: 'Apollo',
    Retail: '129.99',
    New: '90.00',
    'Like New': '75.00',
    Good: '60.00',
    'Photo URL': 'https://drive.google.com/file/d/1pTasgZAzC07qbIf7c0y4IU6RXBixk5vm/view?usp=sharing',
    'Photo ID': '1pTasgZAzC07qbIf7c0y4IU6RXBixk5vm',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1pTasgZAzC07qbIf7c0y4IU6RXBixk5vm',
  },
  {
    Make: 'Spartus',
    Model: 'Ballista',
    Retail: '159.99',
    New: '110.00',
    'Like New': '95.00',
    Good: '75.00',
    'Photo URL': 'https://drive.google.com/file/d/18DQhILWE1OuE3fGYe4H4lmpi7QLsG6EH/view?usp=sharing',
    'Photo ID': '18DQhILWE1OuE3fGYe4H4lmpi7QLsG6EH',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=18DQhILWE1OuE3fGYe4H4lmpi7QLsG6EH',
  },
  {
    Make: 'Spartus',
    Model: 'Gladius',
    Retail: '84.99',
    New: '55.00',
    'Like New': '50.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1bEG3CVSPG-Z8mtAvTZnl6-lPmYLuur5K/view?usp=sharing',
    'Photo ID': '1bEG3CVSPG-Z8mtAvTZnl6-lPmYLuur5K',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1bEG3CVSPG-Z8mtAvTZnl6-lPmYLuur5K',
  },
  {
    Make: 'Spartus',
    Model: 'Gladius Centurion',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/17th6uA-3C_7yih_Rh7WUS8MVCTVJhznr/view?usp=sharing',
    'Photo ID': '17th6uA-3C_7yih_Rh7WUS8MVCTVJhznr',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=17th6uA-3C_7yih_Rh7WUS8MVCTVJhznr',
  },
  {
    Make: 'Spartus',
    Model: 'Olympus',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1DLijebnOc7qtZAV8O7TjWePkNes0oyn6/view?usp=sharing',
    'Photo ID': '1DLijebnOc7qtZAV8O7TjWePkNes0oyn6',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1DLijebnOc7qtZAV8O7TjWePkNes0oyn6',
  },
  {
    Make: 'Spartus',
    Model: 'P1',
    Retail: '219.99',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1o6ulYprBaGkfuWWy-0vu-QHO_IQL6_TL/view?usp=drive_link',
    'Photo ID': '1o6ulYprBaGkfuWWy-0vu-QHO_IQL6_TL',
  },
  {
    Make: 'Thrive',
    Model: 'Azul',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1qul_zhi6Pp4o6DrZSSUfLZUNoJu1u1vW/view?usp=sharing',
    'Photo ID': '1qul_zhi6Pp4o6DrZSSUfLZUNoJu1u1vW',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1qul_zhi6Pp4o6DrZSSUfLZUNoJu1u1vW',
  },
  {
    Make: 'Thrive',
    Model: 'Blackout',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/16Nz_ihPaFERIdwFvbRxZp8cmCZAXVE_S/view?usp=sharing',
    'Photo ID': '16Nz_ihPaFERIdwFvbRxZp8cmCZAXVE_S',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=16Nz_ihPaFERIdwFvbRxZp8cmCZAXVE_S',
  },
  {
    Make: 'Thrive',
    Model: 'Fury',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1VVy7DXXzfEZlqvqcrsZ-l9782FXTYUSF/view?usp=sharing',
    'Photo ID': '1VVy7DXXzfEZlqvqcrsZ-l9782FXTYUSF',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1VVy7DXXzfEZlqvqcrsZ-l9782FXTYUSF',
  },
  {
    Make: 'Thrive',
    Model: 'Rush',
    Retail: '179.99',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1h-D-KS4oKgj1ZSfpqwiYL_NV92UrOwFh/view?usp=sharing',
    'Photo ID': '1h-D-KS4oKgj1ZSfpqwiYL_NV92UrOwFh',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1h-D-KS4oKgj1ZSfpqwiYL_NV92UrOwFh',
  },
  {
    Make: 'Thrive',
    Model: 'Smoke',
    Retail: '219.99',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1-XWhUbmmcRt0eaIW3MiKXEOM8mDHIVaW/view?usp=sharing',
    'Photo ID': '1-XWhUbmmcRt0eaIW3MiKXEOM8mDHIVaW',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1-XWhUbmmcRt0eaIW3MiKXEOM8mDHIVaW',
  },
  {
    Make: 'Thrive',
    Model: 'Surge',
    Retail: '199.99',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1Y448flGDEydqrPm1rGtybKdisdmPQGIt/view?usp=sharing',
    'Photo ID': '1Y448flGDEydqrPm1rGtybKdisdmPQGIt',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Y448flGDEydqrPm1rGtybKdisdmPQGIt',
  },
  {
    Make: 'Thrive',
    Model: 'Threat',
    Retail: '179.99',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1mt6o4mhLTGKr6g82RBOTz_QJYP1PsyWC/view?usp=sharing',
    'Photo ID': '1mt6o4mhLTGKr6g82RBOTz_QJYP1PsyWC',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1mt6o4mhLTGKr6g82RBOTz_QJYP1PsyWC',
  },
  {
    Make: 'Vatic Pro',
    Model: 'Alchemy',
    Retail: '179.99',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1ClLB_1gE9vYGcdWQHmqlL2NY3cUho6Mi/view?usp=sharing',
    'Photo ID': '1ClLB_1gE9vYGcdWQHmqlL2NY3cUho6Mi',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ClLB_1gE9vYGcdWQHmqlL2NY3cUho6Mi',
  },
  {
    Make: 'Vatic Pro',
    Model: 'Flash',
    Retail: '139.99',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/1jh96UH4m4sd2R3MwjKaqSJUw3zEDDhdZ/view?usp=sharing',
    'Photo ID': '1jh96UH4m4sd2R3MwjKaqSJUw3zEDDhdZ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1jh96UH4m4sd2R3MwjKaqSJUw3zEDDhdZ',
  },
  {
    Make: 'Vatic Pro',
    Model: 'Prism Bloom',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1PHtQFLE5uxrZRObLxKpcxWT1r1TOh9el/view?usp=sharing',
    'Photo ID': '1PHtQFLE5uxrZRObLxKpcxWT1r1TOh9el',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1PHtQFLE5uxrZRObLxKpcxWT1r1TOh9el',
  },
  {
    Make: 'Vatic Pro',
    Model: 'Prism Flash',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1YGleD-HzyeRrbv6F9RLdPFR-iJL_2kxF/view?usp=sharing',
    'Photo ID': '1YGleD-HzyeRrbv6F9RLdPFR-iJL_2kxF',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1YGleD-HzyeRrbv6F9RLdPFR-iJL_2kxF',
  },
  {
    Make: 'Vatic Pro',
    Model: 'Prism V7',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1VhbhfJ7lQX82yGzCrQrtSXSRCBgZln92/view?usp=sharing',
    'Photo ID': '1VhbhfJ7lQX82yGzCrQrtSXSRCBgZln92',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1VhbhfJ7lQX82yGzCrQrtSXSRCBgZln92',
  },
  {
    Make: 'Vatic Pro',
    Model: 'Prism V7 - Augie Ge',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1itn4-7-gDgecEtFdu2vrMytEVucj60tn/view?usp=sharing',
    'Photo ID': '1itn4-7-gDgecEtFdu2vrMytEVucj60tn',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1itn4-7-gDgecEtFdu2vrMytEVucj60tn',
  },
  {
    Make: 'Vatic Pro',
    Model: 'V Sol Power',
    Retail: '109.99',
    New: '75.00',
    'Like New': '65.00',
    Good: '50.00',
    'Photo URL': 'https://drive.google.com/file/d/1iZNo5Osmhcn4aVKyvqE8nUHd6myyjJBr/view?usp=sharing',
    'Photo ID': '1iZNo5Osmhcn4aVKyvqE8nUHd6myyjJBr',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1iZNo5Osmhcn4aVKyvqE8nUHd6myyjJBr',
  },
  {
    Make: 'Vatic Pro',
    Model: 'V Sol Pro',
    Retail: '109.99',
    New: '75.00',
    'Like New': '65.00',
    Good: '50.00',
    'Photo URL': 'https://drive.google.com/file/d/1UZ0sAHrXl-DPqzfK-oLZuBl6Can1ofjV/view?usp=sharing',
    'Photo ID': '1UZ0sAHrXl-DPqzfK-oLZuBl6Can1ofjV',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1UZ0sAHrXl-DPqzfK-oLZuBl6Can1ofjV',
  },
  {
    Make: 'Vatic Pro',
    Model: 'V7',
    Retail: '139.99',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/12XzH3jzy2Dd0RCUtKXZf_s5xwpLkuYYA/view?usp=sharing',
    'Photo ID': '12XzH3jzy2Dd0RCUtKXZf_s5xwpLkuYYA',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=12XzH3jzy2Dd0RCUtKXZf_s5xwpLkuYYA',
  },
  {
    Make: 'Veloz',
    Model: 'Ardent',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1AB4oeKyFeFcQkZzuMEnasUNr2W1Czxhb/view?usp=sharing',
    'Photo ID': '1AB4oeKyFeFcQkZzuMEnasUNr2W1Czxhb',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1AB4oeKyFeFcQkZzuMEnasUNr2W1Czxhb',
  },
  {
    Make: 'Veloz',
    Model: 'Ellipse',
    Retail: '239.00',
    New: '165.00',
    'Like New': '140.00',
    Good: '115.00',
    'Photo URL': 'https://drive.google.com/file/d/1HxhaDxMg0gdIK1WH6EqC8hrDydOF-z22/view?usp=sharing',
    'Photo ID': '1HxhaDxMg0gdIK1WH6EqC8hrDydOF-z22',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1HxhaDxMg0gdIK1WH6EqC8hrDydOF-z22',
  },
  {
    Make: 'Veloz',
    Model: 'Quadra',
    Retail: '239.00',
    New: '165.00',
    'Like New': '140.00',
    Good: '115.00',
    'Photo URL': 'https://drive.google.com/file/d/1YjTiI_4weDe27T9zcChud1uZCd-8eH-v/view?usp=sharing',
    'Photo ID': '1YjTiI_4weDe27T9zcChud1uZCd-8eH-v',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1YjTiI_4weDe27T9zcChud1uZCd-8eH-v',
  },
  {
    Make: 'Volair',
    Model: 'Alto',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1nFJuwLg6tixLcZrTTzLm6pSAw0hLBOgR/view?usp=sharing',
    'Photo ID': '1nFJuwLg6tixLcZrTTzLm6pSAw0hLBOgR',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1nFJuwLg6tixLcZrTTzLm6pSAw0hLBOgR',
  },
  {
    Make: 'Volair',
    Model: 'Mach 1',
    Retail: '139.99',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/1oTyIqRHNzQwBhTmJX5D_39WU0e6TKNjx/view?usp=sharing',
    'Photo ID': '1oTyIqRHNzQwBhTmJX5D_39WU0e6TKNjx',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1oTyIqRHNzQwBhTmJX5D_39WU0e6TKNjx',
  },
  {
    Make: 'Volair',
    Model: 'Mach 1 Forza',
    Retail: '179.99',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1VrApUMWCfqUCpvxP4ItTSeOXubWaopzU/view?usp=sharing',
    'Photo ID': '1VrApUMWCfqUCpvxP4ItTSeOXubWaopzU',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1VrApUMWCfqUCpvxP4ItTSeOXubWaopzU',
  },
  {
    Make: 'Volair',
    Model: 'Mach 2',
    Retail: '99.99',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1MCJrN_wO8CDn9RvEqMZPIbH7m7qY4Xq3/view?usp=sharing',
    'Photo ID': '1MCJrN_wO8CDn9RvEqMZPIbH7m7qY4Xq3',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1MCJrN_wO8CDn9RvEqMZPIbH7m7qY4Xq3',
  },
  {
    Make: 'Volair',
    Model: 'Mach 2 Forza',
    Retail: '179.99',
    New: '125.00',
    'Like New': '105.00',
    Good: '85.00',
    'Photo URL': 'https://drive.google.com/file/d/1zcBdiQ4iqtWShrFlz4jkThMS3sbCGoDN/view?usp=sharing',
    'Photo ID': '1zcBdiQ4iqtWShrFlz4jkThMS3sbCGoDN',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1zcBdiQ4iqtWShrFlz4jkThMS3sbCGoDN',
  },
  {
    Make: 'Volair',
    Model: 'Shift',
    Retail: '189.99',
    New: '130.00',
    'Like New': '110.00',
    Good: '90.00',
    'Photo URL': 'https://drive.google.com/file/d/1YXEE8MbX2bcFhwOSGAxr_Q_48_oBBugk/view?usp=drive_link',
    'Photo ID': '1YXEE8MbX2bcFhwOSGAxr_Q_48_oBBugk',
    GTIN: '810179821753',
  },
  {
    Make: 'Vulcan',
    Model: 'Chapter 01 Kyrgios',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1g6MY-eD3PfryVEho-cOlljedlU3c4M93/view?usp=drive_link',
    'Photo ID': '1g6MY-eD3PfryVEho-cOlljedlU3c4M93',
  },
  {
    Make: 'Vulcan',
    Model: 'V300',
    Retail: '49.99',
    New: '30.00',
    'Like New': '25.00',
    Good: '20.00',
    'Photo URL': 'https://drive.google.com/file/d/1CHbJLzIHtXR7pzIjyTwzdcPYWfxepiFt/view?usp=sharing',
    'Photo ID': '1CHbJLzIHtXR7pzIjyTwzdcPYWfxepiFt',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1CHbJLzIHtXR7pzIjyTwzdcPYWfxepiFt',
  },
  {
    Make: 'Vulcan',
    Model: 'V320',
    Retail: '49.99',
    New: '30.00',
    'Like New': '25.00',
    Good: '20.00',
    'Photo URL': 'https://drive.google.com/file/d/1rKHeg9zj7HywVzUQXHCojx-98Go0M4ii/view?usp=sharing',
    'Photo ID': '1rKHeg9zj7HywVzUQXHCojx-98Go0M4ii',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1rKHeg9zj7HywVzUQXHCojx-98Go0M4ii',
  },
  {
    Make: 'Vulcan',
    Model: 'V330',
    Retail: '49.99',
    New: '30.00',
    'Like New': '25.00',
    Good: '20.00',
    'Photo URL': 'https://drive.google.com/file/d/1nC1olsCPAaRaqX1BIXl0lAPzVJjvTNjL/view?usp=sharing',
    'Photo ID': '1nC1olsCPAaRaqX1BIXl0lAPzVJjvTNjL',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1nC1olsCPAaRaqX1BIXl0lAPzVJjvTNjL',
  },
  {
    Make: 'Vulcan',
    Model: 'V350',
    Retail: '89.99',
    New: '60.00',
    'Like New': '50.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/11UfmoQRS1FekCl7wzDjS_thDTXv9DKpk/view?usp=sharing',
    'Photo ID': '11UfmoQRS1FekCl7wzDjS_thDTXv9DKpk',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=11UfmoQRS1FekCl7wzDjS_thDTXv9DKpk',
  },
  {
    Make: 'Vulcan',
    Model: 'V520',
    Retail: '89.99',
    New: '60.00',
    'Like New': '50.00',
    Good: '40.00',
    'Photo URL': 'https://drive.google.com/file/d/1p-XBinCYzXydOry00-gykxOt0U--JyVX/view?usp=sharing',
    'Photo ID': '1p-XBinCYzXydOry00-gykxOt0U--JyVX',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1p-XBinCYzXydOry00-gykxOt0U--JyVX',
  },
  {
    Make: 'Vulcan',
    Model: 'V540',
    Retail: '119.99',
    New: '80.00',
    'Like New': '70.00',
    Good: '55.00',
    'Photo URL': 'https://drive.google.com/file/d/1-rlcHzBfujze_R_paD7pBgYpfbbbHJmo/view?usp=sharing',
    'Photo ID': '1-rlcHzBfujze_R_paD7pBgYpfbbbHJmo',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1-rlcHzBfujze_R_paD7pBgYpfbbbHJmo',
  },
  {
    Make: 'Vulcan',
    Model: 'V550',
    Retail: '139.99',
    New: '95.00',
    'Like New': '80.00',
    Good: '65.00',
    'Photo URL': 'https://drive.google.com/file/d/17H2a5_2efVqXpLYVJI25Xn7uZDEj6Eyx/view?usp=sharing',
    'Photo ID': '17H2a5_2efVqXpLYVJI25Xn7uZDEj6Eyx',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=17H2a5_2efVqXpLYVJI25Xn7uZDEj6Eyx',
  },
  {
    Make: 'Vulcan',
    Model: 'V560',
    Retail: '149.99',
    New: '100.00',
    'Like New': '85.00',
    Good: '70.00',
    'Photo URL': 'https://drive.google.com/file/d/1mlf6j1AvamGY2rL7-kl4ANypbwmsA9G9/view?usp=sharing',
    'Photo ID': '1mlf6j1AvamGY2rL7-kl4ANypbwmsA9G9',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1mlf6j1AvamGY2rL7-kl4ANypbwmsA9G9',
  },
  {
    Make: 'Vulcan',
    Model: 'V710',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1HN_z7adJsqoD2r-9F8CHgrqgLMByl03x/view?usp=sharing',
    'Photo ID': '1HN_z7adJsqoD2r-9F8CHgrqgLMByl03x',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1HN_z7adJsqoD2r-9F8CHgrqgLMByl03x',
  },
  {
    Make: 'Vulcan',
    Model: 'V720',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1RLpjg3RlK9LJbSz1WBBapfYbGJQHdkSm/view?usp=sharing',
    'Photo ID': '1RLpjg3RlK9LJbSz1WBBapfYbGJQHdkSm',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1RLpjg3RlK9LJbSz1WBBapfYbGJQHdkSm',
  },
  {
    Make: 'Vulcan',
    Model: 'V730',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1szzlrtupjcDwlcr3Im8bKsfr9-fQO0MF/view?usp=sharing',
    'Photo ID': '1szzlrtupjcDwlcr3Im8bKsfr9-fQO0MF',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1szzlrtupjcDwlcr3Im8bKsfr9-fQO0MF',
  },
  {
    Make: 'Vulcan',
    Model: 'V740',
    Retail: '249.99',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1yy8npx1z8JN-S6wOF9sV4vKYtnnN1_Hu/view?usp=sharing',
    'Photo ID': '1yy8npx1z8JN-S6wOF9sV4vKYtnnN1_Hu',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1yy8npx1z8JN-S6wOF9sV4vKYtnnN1_Hu',
  },
  {
    Make: 'Vulcan',
    Model: 'V910',
    Retail: '229.99',
    New: '160.00',
    'Like New': '135.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/101GUoN2USz1xXyW_g74C4qyekQZdouaZ/view?usp=sharing',
    'Photo ID': '101GUoN2USz1xXyW_g74C4qyekQZdouaZ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=101GUoN2USz1xXyW_g74C4qyekQZdouaZ',
  },
  {
    Make: 'Vulcan',
    Model: 'V920',
    Retail: '229.99',
    New: '160.00',
    'Like New': '135.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1GWsPkMRg2RpWSBNnycbQyFwJcBQ8rEly/view?usp=sharing',
    'Photo ID': '1GWsPkMRg2RpWSBNnycbQyFwJcBQ8rEly',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1GWsPkMRg2RpWSBNnycbQyFwJcBQ8rEly',
  },
  {
    Make: 'Vulcan',
    Model: 'V930',
    Retail: '229.99',
    New: '160.00',
    'Like New': '135.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/1iOtgFowZH61RULcY57gx4_mbWAyrzykp/view?usp=sharing',
    'Photo ID': '1iOtgFowZH61RULcY57gx4_mbWAyrzykp',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1iOtgFowZH61RULcY57gx4_mbWAyrzykp',
  },
  {
    Make: 'Vulcan',
    Model: 'V940',
    Retail: '229.99',
    New: '160.00',
    'Like New': '135.00',
    Good: '110.00',
    'Photo URL': 'https://drive.google.com/file/d/18BVfuBhEPUC_vM9kDwKQPnM8bnpIAyeg/view?usp=sharing',
    'Photo ID': '18BVfuBhEPUC_vM9kDwKQPnM8bnpIAyeg',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=18BVfuBhEPUC_vM9kDwKQPnM8bnpIAyeg',
  },
  {
    Make: 'Wild Monkeys',
    Model: 'Alpha',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1sL2YXJfiQZ74aJrAVFrdd_ncaerwAFVS/view?usp=sharing',
    'Photo ID': '1sL2YXJfiQZ74aJrAVFrdd_ncaerwAFVS',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1sL2YXJfiQZ74aJrAVFrdd_ncaerwAFVS',
  },
  {
    Make: 'Wild Monkeys',
    Model: 'Arachne',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1JqqFxc7vBQdKHguWDPl_PZTs2inzHGY0/view?usp=sharing',
    'Photo ID': '1JqqFxc7vBQdKHguWDPl_PZTs2inzHGY0',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1JqqFxc7vBQdKHguWDPl_PZTs2inzHGY0',
  },
  {
    Make: 'Wild Monkeys',
    Model: 'Caesar 3K',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1bs84NBSzs6LIi9OHvB4P-1eZE0KdYy7L/view?usp=sharing',
    'Photo ID': '1bs84NBSzs6LIi9OHvB4P-1eZE0KdYy7L',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1bs84NBSzs6LIi9OHvB4P-1eZE0KdYy7L',
  },
  {
    Make: 'Wild Monkeys',
    Model: 'Caesar Ghost',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/18U_6VAblsHI8N4C_d53k-8Cq4sBseY7r/view?usp=sharing',
    'Photo ID': '18U_6VAblsHI8N4C_d53k-8Cq4sBseY7r',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=18U_6VAblsHI8N4C_d53k-8Cq4sBseY7r',
  },
  {
    Make: 'Wild Monkeys',
    Model: 'Falcon',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1vGuf0miD4w4PRg2III5Fd9MZDFqjnJzu/view?usp=sharing',
    'Photo ID': '1vGuf0miD4w4PRg2III5Fd9MZDFqjnJzu',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1vGuf0miD4w4PRg2III5Fd9MZDFqjnJzu',
  },
  {
    Make: 'Wild Monkeys',
    Model: 'Grizzly',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1nCYkTUodOG86GnPDpkmrVD_gfHA9jOiw/view?usp=sharing',
    'Photo ID': '1nCYkTUodOG86GnPDpkmrVD_gfHA9jOiw',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1nCYkTUodOG86GnPDpkmrVD_gfHA9jOiw',
  },
  {
    Make: 'Wild Monkeys',
    Model: 'Grizzly 3K',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1tgdbCw2lXRdy_4Gbmdm0LdfNtXRz1BTP/view?usp=sharing',
    'Photo ID': '1tgdbCw2lXRdy_4Gbmdm0LdfNtXRz1BTP',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1tgdbCw2lXRdy_4Gbmdm0LdfNtXRz1BTP',
  },
  {
    Make: 'Wild Monkeys',
    Model: 'Grizzly Ghost',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1ypOz7MohvsW94wsArwVwGGq1QKYizooC/view?usp=sharing',
    'Photo ID': '1ypOz7MohvsW94wsArwVwGGq1QKYizooC',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ypOz7MohvsW94wsArwVwGGq1QKYizooC',
  },
  {
    Make: 'Wild Monkeys',
    Model: 'Nightshade',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1WvhC0wwWMePEMsT4I9vFrlc0NVOMKhtd/view?usp=sharing',
    'Photo ID': '1WvhC0wwWMePEMsT4I9vFrlc0NVOMKhtd',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1WvhC0wwWMePEMsT4I9vFrlc0NVOMKhtd',
  },
  {
    Make: 'Wild Monkeys',
    Model: 'Pit Viper 3K',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/16N_MY4Tvhq4iBsw1jqce8Wqu1Dwwt-Bb/view?usp=sharing',
    'Photo ID': '16N_MY4Tvhq4iBsw1jqce8Wqu1Dwwt-Bb',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=16N_MY4Tvhq4iBsw1jqce8Wqu1Dwwt-Bb',
  },
  {
    Make: 'Wild Monkeys',
    Model: 'Pit Viper Ghost',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1EXzpe_PAmaWdh_bbjDfr6VCqV_xelYno/view?usp=sharing',
    'Photo ID': '1EXzpe_PAmaWdh_bbjDfr6VCqV_xelYno',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1EXzpe_PAmaWdh_bbjDfr6VCqV_xelYno',
  },
  {
    Make: 'Wild Monkeys',
    Model: 'Prima 3K',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1YJ9ntRkNeSo_M3POdIke6WVrmPWJc3vc/view?usp=sharing',
    'Photo ID': '1YJ9ntRkNeSo_M3POdIke6WVrmPWJc3vc',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1YJ9ntRkNeSo_M3POdIke6WVrmPWJc3vc',
  },
  {
    Make: 'Wild Monkeys',
    Model: 'Prima Ghost',
    Retail: '99.00',
    New: '65.00',
    'Like New': '55.00',
    Good: '45.00',
    'Photo URL': 'https://drive.google.com/file/d/1Jv5JOCUTIs0zHTxTiQ7jznY9NkeYJ4Ty/view?usp=sharing',
    'Photo ID': '1Jv5JOCUTIs0zHTxTiQ7jznY9NkeYJ4Ty',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Jv5JOCUTIs0zHTxTiQ7jznY9NkeYJ4Ty',
  },
  {
    Make: 'Wilson',
    Model: 'Blaze 13',
    Retail: '169.00',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/1uL3FbnIRt36VomrSlt_t1xeCZrk1p1S4/view?usp=sharing',
    'Photo ID': '1uL3FbnIRt36VomrSlt_t1xeCZrk1p1S4',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1uL3FbnIRt36VomrSlt_t1xeCZrk1p1S4',
  },
  {
    Make: 'Wilson',
    Model: 'Blaze Edgeless 13',
    Retail: '219.00',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/10YWX0v-623t282uuXjb7CYInln2Vi5ok/view?usp=sharing',
    'Photo ID': '10YWX0v-623t282uuXjb7CYInln2Vi5ok',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=10YWX0v-623t282uuXjb7CYInln2Vi5ok',
  },
  {
    Make: 'Wilson',
    Model: 'Blaze Pro 13',
    Retail: '199.00',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1o5WETovmrOAhVbEopmnL0oN7k0vo_7vw/view?usp=sharing',
    'Photo ID': '1o5WETovmrOAhVbEopmnL0oN7k0vo_7vw',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1o5WETovmrOAhVbEopmnL0oN7k0vo_7vw',
  },
  {
    Make: 'Wilson',
    Model: 'Blaze Tour 16',
    Retail: '219.00',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1Xi8u95sBJgLmXLrerc5jKNfx8kuQnwRw/view?usp=sharing',
    'Photo ID': '1Xi8u95sBJgLmXLrerc5jKNfx8kuQnwRw',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1Xi8u95sBJgLmXLrerc5jKNfx8kuQnwRw',
  },
  {
    Make: 'Wilson',
    Model: 'Cadence 16',
    Retail: '169.00',
    New: '115.00',
    'Like New': '100.00',
    Good: '80.00',
    'Photo URL': 'https://drive.google.com/file/d/18YvDayffAF4URSsUIrrhmT0xbmg07KcW/view?usp=sharing',
    'Photo ID': '18YvDayffAF4URSsUIrrhmT0xbmg07KcW',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=18YvDayffAF4URSsUIrrhmT0xbmg07KcW',
  },
  {
    Make: 'Wilson',
    Model: 'Cadence Edgeless 16',
    Retail: '219.00',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1ogAxL70NhamjEvl6MT-s13OT9cLUJB3H/view?usp=sharing',
    'Photo ID': '1ogAxL70NhamjEvl6MT-s13OT9cLUJB3H',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ogAxL70NhamjEvl6MT-s13OT9cLUJB3H',
  },
  {
    Make: 'Wilson',
    Model: 'Cadence Pro 16',
    Retail: '199.00',
    New: '135.00',
    'Like New': '115.00',
    Good: '95.00',
    'Photo URL': 'https://drive.google.com/file/d/1DgpUW5yEl8BuCuzPoD7oJLtXd8NWR-BQ/view?usp=sharing',
    'Photo ID': '1DgpUW5yEl8BuCuzPoD7oJLtXd8NWR-BQ',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1DgpUW5yEl8BuCuzPoD7oJLtXd8NWR-BQ',
  },
  {
    Make: 'Wilson',
    Model: 'Cadence Tour 12',
    Retail: '219.00',
    New: '150.00',
    'Like New': '130.00',
    Good: '105.00',
    'Photo URL': 'https://drive.google.com/file/d/1RhKEurR10NF6nMttyiYFEu0od5VJ56Po/view?usp=sharing',
    'Photo ID': '1RhKEurR10NF6nMttyiYFEu0od5VJ56Po',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1RhKEurR10NF6nMttyiYFEu0od5VJ56Po',
  },
  {
    Make: 'Wilson',
    Model: 'Fierce',
    Retail: '109.00',
    New: '75.00',
    'Like New': '65.00',
    Good: '50.00',
    'Photo URL': 'https://drive.google.com/file/d/1ZkXwMrekHO7ifDUBjIQCxid-ey3lw-S-/view?usp=sharing',
    'Photo ID': '1ZkXwMrekHO7ifDUBjIQCxid-ey3lw-S-',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1ZkXwMrekHO7ifDUBjIQCxid-ey3lw-S-',
  },
  {
    Make: 'Wilson',
    Model: 'Vesper Control 17',
    Retail: '249.00',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1U9O_LeVyk9tPKZdp-KCCjun47KWOBzkK/view?usp=sharing',
    'Photo ID': '1U9O_LeVyk9tPKZdp-KCCjun47KWOBzkK',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1U9O_LeVyk9tPKZdp-KCCjun47KWOBzkK',
  },
  {
    Make: 'Wilson',
    Model: 'Vesper Power 14',
    Retail: '249.00',
    New: '170.00',
    'Like New': '145.00',
    Good: '120.00',
    'Photo URL': 'https://drive.google.com/file/d/1BmJfu51idN5M_ecqlLv4cVTx0YuTStBt/view?usp=sharing',
    'Photo ID': '1BmJfu51idN5M_ecqlLv4cVTx0YuTStBt',
    'Converted Url': 'https://drive.google.com/uc?export=view&id=1BmJfu51idN5M_ecqlLv4cVTx0YuTStBt',
  },
];

export const getPaddleMakes = _.memoize(() => {
  return _.sortedUniq(_.map(configPaddleGenius, 'Make'));
});

export const getPaddleModels = _.memoize(make => {
  return _.sortedUniq(_.map(_.filter(configPaddleGenius, { Make: make }), 'Model'));
});

export const getPaddle = _.memoize(
  (make, model) => {
    return _.find(configPaddleGenius, { Make: make, Model: model });
  },
  (make, model) => `${make}/${model}`
);

export const resolvePaddleFromListingData = (publicData = {}, listingCategories = []) => {
  const { categoryLevel1, categoryLevel2, paddle_make, paddle_model } = publicData || {};

  const makeDetails = listingCategories.find(e => e.id == categoryLevel1) || {};
  const modelDetails = makeDetails?.subcategories?.find(e => e.id == categoryLevel2) || {};

  const make = paddle_make || makeDetails?.name;
  const model = paddle_model || modelDetails?.name;

  return make && model ? getPaddle(make, model) : null;
};
